{
  "openapi": "3.0.4",
  "info": {
    "title": "g2fp.AppWeb",
    "version": "1.0"
  },
  "paths": {
    "/apptwo/account/login": {
      "get": {
        "tags": [
          "Account"
        ],
        "operationId": "Login",
        "parameters": [
          {
            "name": "return_url",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "domain_hint",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "login_hint",
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "302": {
            "description": "Found"
          }
        }
      }
    },
    "/apptwo/account/logout": {
      "get": {
        "tags": [
          "Account"
        ],
        "operationId": "Logout",
        "responses": {
          "302": {
            "description": "Found"
          }
        }
      }
    },
    "/apptwo/account/me": {
      "get": {
        "tags": [
          "Account"
        ],
        "operationId": "GetCurrentUserDetail",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Account.GetUserDetail.UserDetailDto"
                }
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          },
          "401": {
            "description": "Unauthorized",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/account/register": {
      "post": {
        "tags": [
          "Account"
        ],
        "operationId": "Register",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Account.CreateUser.CreateUserRequest"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Account.CreateUser.CreateUserRequest"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Account.CreateUser.CreateUserRequest"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/account/confirmation/resend-email": {
      "post": {
        "tags": [
          "Account"
        ],
        "operationId": "ResendConfirmEmail",
        "parameters": [
          {
            "name": "userId",
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/account/confirmation": {
      "get": {
        "tags": [
          "Account"
        ],
        "operationId": "ConfirmEmail",
        "parameters": [
          {
            "name": "userId",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "code",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "verification",
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/account/password/update": {
      "post": {
        "tags": [
          "Account"
        ],
        "operationId": "ResetPassword",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Account.ResetUserPassword.ResetUserPasswordRequest"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Account.ResetUserPassword.ResetUserPasswordRequest"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Account.ResetUserPassword.ResetUserPasswordRequest"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/account/password/send-forgot-email": {
      "post": {
        "tags": [
          "Account"
        ],
        "operationId": "ForgotPassword",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Account.ResetUserPassword.SendPasswordResetEmailRequest"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Account.ResetUserPassword.SendPasswordResetEmailRequest"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Account.ResetUserPassword.SendPasswordResetEmailRequest"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/account/impersonation/start": {
      "post": {
        "tags": [
          "Account"
        ],
        "operationId": "StartUserImpersonation",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Account.UserImpersonation.StartUserImpersonationRequest"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Account.UserImpersonation.StartUserImpersonationRequest"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Account.UserImpersonation.StartUserImpersonationRequest"
              }
            }
          }
        },
        "responses": {
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          },
          "401": {
            "description": "Unauthorized",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          },
          "498": {
            "description": "Client Error",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/account/impersonation/stop": {
      "post": {
        "tags": [
          "Account"
        ],
        "operationId": "StopUserImpersonation",
        "responses": {
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          },
          "401": {
            "description": "Unauthorized",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          },
          "498": {
            "description": "Client Error",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/account/function/switch": {
      "post": {
        "tags": [
          "Account"
        ],
        "operationId": "SwitchFunction",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Account.SwitchFunction.SwitchFunctionRequest"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Account.SwitchFunction.SwitchFunctionRequest"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Account.SwitchFunction.SwitchFunctionRequest"
              }
            }
          }
        },
        "responses": {
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          },
          "401": {
            "description": "Unauthorized",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          },
          "404": {
            "description": "Not Found",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          },
          "498": {
            "description": "Client Error",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          }
        }
      }
    },
    "/MicrosoftIdentity/Account/SignIn/{scheme}": {
      "get": {
        "tags": [
          "Account"
        ],
        "parameters": [
          {
            "name": "scheme",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "redirectUri",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "loginHint",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "domainHint",
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/MicrosoftIdentity/Account/Challenge/{scheme}": {
      "get": {
        "tags": [
          "Account"
        ],
        "parameters": [
          {
            "name": "redirectUri",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "scope",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "loginHint",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "domainHint",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "claims",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "policy",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "scheme",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/MicrosoftIdentity/Account/SignOut/{scheme}": {
      "get": {
        "tags": [
          "Account"
        ],
        "parameters": [
          {
            "name": "scheme",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/MicrosoftIdentity/Account/ResetPassword/{scheme}": {
      "get": {
        "tags": [
          "Account"
        ],
        "parameters": [
          {
            "name": "scheme",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/MicrosoftIdentity/Account/EditProfile/{scheme}": {
      "get": {
        "tags": [
          "Account"
        ],
        "parameters": [
          {
            "name": "scheme",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/antiforgery/token": {
      "get": {
        "tags": [
          "Antiforgery"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/communication/contact-us": {
      "post": {
        "tags": [
          "Communication"
        ],
        "operationId": "ContactUs",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Communication.ContactUs"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Communication.ContactUs"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Communication.ContactUs"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/communication/public-contact-us": {
      "post": {
        "tags": [
          "Communication"
        ],
        "operationId": "PublicContactUs",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Communication.ExtendedContactUs"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Communication.ExtendedContactUs"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Communication.ExtendedContactUs"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/company/companybyid": {
      "get": {
        "tags": [
          "Company"
        ],
        "operationId": "CompanyById",
        "parameters": [
          {
            "name": "id",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          },
          {
            "name": "includeRelation",
            "in": "query",
            "schema": {
              "type": "boolean",
              "default": false
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/dashboard/user": {
      "get": {
        "tags": [
          "Dashboard"
        ],
        "operationId": "GetUserDashboard",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.Dashboard.UserDashboardDto"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/dashboard/productdetails/{isin}": {
      "get": {
        "tags": [
          "Dashboard"
        ],
        "operationId": "GetProductDetailsDashboard",
        "parameters": [
          {
            "name": "isin",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.ProductVm"
                }
              }
            }
          }
        }
      }
    },
    "/print-debug": {
      "get": {
        "tags": [
          "Debug"
        ],
        "operationId": "ShowDebug",
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/print-debug-post": {
      "post": {
        "tags": [
          "Debug"
        ],
        "operationId": "ShowDebugPost",
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/dump": {
      "post": {
        "tags": [
          "Debug"
        ],
        "operationId": "Dump",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "type": "string"
              }
            },
            "text/json": {
              "schema": {
                "type": "string"
              }
            },
            "application/*+json": {
              "schema": {
                "type": "string"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/feature-flags": {
      "get": {
        "tags": [
          "FeatureFlag"
        ],
        "operationId": "GetFeatureFlags",
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/initiated": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetFlowsForUser",
        "parameters": [
          {
            "name": "dataRange",
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.SelectedDataRangeEnum"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/contributed": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetContributedFlowsForUser",
        "parameters": [
          {
            "name": "Offset",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          },
          {
            "name": "Limit",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          },
          {
            "name": "TextQuery",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "DataRange",
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.SelectedDataRangeEnum"
            }
          },
          {
            "name": "ScopeName",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "Status",
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.WorkflowCoreShadowDto.WorkflowStatusEnum"
            }
          },
          {
            "name": "WorkflowDefinitionId",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "HasActivity",
            "in": "query",
            "schema": {
              "type": "boolean"
            }
          },
          {
            "name": "SortField",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "PayingAgent",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          },
          {
            "name": "PaymentTypes",
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.PaymentFlowTypeEnum"
              }
            }
          },
          {
            "name": "Currency",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "SortOrder",
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.WorkflowPagingAndFilteringDto+SortingOrder"
            }
          },
          {
            "name": "Versions",
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "type": "integer",
                "format": "int32"
              }
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.FlowOverviewVm"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/flow/batchpaymentflow/initiate": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "InitiateBatchPaymentFlow",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.BatchPayment.BatchPaymentFlowDto+InitiateBatchPaymentFlowWfCoreDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.BatchPayment.BatchPaymentFlowDto+InitiateBatchPaymentFlowWfCoreDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.BatchPayment.BatchPaymentFlowDto+InitiateBatchPaymentFlowWfCoreDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/batchpaymentflow/all": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetBatchPaymentFlows",
        "parameters": [
          {
            "name": "Offset",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          },
          {
            "name": "Limit",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          },
          {
            "name": "TextQuery",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "DataRange",
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.SelectedDataRangeEnum"
            }
          },
          {
            "name": "ScopeName",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "Status",
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.WorkflowCoreShadowDto.WorkflowStatusEnum"
            }
          },
          {
            "name": "WorkflowDefinitionId",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "HasActivity",
            "in": "query",
            "schema": {
              "type": "boolean"
            }
          },
          {
            "name": "SortField",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "PayingAgent",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          },
          {
            "name": "PaymentTypes",
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.PaymentFlowTypeEnum"
              }
            }
          },
          {
            "name": "Currency",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "SortOrder",
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.WorkflowPagingAndFilteringDto+SortingOrder"
            }
          },
          {
            "name": "Versions",
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "type": "integer",
                "format": "int32"
              }
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.FlowOverviewVm"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/flow/workflowsbyids": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetFlowsByIds",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "type": "array",
                "items": {
                  "type": "string"
                }
              }
            },
            "text/json": {
              "schema": {
                "type": "array",
                "items": {
                  "type": "string"
                }
              }
            },
            "application/*+json": {
              "schema": {
                "type": "array",
                "items": {
                  "type": "string"
                }
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.FlowOverviewVm"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/flow/vm/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetFlowVmByIdPosApi",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.FlowVm"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/flow/overview": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetWorkflowOverview",
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/productissuanceisinavailableflowvm": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetProductIssuanceIsinAvailableFlowVm",
        "parameters": [
          {
            "name": "cloneId",
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/primarybookingrequestflowvm": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetBlankPrimaryBookingRequestFlowVm",
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/primarybookingrequestflowvm/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetExistingPrimaryBookingRequestFlowVm",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/primarybookingrequestflowclonevm/{cloneId}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetPrimaryBookingRequestCloneFlowVm",
        "parameters": [
          {
            "name": "cloneId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/ispsecondarychangeflowvm": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetIspSecondaryChangeFlowVm",
        "parameters": [
          {
            "name": "id",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          },
          {
            "name": "cloneId",
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/ispsecondarychangeflowvm/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetIspSecondaryChangeFlowVmFromTemplate",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          },
          {
            "name": "cloneId",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/ispsecondarychangeflowclonevm/{cloneId}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetIspSecondaryChangeFlowCloneVm",
        "parameters": [
          {
            "name": "cloneId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/productissuanceisinavailableflow": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "InitiateProductIssuanceIsinAvailableFlow",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductIssuanceFlowVm"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductIssuanceFlowVm"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductIssuanceFlowVm"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/primarybookingrequestflow": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "InitiatePrimaryBookingRequestFlow",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.PrimaryBookingRequestFlowVm"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.PrimaryBookingRequestFlowVm"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.PrimaryBookingRequestFlowVm"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/ispsecondarychangeflow": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "InitiateIspSecondaryChangeFlow",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IspSecondaryChangeFlowVm"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IspSecondaryChangeFlowVm"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IspSecondaryChangeFlowVm"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/workflowvm/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetWorkflowVmById",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.WorkflowVm"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/flow/approvalvm/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetApprovalVmById",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/approvalvm": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "PostApprovalVm",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ApprovalVm"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ApprovalVm"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ApprovalVm"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/priceentryvm/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetPriceEntryVm",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/priceentryvm": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "PostPriceEntryVm",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.PriceEntryVm"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.PriceEntryVm"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.PriceEntryVm"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/isppriceentryvm/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetIspPriceEntryVm",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/isppriceentryvm": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "PostIspPriceEntryVm",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IspPriceEntryVm"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IspPriceEntryVm"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IspPriceEntryVm"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/uploadfile": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "UploadFile",
        "requestBody": {
          "content": {
            "multipart/form-data": {
              "schema": {
                "type": "object",
                "properties": {
                  "file": {
                    "type": "string",
                    "format": "binary"
                  },
                  "guid": {
                    "type": "string"
                  },
                  "fileType": {
                    "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Documents.StoredDocumentType+Ids"
                  },
                  "flowId": {
                    "type": "string"
                  }
                }
              },
              "encoding": {
                "file": {
                  "style": "form"
                },
                "guid": {
                  "style": "form"
                },
                "fileType": {
                  "style": "form"
                },
                "flowId": {
                  "style": "form"
                }
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/fileinfo/{fileGuid}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetFileInfo",
        "parameters": [
          {
            "name": "fileGuid",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/downloadfile/{fileGuid}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "DownloadFile",
        "parameters": [
          {
            "name": "fileGuid",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/flowstate": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetFlowStateData",
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/quarterliesapprovalvm/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetQuarterliesApprovalVm",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/quarterliesapprovalvm": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "PostQuarterliesApprovalVm",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.QuarterliesApprovalVm"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.QuarterliesApprovalVm"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.QuarterliesApprovalVm"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/terminateflow": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "TerminateWorkflow",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.TerminateWorkflowRequestDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.TerminateWorkflowRequestDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.TerminateWorkflowRequestDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/reassignflow": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "ReassignWorkflow",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.ReassignFlowDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.ReassignFlowDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.ReassignFlowDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/all-workflow-products": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetAllWorkflowProducts",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.AppWeb.Models.Flow.FlowProductListItemVm"
                  }
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/flow/searchproduct/{term}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "SearchProduct",
        "parameters": [
          {
            "name": "term",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/ispcashaccountamount/{isin}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetIspCashAccountAmount",
        "parameters": [
          {
            "name": "isin",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/paymentflowaccountsdata/{isin}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetPaymentFlowAccountsData",
        "parameters": [
          {
            "name": "isin",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/paymentflowtypes/{isin}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetPaymentFlowTypes",
        "parameters": [
          {
            "name": "isin",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/paymentdirectorapprovalvm/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetPaymentDirectorApprovalVm",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/paymentalbecqapprovalvm/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetPaymentAlbecqApprovalVm",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/paymentdirectorapprovalvm": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "PostPaymentDirectorApprovalVm",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.PaymentDirectorApprovalVm"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.PaymentDirectorApprovalVm"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.PaymentDirectorApprovalVm"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/paymentalbecqapprovalvm": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "PostPaymentAlbecqApprovalVm",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.PaymentDirectorApprovalVm"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.PaymentDirectorApprovalVm"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.PaymentDirectorApprovalVm"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/downloaddocument/{document}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "DownloadDocumentOfType",
        "parameters": [
          {
            "name": "document",
            "in": "path",
            "required": true,
            "schema": {
              "$ref": "#/components/schemas/g2fp.Models.Dropbox.AppTwoDocumentEnum"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/downloadtermsdocument/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "DownloadTermsDocumentById",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/listpublicdocuments": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "ListPublicDocuments",
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/product": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetWorkflowsByProductIsin",
        "parameters": [
          {
            "name": "isin",
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/orderacceptancecreatevm": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetOrderAcceptanceCreateVm",
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/orderacceptancecreate": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "InitiateOrderAcceptanceCreate",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.OrderAcceptanceCreateVm"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.OrderAcceptanceCreateVm"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.OrderAcceptanceCreateVm"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/orderacceptancearchive/{id}": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "ArchiveOrderAcceptance",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/orderacceptanceeditvm/am/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetOrderAcceptanceEditAmVm",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/orderacceptanceeditvm/payingagent/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetOrderAcceptanceEditPayingAgentVm",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/orderacceptanceordercreate": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "CreateOrderAcceptanceOrder",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.G2DbModels.OrderAcceptanceOrder"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.G2DbModels.OrderAcceptanceOrder"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.G2DbModels.OrderAcceptanceOrder"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/sendremindermessage": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "SendReminderMessage",
        "parameters": [
          {
            "name": "templateId",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/orderacceptanceorderdelete": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "DeleteOrderAcceptance",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.G2DbModels.OrderAcceptanceOrder"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.G2DbModels.OrderAcceptanceOrder"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.G2DbModels.OrderAcceptanceOrder"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/orderacceptancetemplate/{id}": {
      "put": {
        "tags": [
          "Flow"
        ],
        "operationId": "UpdateOrderAcceptanceTemplate",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.G2DbModels.OrderAcceptanceTemplate"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.G2DbModels.OrderAcceptanceTemplate"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.G2DbModels.OrderAcceptanceTemplate"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/orderacceptanceprocessorder": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "ProcessOrderAcceptance",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.G2DbModels.OrderAcceptanceOrder"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.G2DbModels.OrderAcceptanceOrder"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.G2DbModels.OrderAcceptanceOrder"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/telekursvm/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetTelekursVm",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/additionalproductdata/{isin}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetAdditionalProductDataForIsin",
        "parameters": [
          {
            "name": "isin",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/issuersubrelationapprovalvm/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetIssuerSubrelationApprovalVm",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/issuersubrelationapprovalvm": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "ProcessIssuerSubrelationApprovalVm",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IssuanceSubrelationIssuerApprovalVm"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IssuanceSubrelationIssuerApprovalVm"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IssuanceSubrelationIssuerApprovalVm"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/telekursvm": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "PostTelekursVm",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.TelekursVm"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.TelekursVm"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.TelekursVm"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/issuanceproductsponsorapprovalvm/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetIssuanceProductSponsorApprovalVm",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/issuanceproductsponsorapprovalvm": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "PostIssuanceProductSponsorApprovalVm",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ApprovalVm"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ApprovalVm"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ApprovalVm"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/issuanceissuerapprovalvm/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetIssuanceIssuerApprovalVm",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/issuanceissuerapprovalvm": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "PostIssuanceIssuerApprovalVm",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IssuanceIssuerApprovalVm"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IssuanceIssuerApprovalVm"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IssuanceIssuerApprovalVm"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/issuancedistributorapprovalvm/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetIssuanceDistributorApprovalVm",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/issuancedistributorapprovalvm": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "PostIssuanceDistributorApprovalVm",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IssuanceDistributorApprovalVm"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IssuanceDistributorApprovalVm"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IssuanceDistributorApprovalVm"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/issuanceproductmanagerapprovalvm/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetIssuanceProductManagerApprovalVm",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/issuanceproductmanagerapprovalvm": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "PostIssuanceProductManagerApprovalVm",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IssuanceProductManagerApprovalVm"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IssuanceProductManagerApprovalVm"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IssuanceProductManagerApprovalVm"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/issuanceplatformownerapprovalvm/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetIssuancePlatformOwnerApprovalVm",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/issuanceplatformownerapprovalvm": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "PostIssuancePlatformOwnerApprovalVm",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ApprovalVm"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ApprovalVm"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ApprovalVm"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/issuancepayingagentapprovalvm/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetIssuancePayingAgentApprovalVm",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/issuancepayingagentapprovalvm": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "PostIssuancePayingAgentApprovalVm",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IssuancePayingAgentApprovalVm"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IssuancePayingAgentApprovalVm"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IssuancePayingAgentApprovalVm"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/issuanceg2approvalvm/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetIssuanceG2ApprovalApprovalVm",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/issuanceg2approvalvm": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "PostIssuanceG2ApprovalVm",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IssuanceG2ApprovalVm"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IssuanceG2ApprovalVm"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.IssuanceG2ApprovalVm"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/orderacceptancetemplates": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetOrderAcceptanceTemplates",
        "parameters": [
          {
            "name": "dataRange",
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.SelectedDataRangeEnum"
            }
          },
          {
            "name": "isArchived",
            "in": "query",
            "schema": {
              "type": "boolean"
            }
          },
          {
            "name": "includeAllTemplates",
            "in": "query",
            "schema": {
              "type": "boolean"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.OrderAcceptanceTemplateOverviewVm"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/flow/sendworkflowremindernotification": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "SendWorkflowReminderNotification",
        "parameters": [
          {
            "name": "workflowId",
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/getissuertypes": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetIssuerTypes",
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/downloadsmallinvoicepdf/{smallInvoiceId}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "DownloadSmallInvoicePdf",
        "parameters": [
          {
            "name": "smallInvoiceId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/downloadinternalinvoicepdf/{internalInvoiceId}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "DownloadInternalInvoicePdf",
        "parameters": [
          {
            "name": "internalInvoiceId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/assetdataupdatevm": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetAssetDataUpdateFlowVm",
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      },
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "InititateAssetDataUpdate",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.AssetDataUpdateFlowDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.AssetDataUpdateFlowDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.AssetDataUpdateFlowDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/productunderlyings/{productId}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetProductUnderlyings",
        "parameters": [
          {
            "name": "productId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/approvalflowvm": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetApprovalFlowVm",
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/entityapprovalflowvm": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetEntityApprovalFlowVm",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.EntityApprovalFlowVm"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/flow/couponflowvm": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetCouponFlowVm",
        "parameters": [
          {
            "name": "productEventId",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.CouponFlowVm"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/flow/productterminationvm": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetProductTerminationFlowVm",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.ProductTerminationFlow.ProductTerminationFlowDto"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/flow/partialredemptioneventvm": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetPartialRedemptionEventFlowVm",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.PartialRedemptionEventFlowV2Dto"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/flow/productapprovalprocess": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetProductApprovalProcessFlowVm",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.ProductApprovalProcessFlowDto"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/flow/g24bproductopeningflowvm": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetG24BProductOpeningFlowVm",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.G24BProductOpeningFlowDto"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/flow/payingAgentAccountopening": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "PayingAgentAccountOpeningFlowDto",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.PayingAgentAccountOpeningFlowDto"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/flow/g24bproductopeningflow/initiate": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "InitiateG24BProductOpeningFlow",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.G24BProductOpeningFlowDto+InitiateG24BProductOpeningDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.G24BProductOpeningFlowDto+InitiateG24BProductOpeningDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.G24BProductOpeningFlowDto+InitiateG24BProductOpeningDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/approvalflow/initiate": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "InititateApprovalFlow",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.ApprovalFlowDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.ApprovalFlowDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.ApprovalFlowDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/approvalprocess/initiate": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "InitiateProductApprovalProcess",
        "parameters": [
          {
            "name": "version",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32",
              "default": 1
            }
          }
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.InitiateProductApprovalProcessFlowEventDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.InitiateProductApprovalProcessFlowEventDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.InitiateProductApprovalProcessFlowEventDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/entityapprovalflow/initiate": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "InitiateEntityApprovalFlow",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.EntityApprovalFlow.InitiateEntityApprovalFlowEventDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.EntityApprovalFlow.InitiateEntityApprovalFlowEventDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.EntityApprovalFlow.InitiateEntityApprovalFlowEventDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/couponflow/initiate": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "InititateCouponFlow",
        "parameters": [
          {
            "name": "version",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32",
              "default": 4
            }
          }
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.CouponFlowDto+InitiateCouponFlowDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.CouponFlowDto+InitiateCouponFlowDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.CouponFlowDto+InitiateCouponFlowDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/payingAgentAccountopening/initiate/{isin}": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "InitiatePayingAgentAccountOpeningFlow",
        "parameters": [
          {
            "name": "isin",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "assignAllToInitiator",
            "in": "query",
            "schema": {
              "type": "boolean"
            }
          },
          {
            "name": "withProduct",
            "in": "query",
            "schema": {
              "type": "boolean"
            }
          },
          {
            "name": "withBrokerCustodian",
            "in": "query",
            "schema": {
              "type": "boolean"
            }
          },
          {
            "name": "version",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32",
              "default": 2
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/productterminationfo/initiate": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "InitiateProductTerminationFlow",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.ProductTerminationFlow.InitiateProductTerminationFlowDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.ProductTerminationFlow.InitiateProductTerminationFlowDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.ProductTerminationFlow.InitiateProductTerminationFlowDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/partialredemptionevent/initiate": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "InitiatePartialRedemptionEventFlow",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.InitiatePartialRedemptionEventFlowDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.InitiatePartialRedemptionEventFlowDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.InitiatePartialRedemptionEventFlowDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/approvalcounterpartyapprovalvm": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "PostApprovalFlowCounterPartyApprovalVm",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ApprovalFlowWithFilesApprovalVm"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ApprovalFlowWithFilesApprovalVm"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ApprovalFlowWithFilesApprovalVm"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/approvalcounterpartyapprovalvm/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetApprovalFlowCounterPartyApprovalVmById",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/approvalflowgentwoapprovalvm": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "PostApprovalFlowGenTwoApprovalVm",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ApprovalFlowGenTwoApprovalVm"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ApprovalFlowGenTwoApprovalVm"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ApprovalFlowGenTwoApprovalVm"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/approvalflowgentwoapprovalvm/{id}": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetApprovalFlowGenTwoApprovaVmById",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/postworkflowevent": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "PostWorkflowEvent",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/notify-entity-approval-workflow/{workflowId}": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "NotifyEntityApprovalWorkflow",
        "parameters": [
          {
            "name": "workflowId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/allavailablecouponflowtypes": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetAllAvailableCouponFlowTypes",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.AppWeb.Models.DropdownOptions"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/flow/availablecouponflowtypes": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetAvailableCouponFlowTypes",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.AppWeb.Models.DropdownOptions"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/flow/cancel": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "CancelWorkflow",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.CancelWorkflowDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.CancelWorkflowDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Flow.CancelWorkflowDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          },
          "404": {
            "description": "Not Found",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/flow/plannedcoupons": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "GetPlannedCoupons",
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/payment-instruction-autogenerated-doc": {
      "get": {
        "tags": [
          "Flow"
        ],
        "operationId": "DownloadPaymentInstructionAutoGeneratedDocument",
        "parameters": [
          {
            "name": "fileName",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "workflowId",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "documentType",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string",
                  "format": "binary"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/flow/download-batchprocessing-csv": {
      "post": {
        "tags": [
          "Flow"
        ],
        "operationId": "DownloadBatchProcessingCsv",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Api.DownloadBatchProcessingDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Api.DownloadBatchProcessingDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Api.DownloadBatchProcessingDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string",
                  "format": "binary"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/incore-payment/account-balance": {
      "get": {
        "tags": [
          "InCorePayment"
        ],
        "operationId": "GetInCoreLiveAccountBalance",
        "parameters": [
          {
            "name": "ProductId",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          },
          {
            "name": "AccountId",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.InCorePayment.GetInCoreLiveAccountBalance.InCoreLiveAccountBalanceResponse"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          }
        }
      }
    },
    "/whoami": {
      "get": {
        "tags": [
          "Introspection"
        ],
        "operationId": "WhoAmI",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Infrastructure.Web.Controllers.WhoAmIDto"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/IssuerKYC/files": {
      "get": {
        "tags": [
          "IssuerKYC"
        ],
        "operationId": "GetIssuersFiles",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "text/plain": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.Documents.IssuerKYCDocumentVm"
                  }
                }
              },
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.Documents.IssuerKYCDocumentVm"
                  }
                }
              },
              "text/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.Documents.IssuerKYCDocumentVm"
                  }
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/IssuerKYC/files/download/{issuerId}": {
      "get": {
        "tags": [
          "IssuerKYC"
        ],
        "parameters": [
          {
            "name": "issuerId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/publicissuer/{slug}/productlist": {
      "get": {
        "tags": [
          "IssuerPublic"
        ],
        "operationId": "PublicGetProductList",
        "parameters": [
          {
            "name": "slug",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.PublicIssuer.PublicProductListVm"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/publicissuer/{slug}/productdetails/{isin}": {
      "get": {
        "tags": [
          "IssuerPublic"
        ],
        "operationId": "PublicGetProductDetailsByIsin",
        "parameters": [
          {
            "name": "slug",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "isin",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.PublicIssuer.PublicProductVm"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/publicissuer/{slug}/valuationhistory/{isin}": {
      "get": {
        "tags": [
          "IssuerPublic"
        ],
        "operationId": "PublicGetValuationHistoryForProduct",
        "parameters": [
          {
            "name": "slug",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "isin",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.Application.Services.ValuationHistoryDto"
                  }
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/publicissuer/{slug}/downloadvaluationhistory/{isin}": {
      "get": {
        "tags": [
          "IssuerPublic"
        ],
        "operationId": "PublicDownloadValuationHistory",
        "parameters": [
          {
            "name": "slug",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "isin",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "includeExtraColumns",
            "in": "query",
            "schema": {
              "type": "boolean",
              "default": true
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/publicissuer/{slug}/downloadlatestdocument": {
      "get": {
        "tags": [
          "IssuerPublic"
        ],
        "operationId": "PublicGetLatestDocumentForProduct",
        "parameters": [
          {
            "name": "slug",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "isin",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "type",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "culture",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "effectiveYear",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/publicissuer/{slug}/issuer": {
      "get": {
        "tags": [
          "IssuerPublic"
        ],
        "operationId": "PublicGetIssuer",
        "parameters": [
          {
            "name": "slug",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.PublicIssuer.PublicIssuerVm"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/workflows/no-touch-issuance/v2/baseflowdto": {
      "get": {
        "tags": [
          "NoTouchIssuance"
        ],
        "operationId": "GetNoTouchIssuanceBaseFlowVm",
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/workflows/no-touch-issuance/{workflowId}/events/approval/{id}": {
      "get": {
        "tags": [
          "NoTouchIssuance"
        ],
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "workflowId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/no-touch-issuance-approvalvm/{id}": {
      "get": {
        "tags": [
          "NoTouchIssuance"
        ],
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/workflows/no-touch-issuance/{workflowId}/events/approval": {
      "post": {
        "tags": [
          "NoTouchIssuance"
        ],
        "parameters": [
          {
            "name": "workflowId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.NoTouchIssuance.Version2.NoTouchIssuanceApprovalEventDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.NoTouchIssuance.Version2.NoTouchIssuanceApprovalEventDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.NoTouchIssuance.Version2.NoTouchIssuanceApprovalEventDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/no-touch-issuance-approvalvm": {
      "post": {
        "tags": [
          "NoTouchIssuance"
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.NoTouchIssuance.Version2.NoTouchIssuanceApprovalEventDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.NoTouchIssuance.Version2.NoTouchIssuanceApprovalEventDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.NoTouchIssuance.Version2.NoTouchIssuanceApprovalEventDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/workflows/no-touch-issuance/{workflowId}/events/cancellation/{id}": {
      "get": {
        "tags": [
          "NoTouchIssuance"
        ],
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "workflowId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/no-touch-issuance-cancellationvm/{id}": {
      "get": {
        "tags": [
          "NoTouchIssuance"
        ],
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/workflows/no-touch-issuance/{workflowId}/events/cancellation": {
      "post": {
        "tags": [
          "NoTouchIssuance"
        ],
        "parameters": [
          {
            "name": "workflowId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.NoTouchIssuance.Version2.NoTouchIssuanceCancellationEventDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.NoTouchIssuance.Version2.NoTouchIssuanceCancellationEventDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.NoTouchIssuance.Version2.NoTouchIssuanceCancellationEventDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/no-touch-issuance-cancellationvm": {
      "post": {
        "tags": [
          "NoTouchIssuance"
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.NoTouchIssuance.Version2.NoTouchIssuanceCancellationEventDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.NoTouchIssuance.Version2.NoTouchIssuanceCancellationEventDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.NoTouchIssuance.Version2.NoTouchIssuanceCancellationEventDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/workflows/payment-instruction/v4/baseflowdto": {
      "get": {
        "tags": [
          "PaymentInstruction"
        ],
        "operationId": "GetPaymentBaseFlowDto",
        "parameters": [
          {
            "name": "cloneId",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "quarterliesFlowId",
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/workflows/payment-instruction/v4/initiate-sync": {
      "post": {
        "tags": [
          "PaymentInstruction"
        ],
        "operationId": "InitiatePaymentFlow",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowV4InitiationStepData"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowV4InitiationStepData"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowV4InitiationStepData"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/workflows/payment-instruction/{workflowId}/events/approval/{id}": {
      "get": {
        "tags": [
          "PaymentInstruction"
        ],
        "operationId": "GetPaymentApprovalVm",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "workflowId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/payment-instruction-approvalvm/{id}": {
      "get": {
        "tags": [
          "PaymentInstruction"
        ],
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/workflows/payment-instruction/{workflowId}/events/approval": {
      "post": {
        "tags": [
          "PaymentInstruction"
        ],
        "operationId": "PostPaymentApprovalVm",
        "parameters": [
          {
            "name": "workflowId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowApprovalEventDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowApprovalEventDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowApprovalEventDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/payment-instruction-approvalvm": {
      "post": {
        "tags": [
          "PaymentInstruction"
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowApprovalEventDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowApprovalEventDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowApprovalEventDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/workflows/payment-instruction/{workflowId}/events/albeq-approval/{id}": {
      "get": {
        "tags": [
          "PaymentInstruction"
        ],
        "operationId": "GetPaymentAlbeqApprovalVm",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "workflowId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/payment-instruction-albeq-approvalvm/{id}": {
      "get": {
        "tags": [
          "PaymentInstruction"
        ],
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/workflows/payment-instruction/{workflowId}/events/albeq-approval": {
      "post": {
        "tags": [
          "PaymentInstruction"
        ],
        "operationId": "PostPaymentAlbeqApprovalVm",
        "parameters": [
          {
            "name": "workflowId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowApprovalWithFilesEventDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowApprovalWithFilesEventDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowApprovalWithFilesEventDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/payment-instruction-albeq-approvalvm": {
      "post": {
        "tags": [
          "PaymentInstruction"
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowApprovalWithFilesEventDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowApprovalWithFilesEventDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowApprovalWithFilesEventDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/workflows/payment-instruction/{workflowId}/events/cancellation/{id}": {
      "get": {
        "tags": [
          "PaymentInstruction"
        ],
        "operationId": "GetPaymentCancellationVm",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "workflowId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/payment-instruction-cancellationvm/{id}": {
      "get": {
        "tags": [
          "PaymentInstruction"
        ],
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/workflows/payment-instruction/{workflowId}/events/cancellation": {
      "post": {
        "tags": [
          "PaymentInstruction"
        ],
        "operationId": "PostPaymentCancellationVm",
        "parameters": [
          {
            "name": "workflowId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowCancellationEventDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowCancellationEventDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowCancellationEventDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/payment-instruction-cancellationvm": {
      "post": {
        "tags": [
          "PaymentInstruction"
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowCancellationEventDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowCancellationEventDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowCancellationEventDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/pdd/reference-data": {
      "get": {
        "tags": [
          "Pdd"
        ],
        "operationId": "PddGetReferenceData",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Pdd.GetReferenceData.PddReferenceDataDto"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/pdd/parties": {
      "get": {
        "tags": [
          "Pdd"
        ],
        "operationId": "PddGetParties",
        "parameters": [
          {
            "name": "partyIds",
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "type": "integer",
                "format": "int32"
              }
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Pdd.GetParties.PddPartyDto"
                  }
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/pdd/srfs": {
      "get": {
        "tags": [
          "Pdd"
        ],
        "operationId": "PddListSrfs",
        "parameters": [
          {
            "name": "search",
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "take",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32",
              "default": 100
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Pdd.ListSrfs.PddSrfListItemDto"
                  }
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/pdd/srfs/{srfId}": {
      "get": {
        "tags": [
          "Pdd"
        ],
        "operationId": "PddGetSrfSummary",
        "parameters": [
          {
            "name": "srfId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Pdd.GetSrfSummary.PddSrfSummaryDto"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/pdd/srfs/{srfId}/serialized-data": {
      "get": {
        "tags": [
          "Pdd"
        ],
        "operationId": "PddGetSerializedData",
        "parameters": [
          {
            "name": "srfId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/System.Text.Json.Nodes.JsonNode"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/pdd/srfs/{srfId}/parties": {
      "get": {
        "tags": [
          "Pdd"
        ],
        "operationId": "PddGetSrfParties",
        "parameters": [
          {
            "name": "srfId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Pdd.GetSrfParties.PddSrfPartyDto"
                  }
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/pdd/party-documents": {
      "get": {
        "tags": [
          "Pdd"
        ],
        "operationId": "PddGetPartyDocuments",
        "parameters": [
          {
            "name": "partyIds",
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "type": "integer",
                "format": "int32"
              }
            }
          },
          {
            "name": "documentTypeIds",
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "type": "integer",
                "format": "int32"
              }
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Pdd.GetPartyDocuments.PddPartyDocumentsDto"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/pdd/party-documents/{documentId}/file": {
      "get": {
        "tags": [
          "Pdd"
        ],
        "operationId": "PddGetPartyDocumentFile",
        "parameters": [
          {
            "name": "documentId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int64"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string",
                  "format": "binary"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/pdd/party-documents/{documentId}/status": {
      "post": {
        "tags": [
          "Pdd"
        ],
        "operationId": "PddUpdatePartyDocumentStatus",
        "parameters": [
          {
            "name": "documentId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int64"
            }
          },
          {
            "name": "newStatusId",
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Documents.StoredDocumentStatus+Ids"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/pdd/scan": {
      "get": {
        "tags": [
          "Pdd"
        ],
        "operationId": "PddScanDueDiligences",
        "parameters": [
          {
            "name": "skip",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32",
              "default": 0
            }
          },
          {
            "name": "take",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32",
              "default": 200
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Pdd.ScanDueDiligences.PddScanItemDto"
                  }
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/platformuserterms/status": {
      "get": {
        "tags": [
          "PlatformUserTerms"
        ],
        "operationId": "GetPlatformUserTermsStatus",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.PlatformUserTerms.GetPlatformUserTermsStatus.GetPlatformUserTermsStatusResponse"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/platformuserterms/document": {
      "get": {
        "tags": [
          "PlatformUserTerms"
        ],
        "operationId": "DownloadPlatformUserTermsDocument",
        "responses": {
          "200": {
            "description": "OK"
          },
          "404": {
            "description": "Not Found",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/platformuserterms/accept": {
      "post": {
        "tags": [
          "PlatformUserTerms"
        ],
        "operationId": "AcceptPlatformUserTerms",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.PlatformUserTerms.AcceptPlatformUserTerms.AcceptPlatformUserTermsResponse"
                }
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          },
          "404": {
            "description": "Not Found",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/producthistory/{slug}": {
      "get": {
        "tags": [
          "ProductHistory"
        ],
        "operationId": "GetProductDetails",
        "parameters": [
          {
            "name": "slug",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.ProductHistory.GetProductDetails.GetProductDetailsResponse"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/producthistory/{slug}/downloadtermsheet": {
      "get": {
        "tags": [
          "ProductHistory"
        ],
        "operationId": "DownloadProductTermsheetDocuments",
        "parameters": [
          {
            "name": "slug",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.ProductHistory.GetProductTermsheetDocuments.GetProductTermsheetDocumentsResponse"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          },
          "404": {
            "description": "Not Found",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/producthistory/{slug}/downloadvaluationhistory": {
      "get": {
        "tags": [
          "ProductHistory"
        ],
        "operationId": "DownloadProductValuationHistory",
        "parameters": [
          {
            "name": "slug",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.ProductHistory.GetProductValuationHistory.GetProductValuationHistoryFileResponse"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/producthistory/{slug}/getvaluationhistory": {
      "get": {
        "tags": [
          "ProductHistory"
        ],
        "operationId": "GetProductValuationHistory",
        "parameters": [
          {
            "name": "slug",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.ProductHistory.GetProductValuationHistory.GetValuationHistoryDto"
                  }
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/producthub/companydetails": {
      "get": {
        "tags": [
          "ProductHub"
        ],
        "operationId": "GetCompanyDetails",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.CompanyDetailsVm"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/producthub/basicproductinfo/{isin}": {
      "get": {
        "tags": [
          "ProductHub"
        ],
        "operationId": "GetBasicProductInfo",
        "parameters": [
          {
            "name": "isin",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.BasicProductInfoVm"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/producthub/productdetails/{isin}": {
      "get": {
        "tags": [
          "ProductHub"
        ],
        "operationId": "GetProductDetailsByIsin",
        "parameters": [
          {
            "name": "isin",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "checkForAllowPotentialInvestor",
            "in": "query",
            "schema": {
              "type": "boolean"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.ProductVm"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/producthub/productlist": {
      "get": {
        "tags": [
          "ProductHub"
        ],
        "operationId": "GetProductList",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Application.Models.ProductListVm"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/producthub/productlist/interested-in": {
      "get": {
        "tags": [
          "ProductHub"
        ],
        "operationId": "GetInterestedInProductList",
        "parameters": [
          {
            "name": "productStates",
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductStateEnum"
              }
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Application.Models.ProductListVm"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/producthub/productlist/{issuerId}": {
      "get": {
        "tags": [
          "ProductHub"
        ],
        "operationId": "GetProductListByIssuer",
        "parameters": [
          {
            "name": "issuerId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Application.Models.ProductListVm"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/producthub/downloadlatesttermsheet/{productId}": {
      "get": {
        "tags": [
          "ProductHub"
        ],
        "operationId": "GetLatestTermsheetForProduct",
        "parameters": [
          {
            "name": "productId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          },
          {
            "name": "checkForAllowPotentialInvestor",
            "in": "query",
            "schema": {
              "type": "boolean",
              "default": false
            }
          },
          {
            "name": "viewInBrowser",
            "in": "query",
            "schema": {
              "type": "boolean",
              "default": false
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/producthub/downloaddrafttermsheet/{productId}": {
      "get": {
        "tags": [
          "ProductHub"
        ],
        "operationId": "GetDraftTermsheetForProduct",
        "parameters": [
          {
            "name": "productId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/producthub/hastermsheet/{productId}": {
      "get": {
        "tags": [
          "ProductHub"
        ],
        "operationId": "HasTermsheetForAProduct",
        "parameters": [
          {
            "name": "productId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          },
          {
            "name": "checkForAllowPotentialInvestor",
            "in": "query",
            "schema": {
              "type": "boolean",
              "default": false
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "boolean"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/producthub/downloadlatestsrf/{productId}": {
      "get": {
        "tags": [
          "ProductHub"
        ],
        "operationId": "DownloadLatestSRFForProduct",
        "parameters": [
          {
            "name": "productId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/producthub/listproductinvoices/{productId}": {
      "get": {
        "tags": [
          "ProductHub"
        ],
        "operationId": "ListProductInvoices",
        "parameters": [
          {
            "name": "productId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/producthub/downloadproductinvoice/{invoiceId}/{productId}/{source}": {
      "get": {
        "tags": [
          "ProductHub"
        ],
        "operationId": "DownloadProductInvoice",
        "parameters": [
          {
            "name": "invoiceId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          },
          {
            "name": "productId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          },
          {
            "name": "source",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/producthub/valuationhistory/{productId}": {
      "get": {
        "tags": [
          "ProductHub"
        ],
        "operationId": "GetValuationHistoryForProduct",
        "parameters": [
          {
            "name": "productId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          },
          {
            "name": "checkForAllowPotentialInvestor",
            "in": "query",
            "schema": {
              "type": "boolean",
              "default": false
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.Application.Services.ValuationHistoryDto"
                  }
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/producthub/downloadproductsheet/{issuerId}": {
      "get": {
        "tags": [
          "ProductHub"
        ],
        "operationId": "GetProductSheetForIssuer",
        "parameters": [
          {
            "name": "issuerId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/producthub/downloadproductsheet": {
      "get": {
        "tags": [
          "ProductHub"
        ],
        "operationId": "GetProductSheetForAllIssuers",
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/producthub/downloadvaluationhistory/{id}": {
      "get": {
        "tags": [
          "ProductHub"
        ],
        "operationId": "DownloadValuationHistoryForProduct",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          },
          {
            "name": "checkForAllowPotentialInvestor",
            "in": "query",
            "schema": {
              "type": "boolean",
              "default": false
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/producthub/pricingsheet/{isin}": {
      "get": {
        "tags": [
          "ProductHub"
        ],
        "operationId": "GetPricingSheetByProduct",
        "parameters": [
          {
            "name": "isin",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/producthub/clientfeedback": {
      "post": {
        "tags": [
          "ProductHub"
        ],
        "operationId": "SendClientFeedback",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.ClientFeedbackVm"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.ClientFeedbackVm"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.ClientFeedbackVm"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/producthub/termsandconditions/{isin}": {
      "get": {
        "tags": [
          "ProductHub"
        ],
        "operationId": "GetTermsAndConditionsForProduct",
        "parameters": [
          {
            "name": "isin",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.AppWeb.Models.ProductHub.TermsAndConditionsDocument"
                  }
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/producthub/productevent/create": {
      "post": {
        "tags": [
          "ProductHub"
        ],
        "operationId": "CreateProductEvent",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductEvent"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductEvent"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductEvent"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/producthub/downloaddocumenttype/{isin}/{dropboxDataType}": {
      "get": {
        "tags": [
          "ProductHub"
        ],
        "operationId": "DownloadDocumentType",
        "parameters": [
          {
            "name": "isin",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "dropboxDataType",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/producthub/updateproductvisibilitydashboard/{id}": {
      "patch": {
        "tags": [
          "ProductHub"
        ],
        "operationId": "UpdateProductVisibilityOnDashboard",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "type": "boolean"
              }
            },
            "text/json": {
              "schema": {
                "type": "boolean"
              }
            },
            "application/*+json": {
              "schema": {
                "type": "boolean"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/producthub/{isin}/change-request": {
      "post": {
        "tags": [
          "ProductHub"
        ],
        "operationId": "ProductChangeRequest",
        "parameters": [
          {
            "name": "isin",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "requestBody": {
          "content": {
            "multipart/form-data": {
              "schema": {
                "required": [
                  "SelectedChanges",
                  "SelectedGroups",
                  "Text"
                ],
                "type": "object",
                "properties": {
                  "SelectedChanges": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "SelectedGroups": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "Text": {
                    "type": "string"
                  },
                  "Attachments": {
                    "type": "array",
                    "items": {
                      "type": "string",
                      "format": "binary"
                    }
                  }
                }
              },
              "encoding": {
                "SelectedChanges": {
                  "style": "form"
                },
                "SelectedGroups": {
                  "style": "form"
                },
                "Text": {
                  "style": "form"
                },
                "Attachments": {
                  "style": "form"
                }
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/workflows/product-issuance/v6/baseflowdto": {
      "get": {
        "tags": [
          "ProductIssuance"
        ],
        "operationId": "GetProductIssuanceBaseFlowVm",
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/workflows/product-issuance/v6/initiate-sync": {
      "post": {
        "tags": [
          "ProductIssuance"
        ],
        "operationId": "InitiateProductIssuanceFlow",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceFlowV6InitiationStepData"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceFlowV6InitiationStepData"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceFlowV6InitiationStepData"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/workflows/product-issuance/{workflowId}/events/approval/{id}": {
      "get": {
        "tags": [
          "ProductIssuance"
        ],
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "workflowId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/product-issuance-approvalvm/{id}": {
      "get": {
        "tags": [
          "ProductIssuance"
        ],
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/workflows/product-issuance/{workflowId}/events/approval": {
      "post": {
        "tags": [
          "ProductIssuance"
        ],
        "parameters": [
          {
            "name": "workflowId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceApprovalEventDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceApprovalEventDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceApprovalEventDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/product-issuance-approvalvm": {
      "post": {
        "tags": [
          "ProductIssuance"
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceApprovalEventDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceApprovalEventDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceApprovalEventDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/workflows/product-issuance/{workflowId}/events/approval-with-files/{id}": {
      "get": {
        "tags": [
          "ProductIssuance"
        ],
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "workflowId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/product-issuance-approval-with-filesvm/{id}": {
      "get": {
        "tags": [
          "ProductIssuance"
        ],
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/workflows/product-issuance/{workflowId}/events/approval-with-files": {
      "post": {
        "tags": [
          "ProductIssuance"
        ],
        "parameters": [
          {
            "name": "workflowId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceApprovalWithFilesEventDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceApprovalWithFilesEventDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceApprovalWithFilesEventDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/product-issuance-approval-with-filesvm": {
      "post": {
        "tags": [
          "ProductIssuance"
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceApprovalWithFilesEventDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceApprovalWithFilesEventDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceApprovalWithFilesEventDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/workflows/product-issuance/{workflowId}/events/g2-approval/{id}": {
      "get": {
        "tags": [
          "ProductIssuance"
        ],
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "workflowId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/product-issuance-g2-approvalvm/{id}": {
      "get": {
        "tags": [
          "ProductIssuance"
        ],
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/workflows/product-issuance/{workflowId}/events/g2-approval": {
      "post": {
        "tags": [
          "ProductIssuance"
        ],
        "parameters": [
          {
            "name": "workflowId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceG2ApprovalEventDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceG2ApprovalEventDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceG2ApprovalEventDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/product-issuance-g2-approvalvm": {
      "post": {
        "tags": [
          "ProductIssuance"
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceG2ApprovalEventDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceG2ApprovalEventDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceG2ApprovalEventDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/workflows/product-issuance/{workflowId}/events/cancellation/{id}": {
      "get": {
        "tags": [
          "ProductIssuance"
        ],
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "workflowId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/product-issuance-cancellationvm/{id}": {
      "get": {
        "tags": [
          "ProductIssuance"
        ],
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/workflows/product-issuance/{workflowId}/events/cancellation": {
      "post": {
        "tags": [
          "ProductIssuance"
        ],
        "parameters": [
          {
            "name": "workflowId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceFlowCancellationEventDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceFlowCancellationEventDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceFlowCancellationEventDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/flow/product-issuance-cancellationvm": {
      "post": {
        "tags": [
          "ProductIssuance"
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceFlowCancellationEventDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceFlowCancellationEventDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceFlowCancellationEventDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/quarterlies/approveandinitiatepayment": {
      "post": {
        "tags": [
          "QuarterliesApproval"
        ],
        "operationId": "ApproveAndInitiatePayment",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "type": "string"
              }
            },
            "text/json": {
              "schema": {
                "type": "string"
              }
            },
            "application/*+json": {
              "schema": {
                "type": "string"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.AppWeb.Controllers.QuarterliesApprovalController+QuarterlyFlowApprovalResponse"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/quarterlies/downloadinvoices": {
      "post": {
        "tags": [
          "QuarterliesApproval"
        ],
        "operationId": "DownloadInvoices",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "type": "array",
                "items": {
                  "$ref": "#/components/schemas/g2fp.AppWeb.Controllers.QuarterliesApprovalController+InvoiceDto"
                }
              }
            },
            "text/json": {
              "schema": {
                "type": "array",
                "items": {
                  "$ref": "#/components/schemas/g2fp.AppWeb.Controllers.QuarterliesApprovalController+InvoiceDto"
                }
              }
            },
            "application/*+json": {
              "schema": {
                "type": "array",
                "items": {
                  "$ref": "#/components/schemas/g2fp.AppWeb.Controllers.QuarterliesApprovalController+InvoiceDto"
                }
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/quarterlies/checkinvoices/{warningKey}": {
      "get": {
        "tags": [
          "QuarterliesApproval"
        ],
        "operationId": "CheckInvoices",
        "parameters": [
          {
            "name": "warningKey",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/quarterlies/associatedpaymentinstructions": {
      "post": {
        "tags": [
          "QuarterliesApproval"
        ],
        "operationId": "GetAssociatedPaymentInstructions",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "type": "array",
                "items": {
                  "type": "string"
                }
              }
            },
            "text/json": {
              "schema": {
                "type": "array",
                "items": {
                  "type": "string"
                }
              }
            },
            "application/*+json": {
              "schema": {
                "type": "array",
                "items": {
                  "type": "string"
                }
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.AppWeb.Controllers.QuarterliesApprovalController+QuarterlyFlowPaymentInstructionResponse"
                  }
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/SalesDocument/types": {
      "get": {
        "tags": [
          "SalesDocument"
        ],
        "operationId": "SalesDocumentTypes",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.Models.Documents.SalesDocumentTypeDto"
                  }
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/SalesDocument/latest/{isGenTwoDigitalDocument}": {
      "get": {
        "tags": [
          "SalesDocument"
        ],
        "operationId": "GetLatestDocuments",
        "parameters": [
          {
            "name": "isGenTwoDigitalDocument",
            "in": "path",
            "required": true,
            "schema": {
              "type": "boolean"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.Documents.SalesDocumentVm"
                  }
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/SalesDocument/download/{id}": {
      "get": {
        "tags": [
          "SalesDocument"
        ],
        "operationId": "SalesDocumentDownload",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string",
                  "format": "binary"
                }
              }
            }
          }
        }
      }
    },
    "/startup": {
      "get": {
        "tags": [
          "Startup"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/srf/listsrf": {
      "get": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "ListSrfs",
        "parameters": [
          {
            "name": "dataRange",
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.SelectedDataRangeEnum"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/srf/srfdetails": {
      "get": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "GetSrfDetails",
        "parameters": [
          {
            "name": "id",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          },
          {
            "name": "isLite",
            "in": "query",
            "schema": {
              "type": "boolean",
              "default": false
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.Srf.StructuringRequestFormVm"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/srf/srfstepdetails": {
      "get": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "GetSrfStepDetails",
        "parameters": [
          {
            "name": "id",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/srf/srfupsertstep": {
      "post": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "UpsertSrfStep",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Modules.ProductStructuring.Legacy.Models.UpsertStep"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Modules.ProductStructuring.Legacy.Models.UpsertStep"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Modules.ProductStructuring.Legacy.Models.UpsertStep"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/srf/srfdeletesteps": {
      "post": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "DeleteSrfSteps",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Api.StructuringRequestDeleteStepsDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Api.StructuringRequestDeleteStepsDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Api.StructuringRequestDeleteStepsDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/srf/srfmarkcomplete": {
      "post": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "MarkSrfAsComplete",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "type": "integer",
                "format": "int32"
              }
            },
            "text/json": {
              "schema": {
                "type": "integer",
                "format": "int32"
              }
            },
            "application/*+json": {
              "schema": {
                "type": "integer",
                "format": "int32"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/srf/srfarchive": {
      "post": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "ArchiveSrf",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "type": "integer",
                "format": "int32"
              }
            },
            "text/json": {
              "schema": {
                "type": "integer",
                "format": "int32"
              }
            },
            "application/*+json": {
              "schema": {
                "type": "integer",
                "format": "int32"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/srf/srfcreate": {
      "post": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "CreateSrf",
        "parameters": [
          {
            "name": "isLite",
            "in": "query",
            "schema": {
              "type": "boolean",
              "default": false
            }
          }
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "type": "integer",
                "format": "int32"
              }
            },
            "text/json": {
              "schema": {
                "type": "integer",
                "format": "int32"
              }
            },
            "application/*+json": {
              "schema": {
                "type": "integer",
                "format": "int32"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/srf/srfclone/{id}": {
      "post": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "CloneSrf",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/srf/srfdelete": {
      "post": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "DeleteSrf",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "type": "integer",
                "format": "int32"
              }
            },
            "text/json": {
              "schema": {
                "type": "integer",
                "format": "int32"
              }
            },
            "application/*+json": {
              "schema": {
                "type": "integer",
                "format": "int32"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/srf/srfstatic": {
      "get": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "GetSrfStaticData",
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/srf/srfuserspecificstatic": {
      "get": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "GetSrfUserSpecificStaticData",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.Srf.SrfUserSpecificStaticVm"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/srf/product-managers": {
      "get": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "GetProductManagersForClient",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.Srf.PartyVm"
                  }
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/srf/distribution-agents": {
      "get": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "GetDistributionAgentsForClient",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.Srf.PartyVm"
                  }
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/srf/custodians-brokers": {
      "get": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "GetProductCustodiansBrokersForClient",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.Srf.PartyVm"
                  }
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/srf/payingagents": {
      "get": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "GetPayingAgents",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Party"
                  }
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/srf/issuer/{issuerId}": {
      "get": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "GetIssuer",
        "parameters": [
          {
            "name": "issuerId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Issuer"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/srf/update-current-step": {
      "put": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "UpdateCurrentStep",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Api.UpdateCurrentStepDto"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Api.UpdateCurrentStepDto"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.Api.UpdateCurrentStepDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/srf/{srfId}/create-product": {
      "post": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "CreateSrfProduct",
        "parameters": [
          {
            "name": "srfId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          },
          {
            "name": "isAgenticPdd",
            "in": "query",
            "schema": {
              "type": "boolean"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.Srf.SrfConversionResult"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/srf/{id}/detect-product-type": {
      "get": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "DetectProductType",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.Srf.DetectProductTypeResult"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/srf/{srfId}/pdd": {
      "put": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "ProductDueDiligenceUpdate",
        "parameters": [
          {
            "name": "srfId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductDueDiligence"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductDueDiligence"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductDueDiligence"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.Srf.ProductDueDiligenceUpdateResponse"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/srf/{srfId}/pdd/submit": {
      "post": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "ProductDueDiligenceSubmit",
        "parameters": [
          {
            "name": "srfId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Models.StructuringRequest.ProductDueDiligenceSubmitRequest"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Models.StructuringRequest.ProductDueDiligenceSubmitRequest"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Models.StructuringRequest.ProductDueDiligenceSubmitRequest"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductDueDiligence"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/srf/{srfId}/pdd/approve": {
      "post": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "ProductDueDiligenceApprove",
        "parameters": [
          {
            "name": "srfId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductDueDiligence"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/srf/{srfId}/pdd-uploadfile": {
      "post": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "ProductDueDiligenceUploadFile",
        "parameters": [
          {
            "name": "srfId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "requestBody": {
          "content": {
            "multipart/form-data": {
              "schema": {
                "type": "object",
                "properties": {
                  "entityId": {
                    "type": "integer",
                    "format": "int32"
                  },
                  "documentType": {
                    "type": "string"
                  },
                  "relatedEntityType": {
                    "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Documents.StoredDocumentRelatedEntityEnum"
                  },
                  "expiryDate": {
                    "type": "string",
                    "format": "date-time"
                  },
                  "file": {
                    "type": "string",
                    "format": "binary"
                  },
                  "description": {
                    "type": "string"
                  }
                }
              },
              "encoding": {
                "entityId": {
                  "style": "form"
                },
                "documentType": {
                  "style": "form"
                },
                "relatedEntityType": {
                  "style": "form"
                },
                "expiryDate": {
                  "style": "form"
                },
                "file": {
                  "style": "form"
                },
                "description": {
                  "style": "form"
                }
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string",
                  "format": "uuid"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/srf/{srfId}/pdd-file/{fileGuid}": {
      "get": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "ProductDueDiligenceFileDownload",
        "parameters": [
          {
            "name": "srfId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          },
          {
            "name": "entityId",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          },
          {
            "name": "fileGuid",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string",
              "format": "uuid"
            }
          },
          {
            "name": "relatedEntityType",
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Documents.StoredDocumentRelatedEntityEnum"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.AppWeb.Models.StructuringRequest.ProductDueDiligenceDocumentDownloadResponse"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/srf/product-documents/{productId}": {
      "get": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "GetProductDocumentsAsJson",
        "parameters": [
          {
            "name": "productId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Documents.StoredDocumentType"
                  }
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/srf/{srfId}/available-traders": {
      "get": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "AvailableTraders",
        "parameters": [
          {
            "name": "srfId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.Srf.TraderVm"
                  }
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/srf/pdd-documenttypes": {
      "get": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "GetPddDocumentTypes",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.Srf.DocumentTypeVm"
                  }
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/srf/{srfId}/create-entity-in-portal": {
      "post": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "CreateEntityInPortal",
        "parameters": [
          {
            "name": "srfId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Models.StructuringRequest.EntityCreationRequest"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Models.StructuringRequest.EntityCreationRequest"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Models.StructuringRequest.EntityCreationRequest"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.AppWeb.Models.StructuringRequest.CreateEntityInPortalResponse"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/srf/{srfId}/required-documents": {
      "get": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "RequiredDocuments",
        "parameters": [
          {
            "name": "srfId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.AppWeb.Models.StructuringRequest.RequiredDocumentsVm"
                  }
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/srf/{srfId}/entity-status/{partyId}/{partyTypeId}": {
      "get": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "GetEntityStatus",
        "parameters": [
          {
            "name": "srfId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          },
          {
            "name": "partyId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          },
          {
            "name": "partyTypeId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.AppWeb.Models.StructuringRequest.ProductDueDiligenceEntityStatusVm"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/srf/{srfId}/product-parties": {
      "get": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "GetProductParties",
        "parameters": [
          {
            "name": "srfId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.Srf.ProductPartyVm"
                  }
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/srf/termsheet": {
      "get": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "DownloadSRFTermsheet",
        "parameters": [
          {
            "name": "srfId",
            "in": "query",
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/srf/isvalidportfoliomanager/{pmId}": {
      "get": {
        "tags": [
          "StructuringRequest"
        ],
        "operationId": "IsValidPortfolioManager",
        "parameters": [
          {
            "name": "pmId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "boolean"
                }
              }
            }
          }
        }
      }
    },
    "/test/problem-details/{statusCode}": {
      "get": {
        "tags": [
          "Test"
        ],
        "parameters": [
          {
            "name": "statusCode",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int32"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/exception": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/api-exception": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/serialization-exception": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/stream-with-error": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-exception": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/auth/plain": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/auth/bearer-allowed": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/auth/antiforgery-protected": {
      "post": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/post-exception": {
      "post": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/put-exception": {
      "put": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/patch-exception": {
      "patch": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/delete-exception": {
      "delete": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-localapiexception": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-problemdetails": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-notfound": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-notfoundwithproblemdetails": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-accepted": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-badrequest": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-emptybadrequest": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-conflict": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-nocontent": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-emptyresult": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-validationproblem": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-validationexception": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-fluentvalidationexception": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-apierror": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-library-fluentvalidationexception": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/delete-library-exception": {
      "delete": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/api-library-exception": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-library-exception": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-library-localapiexception": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-library-validationexception": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/patch-library-exception": {
      "patch": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/post-library-exception": {
      "post": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/put-library-exception": {
      "put": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-library-apierror": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-library-badrequest": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-library-emptybadrequest": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-library-notfoundwithproblemdetails": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-library-problemdetails": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-empty-parameter/{guid}": {
      "get": {
        "tags": [
          "Test"
        ],
        "parameters": [
          {
            "name": "guid",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-posapi-empty-parameter": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-guid-created-at-action": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-guid-ok": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-string-ok": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-string-from-posapi-ok": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-guid-from-posapi-created-at-action": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/test/get-guid-from-posapi-ok": {
      "get": {
        "tags": [
          "Test"
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    },
    "/apptwo/user/{email}/image": {
      "get": {
        "tags": [
          "User"
        ],
        "operationId": "GetUserImage",
        "parameters": [
          {
            "name": "email",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.UserImageVm"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/user/notifications": {
      "get": {
        "tags": [
          "User"
        ],
        "operationId": "GetUserNotifications",
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.UserNotificationVm"
                  }
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/webhook/savewebhook": {
      "post": {
        "tags": [
          "Webhook"
        ],
        "operationId": "SaveWebhook",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Webhook.SaveWebhook.SaveWebHookRequest"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Webhook.SaveWebhook.SaveWebHookRequest"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Webhook.SaveWebhook.SaveWebHookRequest"
              }
            }
          }
        },
        "responses": {
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/webhook/deletewebhook/{guid}": {
      "get": {
        "tags": [
          "Webhook"
        ],
        "operationId": "DeleteWebhook",
        "parameters": [
          {
            "name": "guid",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/webhook/getwebhooks": {
      "get": {
        "tags": [
          "Webhook"
        ],
        "operationId": "GetWebhooks",
        "responses": {
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/webhook/testwebhook": {
      "post": {
        "tags": [
          "Webhook"
        ],
        "operationId": "TestWebhook",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Webhook.TestWebhook.TestWebhookRequest"
              }
            },
            "text/json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Webhook.TestWebhook.TestWebhookRequest"
              }
            },
            "application/*+json": {
              "schema": {
                "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Webhook.TestWebhook.TestWebhookRequest"
              }
            }
          }
        },
        "responses": {
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Microsoft.AspNetCore.Mvc.ProblemDetails"
                }
              }
            }
          }
        }
      }
    },
    "/apptwo/workflows/{workflowId}/events/all": {
      "get": {
        "tags": [
          "Workflow"
        ],
        "operationId": "GetAllWorkflowEventsById",
        "parameters": [
          {
            "name": "workflowId",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK"
          }
        }
      }
    }
  },
  "components": {
    "schemas": {
      "Microsoft.AspNetCore.Mvc.ProblemDetails": {
        "type": "object",
        "properties": {
          "type": {
            "type": "string",
            "nullable": true
          },
          "title": {
            "type": "string",
            "nullable": true
          },
          "status": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "detail": {
            "type": "string",
            "nullable": true
          },
          "instance": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": { }
      },
      "System.Text.Json.Nodes.JsonNode": {
        "type": "object",
        "properties": {
          "options": {
            "$ref": "#/components/schemas/System.Text.Json.Nodes.JsonNodeOptions"
          },
          "parent": {
            "$ref": "#/components/schemas/System.Text.Json.Nodes.JsonNode"
          },
          "root": {
            "$ref": "#/components/schemas/System.Text.Json.Nodes.JsonNode"
          }
        },
        "additionalProperties": false
      },
      "System.Text.Json.Nodes.JsonNodeOptions": {
        "type": "object",
        "properties": {
          "propertyNameCaseInsensitive": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.Account.CreateUser.CreateUserRequest": {
        "type": "object",
        "properties": {
          "email": {
            "type": "string",
            "nullable": true
          },
          "firstName": {
            "type": "string",
            "nullable": true
          },
          "lastName": {
            "type": "string",
            "nullable": true
          },
          "companyName": {
            "type": "string",
            "nullable": true
          },
          "jobTitle": {
            "type": "string",
            "nullable": true
          },
          "launchProductIn": {
            "type": "string",
            "nullable": true
          },
          "projectStage": {
            "type": "string",
            "nullable": true
          },
          "projectTiming": {
            "type": "string",
            "nullable": true
          },
          "projectDescription": {
            "type": "string",
            "nullable": true
          },
          "aboutGentwoReferral": {
            "type": "string",
            "nullable": true
          },
          "isSubscribedToNewsletter": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.Account.GetUserDetail.AvailableFunctionDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "email": {
            "type": "string",
            "nullable": true
          },
          "firstName": {
            "type": "string",
            "nullable": true
          },
          "lastName": {
            "type": "string",
            "nullable": true
          },
          "isSelf": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.Account.GetUserDetail.FlowGroupDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "email": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.Account.GetUserDetail.UserClaimDto": {
        "type": "object",
        "properties": {
          "type": {
            "type": "string",
            "nullable": true
          },
          "value": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.Account.GetUserDetail.UserDetailDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "userCompanyId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "firstName": {
            "type": "string",
            "nullable": true
          },
          "lastName": {
            "type": "string",
            "nullable": true
          },
          "userName": {
            "type": "string",
            "nullable": true
          },
          "email": {
            "type": "string",
            "nullable": true
          },
          "roles": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "claims": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Account.GetUserDetail.UserClaimDto"
            },
            "nullable": true
          },
          "groups": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Account.GetUserDetail.FlowGroupDto"
            },
            "nullable": true
          },
          "availableFunctions": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Account.GetUserDetail.AvailableFunctionDto"
            },
            "nullable": true
          },
          "activeFunctionEmail": {
            "type": "string",
            "nullable": true
          },
          "platformUserTermsAcceptanceRequired": {
            "type": "boolean"
          },
          "isGentwo": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.Account.ResetUserPassword.ResetUserPasswordRequest": {
        "type": "object",
        "properties": {
          "localUserId": {
            "type": "string",
            "nullable": true
          },
          "remoteUserId": {
            "type": "string",
            "nullable": true
          },
          "code": {
            "type": "string",
            "nullable": true
          },
          "newPassword": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.Account.ResetUserPassword.SendPasswordResetEmailRequest": {
        "type": "object",
        "properties": {
          "emailAddress": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.Account.SwitchFunction.SwitchFunctionRequest": {
        "type": "object",
        "properties": {
          "targetUserId": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.Account.UserImpersonation.StartUserImpersonationRequest": {
        "type": "object",
        "properties": {
          "emailAddress": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.InCorePayment.GetInCoreLiveAccountBalance.InCoreLiveAccountBalanceResponse": {
        "type": "object",
        "properties": {
          "amount": {
            "type": "number",
            "format": "double"
          },
          "fetchedAt": {
            "type": "string",
            "format": "date-time"
          },
          "error": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.Pdd.GetParties.PddPartyDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "zefixUid": {
            "type": "string",
            "nullable": true
          },
          "legalEntityIdentifier": {
            "type": "string",
            "nullable": true
          },
          "esmaId": {
            "type": "string",
            "nullable": true
          },
          "isArchived": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.Pdd.GetPartyDocuments.PddDocumentAuditDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "auditReferenceId": {
            "type": "integer",
            "format": "int32"
          },
          "auditEventName": {
            "type": "string",
            "nullable": true
          },
          "auditDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "userId": {
            "type": "string",
            "nullable": true
          },
          "userGuid": {
            "type": "string",
            "nullable": true
          },
          "userName": {
            "type": "string",
            "nullable": true
          },
          "changeDescription": {
            "type": "string",
            "nullable": true
          },
          "fieldChanges": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.Pdd.GetPartyDocuments.PddPartyDocumentsDto": {
        "type": "object",
        "properties": {
          "documents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Pdd.GetPartyDocuments.PddStoredDocumentDto"
            },
            "nullable": true
          },
          "audits": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Pdd.GetPartyDocuments.PddDocumentAuditDto"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.Pdd.GetPartyDocuments.PddStoredDocumentDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int64"
          },
          "entityId": {
            "type": "integer",
            "format": "int32"
          },
          "storedDocumentTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Documents.StoredDocumentType+Ids"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "originalFileName": {
            "type": "string",
            "nullable": true
          },
          "internalName": {
            "type": "string",
            "nullable": true
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "fileLocation": {
            "type": "string",
            "nullable": true
          },
          "statusId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Documents.StoredDocumentStatus+Ids"
          },
          "createdAt": {
            "type": "string",
            "format": "date-time"
          },
          "expiryDate": {
            "type": "string",
            "format": "date"
          },
          "effectiveYear": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "userGuid": {
            "type": "string",
            "nullable": true
          },
          "uploadedBy": {
            "type": "string",
            "nullable": true
          },
          "sourceEntityType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Documents.StoredDocumentRelatedEntityEnum"
          },
          "sourceEntityId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.Pdd.GetReferenceData.PddLookupDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.Pdd.GetReferenceData.PddReferenceDataDto": {
        "type": "object",
        "properties": {
          "requiredDocuments": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Pdd.GetReferenceData.PddRequiredDocumentDto"
            },
            "nullable": true
          },
          "documentTypes": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Pdd.GetReferenceData.PddLookupDto"
            },
            "nullable": true
          },
          "partyTypes": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.Pdd.GetReferenceData.PddLookupDto"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.Pdd.GetReferenceData.PddRequiredDocumentDto": {
        "type": "object",
        "properties": {
          "partyTypeId": {
            "type": "integer",
            "format": "int32"
          },
          "storedDocumentTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Documents.StoredDocumentType+Ids"
          },
          "internalProductTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.InternalProductTypeEnum"
          },
          "legalSubjectTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.LegalSubjectType+Ids"
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.Pdd.GetSrfParties.PddSrfPartyDto": {
        "type": "object",
        "properties": {
          "partyId": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "partyTypeId": {
            "type": "integer",
            "format": "int32"
          },
          "legalSubjectTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.LegalSubjectType+Ids"
          },
          "countryId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "countryName": {
            "type": "string",
            "nullable": true
          },
          "countryIsoAlpha2Code": {
            "type": "string",
            "nullable": true
          },
          "isRegulated": {
            "type": "boolean",
            "nullable": true
          },
          "regulatoryBodyId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "regulatoryBodyName": {
            "type": "string",
            "nullable": true
          },
          "isLowRiskJurisdiction": {
            "type": "boolean",
            "nullable": true
          },
          "regulatoryLicenseTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.RegulatoryLicenseType+Ids"
          },
          "isArchived": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.Pdd.GetSrfSummary.PddSrfSummaryDto": {
        "type": "object",
        "properties": {
          "srfId": {
            "type": "integer",
            "format": "int32"
          },
          "srfName": {
            "type": "string",
            "nullable": true
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "productDueDiligenceId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "longName": {
            "type": "string",
            "nullable": true
          },
          "isin": {
            "type": "string",
            "nullable": true
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "internalProductTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.InternalProductTypeEnum"
          },
          "internalProductTypeName": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.Pdd.ListSrfs.PddSrfListItemDto": {
        "type": "object",
        "properties": {
          "srfId": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "statusId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "statusName": {
            "type": "string",
            "nullable": true
          },
          "productType": {
            "type": "string",
            "nullable": true
          },
          "productDueDiligenceId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "productId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "isin": {
            "type": "string",
            "nullable": true
          },
          "productName": {
            "type": "string",
            "nullable": true
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "internalProductTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.InternalProductTypeEnum"
          },
          "internalProductTypeName": {
            "type": "string",
            "nullable": true
          },
          "createDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "submittedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.Pdd.ScanDueDiligences.PddScanItemDto": {
        "type": "object",
        "properties": {
          "productDueDiligenceId": {
            "type": "integer",
            "format": "int32"
          },
          "statusId": {
            "type": "integer",
            "format": "int32"
          },
          "modifiedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "srfId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "productId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "isin": {
            "type": "string",
            "nullable": true
          },
          "productName": {
            "type": "string",
            "nullable": true
          },
          "serializedData": {
            "$ref": "#/components/schemas/System.Text.Json.Nodes.JsonNode"
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.PlatformUserTerms.AcceptPlatformUserTerms.AcceptPlatformUserTermsOutcome": {
        "enum": [
          0,
          1,
          2,
          3
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.AppWeb.Application.Features.PlatformUserTerms.AcceptPlatformUserTerms.AcceptPlatformUserTermsResponse": {
        "type": "object",
        "properties": {
          "outcome": {
            "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.PlatformUserTerms.AcceptPlatformUserTerms.AcceptPlatformUserTermsOutcome"
          },
          "acceptedAtUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.PlatformUserTerms.GetPlatformUserTermsStatus.GetPlatformUserTermsStatusResponse": {
        "type": "object",
        "properties": {
          "isEnforced": {
            "type": "boolean"
          },
          "acceptanceRequired": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.ProductHistory.GetProductDetails.Dtos.CouponPaymentTypeDto": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.CouponPaymentTypeEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.ProductHistory.GetProductDetails.Dtos.CouponTypeDto": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.CouponTypeEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.ProductHistory.GetProductDetails.Dtos.DistributorDto": {
        "type": "object",
        "properties": {
          "partyId": {
            "type": "integer",
            "format": "int32"
          },
          "distributionCountries": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.ProductHistory.GetProductDetails.Dtos.EarlyRedemptionStateDto": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.EarlyRedemptionStatesEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.ProductHistory.GetProductDetails.Dtos.IssuerDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.ProductHistory.GetProductDetails.Dtos.PartyDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.ProductHistory.GetProductDetails.Dtos.PriceDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "code": {
            "type": "string",
            "nullable": true
          },
          "isin": {
            "type": "string",
            "nullable": true
          },
          "type": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.PriceTypeEnum"
          },
          "price": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "dataLastRefreshDateTime": {
            "type": "string",
            "format": "date-time"
          },
          "priceDateTime": {
            "type": "string",
            "format": "date-time"
          },
          "priceDate": {
            "type": "string",
            "format": "date"
          },
          "createDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "modifiedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "modifiedUserName": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.ProductHistory.GetProductDetails.Dtos.ProductDocumentDto": {
        "type": "object",
        "properties": {
          "type": {
            "type": "string",
            "nullable": true
          },
          "culture": {
            "type": "string",
            "nullable": true
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.ProductHistory.GetProductDetails.Dtos.ProductHistoryDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "title": {
            "type": "string",
            "nullable": true
          },
          "details": {
            "type": "string",
            "nullable": true
          },
          "createdAt": {
            "type": "string",
            "format": "date"
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.ProductHistory.GetProductDetails.Dtos.ProductOfferingDto": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductOfferingEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.ProductHistory.GetProductDetails.GetProductDetailsResponse": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "internalProductTypeId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "productStateId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "denomination": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "issuePrice": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "couponPct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "isin": {
            "type": "string",
            "nullable": true
          },
          "longName": {
            "type": "string",
            "nullable": true
          },
          "slug": {
            "type": "string",
            "nullable": true
          },
          "valor": {
            "type": "string",
            "nullable": true
          },
          "couponType": {
            "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.ProductHistory.GetProductDetails.Dtos.CouponTypeDto"
          },
          "couponPaymentType": {
            "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.ProductHistory.GetProductDetails.Dtos.CouponPaymentTypeDto"
          },
          "assetManager": {
            "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.ProductHistory.GetProductDetails.Dtos.IssuerDto"
          },
          "latestProductValuation": {
            "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.ProductHistory.GetProductDetails.Dtos.PriceDto"
          },
          "productManager": {
            "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.ProductHistory.GetProductDetails.Dtos.PartyDto"
          },
          "payingAgent": {
            "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.ProductHistory.GetProductDetails.Dtos.PartyDto"
          },
          "productOffering": {
            "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.ProductHistory.GetProductDetails.Dtos.ProductOfferingDto"
          },
          "earlyRedemption": {
            "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.ProductHistory.GetProductDetails.Dtos.EarlyRedemptionStateDto"
          },
          "paymentDate": {
            "type": "string",
            "format": "date-time"
          },
          "repaymentDate": {
            "type": "string",
            "format": "date-time"
          },
          "subscriptionEndDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "hasTermsheet": {
            "type": "boolean"
          },
          "availableDocuments": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.ProductHistory.GetProductDetails.Dtos.ProductDocumentDto"
            },
            "nullable": true
          },
          "distributionDetails": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.ProductHistory.GetProductDetails.Dtos.DistributorDto"
            },
            "nullable": true
          },
          "productHistory": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.AppWeb.Application.Features.ProductHistory.GetProductDetails.Dtos.ProductHistoryDto"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.ProductHistory.GetProductTermsheetDocuments.GetProductTermsheetDocumentsResponse": {
        "type": "object",
        "properties": {
          "file": {
            "type": "string",
            "format": "byte",
            "nullable": true
          },
          "productName": {
            "type": "string",
            "nullable": true
          },
          "fileExtension": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.ProductHistory.GetProductValuationHistory.GetProductValuationHistoryFileResponse": {
        "type": "object",
        "properties": {
          "file": {
            "type": "string",
            "format": "binary",
            "nullable": true
          },
          "filename": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.ProductHistory.GetProductValuationHistory.GetValuationHistoryDto": {
        "type": "object",
        "properties": {
          "valuationDate": {
            "type": "string",
            "format": "date"
          },
          "isin": {
            "type": "string",
            "nullable": true
          },
          "outstandingCertificates": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "grossNav": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "price": {
            "type": "number",
            "format": "double",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.Webhook.SaveWebhook.SaveWebHookRequest": {
        "type": "object",
        "properties": {
          "guid": {
            "type": "string",
            "nullable": true
          },
          "url": {
            "type": "string",
            "format": "uri",
            "nullable": true
          },
          "token": {
            "type": "string",
            "nullable": true
          },
          "events": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.EventTypeEnum"
            },
            "nullable": true
          },
          "isEnabled": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Application.Features.Webhook.TestWebhook.TestWebhookRequest": {
        "type": "object",
        "properties": {
          "guid": {
            "type": "string",
            "nullable": true
          },
          "url": {
            "type": "string",
            "format": "uri",
            "nullable": true
          },
          "token": {
            "type": "string",
            "nullable": true
          },
          "events": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.EventTypeEnum"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Controllers.QuarterliesApprovalController+InvoiceDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "invoicingSystem": {
            "type": "string",
            "nullable": true
          },
          "isin": {
            "type": "string",
            "nullable": true
          },
          "invoiceDate": {
            "type": "string",
            "format": "date-time"
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Controllers.QuarterliesApprovalController+QuarterlyFlowApprovalErrorType": {
        "enum": [
          1,
          2
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.AppWeb.Controllers.QuarterliesApprovalController+QuarterlyFlowApprovalResponse": {
        "type": "object",
        "properties": {
          "errorType": {
            "$ref": "#/components/schemas/g2fp.AppWeb.Controllers.QuarterliesApprovalController+QuarterlyFlowApprovalErrorType"
          },
          "errorMessage": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Controllers.QuarterliesApprovalController+QuarterlyFlowPaymentInstructionResponse": {
        "type": "object",
        "properties": {
          "quarterlyFlowId": {
            "type": "string",
            "nullable": true
          },
          "paymentInstructionLink": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Models.DropdownOption": {
        "type": "object",
        "properties": {
          "value": {
            "type": "integer",
            "format": "int32"
          },
          "label": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Models.DropdownOptions": {
        "type": "object",
        "properties": {
          "options": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.AppWeb.Models.DropdownOption"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Models.Flow.FlowProductListItemVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "isin": {
            "type": "string",
            "nullable": true
          },
          "longName": {
            "type": "string",
            "nullable": true
          },
          "couponTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.CouponTypeEnum"
          },
          "productStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductStateEnum"
          },
          "isFromSrfLite": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Models.ProductHub.TermsAndConditionsDocument": {
        "type": "object",
        "properties": {
          "type": {
            "type": "string",
            "nullable": true
          },
          "documentName": {
            "type": "string",
            "nullable": true
          },
          "downloadLink": {
            "type": "string",
            "nullable": true
          },
          "isSigned": {
            "type": "boolean"
          },
          "signUser": {
            "type": "string",
            "nullable": true
          },
          "signDateTime": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Models.StructuringRequest.AdditionalDocumentVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "description": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Models.StructuringRequest.CreateEntityInPortalResponse": {
        "type": "object",
        "properties": {
          "isSuccessful": {
            "type": "boolean"
          },
          "errorMessage": {
            "type": "string",
            "nullable": true
          },
          "entityId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "existingEntity": {
            "$ref": "#/components/schemas/g2fp.AppWeb.Models.StructuringRequest.CreateEntityInPortalResponse+EntityCreationResponse"
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Models.StructuringRequest.CreateEntityInPortalResponse+EntityCreationResponse": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string",
            "nullable": true
          },
          "address": {
            "type": "string",
            "nullable": true
          },
          "city": {
            "type": "string",
            "nullable": true
          },
          "postCode": {
            "type": "string",
            "nullable": true
          },
          "countryId": {
            "type": "integer",
            "format": "int32"
          },
          "legalSubjectTypeId": {
            "type": "integer",
            "format": "int32"
          },
          "notes": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Models.StructuringRequest.EntityCreationRequest": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string",
            "nullable": true
          },
          "address": {
            "type": "string",
            "nullable": true
          },
          "city": {
            "type": "string",
            "nullable": true
          },
          "postCode": {
            "type": "string",
            "nullable": true
          },
          "countryId": {
            "type": "integer",
            "format": "int32"
          },
          "legalSubjectTypeId": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Models.StructuringRequest.LegalSubjectTypeVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Models.StructuringRequest.ProductDueDiligenceDocumentDownloadResponse": {
        "type": "object",
        "properties": {
          "originalFileName": {
            "type": "string",
            "nullable": true
          },
          "content": {
            "type": "string",
            "format": "byte",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Models.StructuringRequest.ProductDueDiligenceEntityStatusVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "golemStatus": {
            "$ref": "#/components/schemas/g2fp.Models.PartyScreening.ScreeningStatus"
          },
          "golemUrl": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Models.StructuringRequest.ProductDueDiligenceProgressStatusEnum": {
        "enum": [
          1,
          2,
          3,
          4
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.AppWeb.Models.StructuringRequest.ProductDueDiligenceSubmitRequest": {
        "type": "object",
        "properties": {
          "pendingStatusId": {
            "$ref": "#/components/schemas/g2fp.AppWeb.Models.StructuringRequest.ProductDueDiligenceProgressStatusEnum"
          },
          "updatedEntitiesIds": {
            "type": "array",
            "items": {
              "type": "integer",
              "format": "int64"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Models.StructuringRequest.RequiredDocumentVm": {
        "type": "object",
        "properties": {
          "partyTypeId": {
            "type": "integer",
            "format": "int32"
          },
          "legalSubjectTypeId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "storedDocumentTypeId": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Models.StructuringRequest.RequiredDocumentsVm": {
        "type": "object",
        "properties": {
          "legalSubjects": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.AppWeb.Models.StructuringRequest.LegalSubjectTypeVm"
            },
            "nullable": true
          },
          "storedDocumentTypes": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.AppWeb.Models.StructuringRequest.StoredDocumentTypeVm"
            },
            "nullable": true
          },
          "requiredDocuments": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.AppWeb.Models.StructuringRequest.RequiredDocumentVm"
            },
            "nullable": true
          },
          "additionalDocuments": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.AppWeb.Models.StructuringRequest.AdditionalDocumentVm"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.AppWeb.Models.StructuringRequest.StoredDocumentTypeVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "isOptional": {
            "type": "boolean"
          },
          "isMultiple": {
            "type": "boolean"
          },
          "hasDate": {
            "type": "boolean"
          },
          "hasExpiry": {
            "type": "boolean"
          },
          "notOlderThanInMonths": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Application.Models.ProductListItemVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "isin": {
            "type": "string",
            "nullable": true
          },
          "longName": {
            "type": "string",
            "nullable": true
          },
          "paymentDate": {
            "type": "string",
            "format": "date-time"
          },
          "issuerName": {
            "type": "string",
            "nullable": true
          },
          "assetManagerId": {
            "type": "integer",
            "format": "int32"
          },
          "valor": {
            "type": "string",
            "nullable": true
          },
          "productStateId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "productState": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductState"
          },
          "internalProductTypeId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "valuationTypeId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "latestProductValuation": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.PriceDto"
          },
          "hasTermsheet": {
            "type": "boolean"
          },
          "isIspPayingAgent": {
            "type": "boolean"
          },
          "platformOwner": {
            "type": "string",
            "nullable": true
          },
          "platformOwnerAssignmentId": {
            "type": "string",
            "nullable": true
          },
          "productSponsorDisplay": {
            "type": "string",
            "nullable": true
          },
          "productSponsorAssignmentId": {
            "type": "string",
            "nullable": true
          },
          "productManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "productManagerAssignmentId": {
            "type": "string",
            "nullable": true
          },
          "numberOfRunningWorkflows": {
            "type": "integer",
            "format": "int32"
          },
          "externalProductStateHistory": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.ExternalProductStateHistoryVm"
            },
            "nullable": true
          },
          "showInvoices": {
            "type": "boolean"
          },
          "productDueDiligenceId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "srfVersion": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "hasAllowPotentialInvestorsOption": {
            "type": "boolean"
          },
          "terminationPrice": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "terminatedAt": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "latestOutstandingCertificate": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.OutstandingCertificatesVm"
          },
          "grossNav": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "distributionDetails": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppTwo.ProductHub.ProductDistributionDetailsVm"
          },
          "workflowInitiationBlockReasons": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.WorkflowInitiationBlockReason"
            },
            "nullable": true
          },
          "isVisibleOnDashboard": {
            "type": "boolean"
          },
          "productParties": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.Srf.ProductPartyVm"
            },
            "nullable": true
          },
          "productBelongsToIsp": {
            "type": "boolean"
          },
          "hasVestr": {
            "type": "boolean"
          },
          "isFromSrfLite": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Application.Models.ProductListVm": {
        "type": "object",
        "properties": {
          "products": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Application.Models.ProductListItemVm"
            },
            "nullable": true
          },
          "productStates": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductState"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Application.Services.ValuationHistoryDto": {
        "required": [
          "isin"
        ],
        "type": "object",
        "properties": {
          "valuationDate": {
            "type": "string",
            "format": "date"
          },
          "isin": {
            "type": "string",
            "nullable": true
          },
          "outstandingCertificates": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "grossNav": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "price": {
            "type": "number",
            "format": "double",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Infrastructure.Web.Controllers.WhoAmIDto": {
        "required": [
          "currentUserName"
        ],
        "type": "object",
        "properties": {
          "currentUserName": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Account.UserClaim": {
        "type": "object",
        "properties": {
          "type": {
            "type": "string",
            "nullable": true
          },
          "value": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Account.UserDto": {
        "required": [
          "email",
          "userName"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "userCompanyId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "firstName": {
            "type": "string",
            "nullable": true
          },
          "lastName": {
            "type": "string",
            "nullable": true
          },
          "userName": {
            "minLength": 1,
            "type": "string"
          },
          "email": {
            "minLength": 1,
            "type": "string"
          },
          "emailConfirmed": {
            "type": "boolean"
          },
          "notes": {
            "type": "string",
            "nullable": true
          },
          "registrationDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "lastLoginDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "lastChangedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "isDisabled": {
            "type": "boolean"
          },
          "isLockedOut": {
            "type": "boolean"
          },
          "roles": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "claims": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Account.UserClaim"
            },
            "nullable": true
          },
          "groups": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.FlowGroups"
            },
            "nullable": true
          },
          "userType": {
            "$ref": "#/components/schemas/g2fp.Models.Account.UserTypeEnum"
          },
          "gentwoContactId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "gentwoContact": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.GentwoContact"
          },
          "auditReferenceId": {
            "type": "integer",
            "format": "int32"
          },
          "returnRedirectURL": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Account.UserTypeEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.Api.DownloadBatchProcessingDto": {
        "type": "object",
        "properties": {
          "batchId": {
            "type": "string",
            "nullable": true
          },
          "paymentFlowsId": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Api.StructuringRequestDeleteStepsDto": {
        "type": "object",
        "properties": {
          "stepIds": {
            "type": "array",
            "items": {
              "type": "integer",
              "format": "int32"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Api.UpdateCurrentStepDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "currentStepId": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.BusinessCentral.BusinessCentralCompanyEnum": {
        "enum": [
          1,
          2
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.Communication.ContactUs": {
        "type": "object",
        "properties": {
          "firstName": {
            "type": "string",
            "nullable": true
          },
          "lastName": {
            "type": "string",
            "nullable": true
          },
          "email": {
            "type": "string",
            "nullable": true
          },
          "phoneNumber": {
            "type": "string",
            "nullable": true
          },
          "subject": {
            "type": "string",
            "nullable": true
          },
          "message": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Communication.ExtendedContactUs": {
        "type": "object",
        "properties": {
          "firstName": {
            "type": "string",
            "nullable": true
          },
          "lastName": {
            "type": "string",
            "nullable": true
          },
          "email": {
            "type": "string",
            "nullable": true
          },
          "phoneNumber": {
            "type": "string",
            "nullable": true
          },
          "subject": {
            "type": "string",
            "nullable": true
          },
          "message": {
            "type": "string",
            "nullable": true
          },
          "coreBusinessId": {
            "type": "integer",
            "format": "int32"
          },
          "countryId": {
            "type": "integer",
            "format": "int32"
          },
          "jobRole": {
            "type": "string",
            "nullable": true
          },
          "reCaptchaToken": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Connexor.Enums.ConnexorEventType": {
        "enum": [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.Dashboard.UserDashboardDto": {
        "type": "object",
        "properties": {
          "activePlatforms": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "newProductRequests": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Documents.SalesDocumentTypeDto": {
        "required": [
          "id",
          "isGenTwoDigitalDocumentType",
          "name"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "minLength": 1,
            "type": "string"
          },
          "isGenTwoDigitalDocumentType": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Dropbox.AppTwoDocumentEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
          32,
          33,
          34,
          35,
          36,
          37
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.Flow.CancelWorkflowDto": {
        "type": "object",
        "properties": {
          "jsonType": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "workflowId": {
            "type": "string",
            "nullable": true
          },
          "reason": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Flow.EntityApprovalFlow.InitiateEntityApprovalFlowEventDto": {
        "type": "object",
        "properties": {
          "jsonType": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "initiatorUserName": {
            "type": "string",
            "nullable": true
          },
          "assignAllToInitiator": {
            "type": "boolean"
          },
          "isin": {
            "type": "string",
            "nullable": true
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Flow.Flows.ApprovalFlowDto": {
        "required": [
          "initiatorUserName",
          "isin"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "initiatorUserName": {
            "minLength": 1,
            "type": "string"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "initiationTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "assignedUserGroupName": {
            "type": "string",
            "nullable": true
          },
          "assignAllToInitiator": {
            "type": "boolean"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isCancelled": {
            "type": "boolean"
          },
          "terminationReason": {
            "type": "string",
            "nullable": true
          },
          "terminationUserName": {
            "type": "string",
            "nullable": true
          },
          "terminationDateUtc": {
            "type": "string",
            "format": "date-time"
          },
          "pendingEvent": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
          },
          "pendingStage": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.StageDto"
          },
          "processedEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "allEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "isin": {
            "minLength": 1,
            "type": "string"
          },
          "workflowDisplayName": {
            "type": "string",
            "nullable": true
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "productName": {
            "type": "string",
            "nullable": true
          },
          "isFromSrfLite": {
            "type": "boolean"
          },
          "productStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductStateEnum"
          },
          "issuerDisplayName": {
            "type": "string",
            "nullable": true
          },
          "assetManager": {
            "type": "string",
            "nullable": true
          },
          "assetManagerEmail": {
            "type": "string",
            "nullable": true
          },
          "assetManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "issuerId": {
            "type": "integer",
            "format": "int32"
          },
          "companyId": {
            "type": "integer",
            "format": "int32"
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "valuationTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ValuationTypeEnum"
          },
          "payingAgentCompany": {
            "type": "string",
            "nullable": true
          },
          "payingAgentDisplay": {
            "type": "string",
            "nullable": true
          },
          "payingAgentAccountNumber": {
            "type": "string",
            "nullable": true
          },
          "payingAgentMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "payingAgentTradingMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productManagerCompany": {
            "type": "string",
            "nullable": true
          },
          "productManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "productManagerMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productRequestorCompany": {
            "type": "string",
            "nullable": true
          },
          "productRequestorDisplay": {
            "type": "string",
            "nullable": true
          },
          "productRequestorMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "isCellularProduct": {
            "type": "boolean"
          },
          "cellName": {
            "type": "string",
            "nullable": true
          },
          "subscriptionEndDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "paymentDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "productOfferingId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "jsonType": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "directorOfIssuerCompany": {
            "type": "string",
            "nullable": true
          },
          "directorOfIssuerDisplay": {
            "type": "string",
            "nullable": true
          },
          "parentWorkflowId": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "reportBackEventGuid": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "currentStep": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.ApprovalFlowSteps"
          },
          "party": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.PartyTypeEnum"
          },
          "isGenTwoApproved": {
            "type": "boolean"
          },
          "isCounterpartyApproved": {
            "type": "boolean"
          },
          "shouldSignSubRelationForm": {
            "type": "boolean"
          },
          "signedSubRelationFormGuid": {
            "type": "string",
            "nullable": true
          },
          "counterpartyDisplay": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "counterpartyName": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Flow.Flows.ApprovalFlowSteps": {
        "enum": [
          0,
          1,
          2,
          4,
          5
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.Flow.Flows.AssetDataUpdateFlowDto": {
        "required": [
          "initiatorUserName",
          "isin"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "initiatorUserName": {
            "minLength": 1,
            "type": "string"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "initiationTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "assignedUserGroupName": {
            "type": "string",
            "nullable": true
          },
          "assignAllToInitiator": {
            "type": "boolean"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isCancelled": {
            "type": "boolean"
          },
          "terminationReason": {
            "type": "string",
            "nullable": true
          },
          "terminationUserName": {
            "type": "string",
            "nullable": true
          },
          "terminationDateUtc": {
            "type": "string",
            "format": "date-time"
          },
          "pendingEvent": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
          },
          "pendingStage": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.StageDto"
          },
          "processedEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "allEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "isin": {
            "minLength": 1,
            "type": "string"
          },
          "workflowDisplayName": {
            "type": "string",
            "nullable": true
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "productName": {
            "type": "string",
            "nullable": true
          },
          "isFromSrfLite": {
            "type": "boolean"
          },
          "productStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductStateEnum"
          },
          "issuerDisplayName": {
            "type": "string",
            "nullable": true
          },
          "assetManager": {
            "type": "string",
            "nullable": true
          },
          "assetManagerEmail": {
            "type": "string",
            "nullable": true
          },
          "assetManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "issuerId": {
            "type": "integer",
            "format": "int32"
          },
          "companyId": {
            "type": "integer",
            "format": "int32"
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "valuationTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ValuationTypeEnum"
          },
          "payingAgentCompany": {
            "type": "string",
            "nullable": true
          },
          "payingAgentDisplay": {
            "type": "string",
            "nullable": true
          },
          "payingAgentAccountNumber": {
            "type": "string",
            "nullable": true
          },
          "payingAgentMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "payingAgentTradingMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productManagerCompany": {
            "type": "string",
            "nullable": true
          },
          "productManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "productManagerMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productRequestorCompany": {
            "type": "string",
            "nullable": true
          },
          "productRequestorDisplay": {
            "type": "string",
            "nullable": true
          },
          "productRequestorMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "isCellularProduct": {
            "type": "boolean"
          },
          "cellName": {
            "type": "string",
            "nullable": true
          },
          "subscriptionEndDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "paymentDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "productOfferingId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "jsonType": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "directorOfIssuerCompany": {
            "type": "string",
            "nullable": true
          },
          "directorOfIssuerDisplay": {
            "type": "string",
            "nullable": true
          },
          "parentWorkflowId": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "reportBackEventGuid": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "currentStep": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.AssetDataUpdateFlowSteps"
          },
          "underlyingTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.UnderlyingTypeEnum"
          },
          "underlyingTypeName": {
            "type": "string",
            "nullable": true
          },
          "underlyingId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "underlying": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Underlying"
          },
          "underlyingAssetName": {
            "type": "string",
            "nullable": true
          },
          "assetBalanceTotal": {
            "type": "number",
            "format": "double"
          },
          "assetBalanceCurrency": {
            "type": "string",
            "nullable": true
          },
          "underlyingRevaluationDate": {
            "type": "string",
            "format": "date-time"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Flow.Flows.AssetDataUpdateFlowSteps": {
        "enum": [
          0,
          1,
          2,
          3
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.Flow.Flows.BaseFlowDto": {
        "required": [
          "initiatorUserName",
          "isin"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "initiatorUserName": {
            "minLength": 1,
            "type": "string"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "initiationTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "assignedUserGroupName": {
            "type": "string",
            "nullable": true
          },
          "assignAllToInitiator": {
            "type": "boolean"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isCancelled": {
            "type": "boolean"
          },
          "terminationReason": {
            "type": "string",
            "nullable": true
          },
          "terminationUserName": {
            "type": "string",
            "nullable": true
          },
          "terminationDateUtc": {
            "type": "string",
            "format": "date-time"
          },
          "pendingEvent": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
          },
          "pendingStage": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.StageDto"
          },
          "processedEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "allEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "isin": {
            "minLength": 1,
            "type": "string"
          },
          "workflowDisplayName": {
            "type": "string",
            "nullable": true
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "productName": {
            "type": "string",
            "nullable": true
          },
          "isFromSrfLite": {
            "type": "boolean"
          },
          "productStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductStateEnum"
          },
          "issuerDisplayName": {
            "type": "string",
            "nullable": true
          },
          "assetManager": {
            "type": "string",
            "nullable": true
          },
          "assetManagerEmail": {
            "type": "string",
            "nullable": true
          },
          "assetManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "issuerId": {
            "type": "integer",
            "format": "int32"
          },
          "companyId": {
            "type": "integer",
            "format": "int32"
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "valuationTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ValuationTypeEnum"
          },
          "payingAgentCompany": {
            "type": "string",
            "nullable": true
          },
          "payingAgentDisplay": {
            "type": "string",
            "nullable": true
          },
          "payingAgentAccountNumber": {
            "type": "string",
            "nullable": true
          },
          "payingAgentMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "payingAgentTradingMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productManagerCompany": {
            "type": "string",
            "nullable": true
          },
          "productManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "productManagerMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productRequestorCompany": {
            "type": "string",
            "nullable": true
          },
          "productRequestorDisplay": {
            "type": "string",
            "nullable": true
          },
          "productRequestorMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "isCellularProduct": {
            "type": "boolean"
          },
          "cellName": {
            "type": "string",
            "nullable": true
          },
          "subscriptionEndDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "paymentDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "productOfferingId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "jsonType": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "directorOfIssuerCompany": {
            "type": "string",
            "nullable": true
          },
          "directorOfIssuerDisplay": {
            "type": "string",
            "nullable": true
          },
          "parentWorkflowId": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "reportBackEventGuid": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Flow.Flows.BatchPayment.BatchPaymentFlowDto+InitiateBatchPaymentFlowWfCoreDto": {
        "type": "object",
        "properties": {
          "jsonType": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "initiatorUserName": {
            "type": "string",
            "nullable": true
          },
          "assignAllToInitiator": {
            "type": "boolean"
          },
          "isin": {
            "type": "string",
            "nullable": true
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "party": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.PartyEnum"
          },
          "paymentInstructionIds": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Flow.Flows.CouponFlowDto+InitiateCouponFlowDto": {
        "type": "object",
        "properties": {
          "jsonType": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "initiatorUserName": {
            "type": "string",
            "nullable": true
          },
          "assignAllToInitiator": {
            "type": "boolean"
          },
          "isin": {
            "type": "string",
            "nullable": true
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "couponTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.CouponTypeEnum"
          },
          "discretionaryInterestRate": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "fixedInterestRate": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "variableInterestRate": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "paymentFrequencyId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "currency": {
            "type": "string",
            "nullable": true
          },
          "denomination": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "totalAmount": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "amountPerNote": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "outstandingsEntitled": {
            "type": "integer",
            "format": "int32"
          },
          "isPACashAccountFunded": {
            "type": "boolean"
          },
          "paCashAccountBalance": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "executionDate": {
            "type": "string",
            "format": "date"
          },
          "attachedFilesGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "paymentDate": {
            "type": "string",
            "format": "date"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Flow.Flows.EventDto": {
        "type": "object",
        "properties": {
          "jsonType": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "assignedUserGroupName": {
            "type": "string",
            "nullable": true
          },
          "assignedUserGroupDisplay": {
            "type": "string",
            "nullable": true
          },
          "completedBy": {
            "type": "string",
            "nullable": true
          },
          "completedOn": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "eventId": {
            "type": "string",
            "nullable": true
          },
          "eventDescription": {
            "type": "string",
            "nullable": true
          },
          "eventDisplay": {
            "type": "string",
            "nullable": true
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "eventData": {
            "nullable": true
          },
          "assignedDateUtc": {
            "type": "string",
            "format": "date-time"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Flow.Flows.G24BProductOpeningFlowDto": {
        "required": [
          "initiatorUserName",
          "isin"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "initiatorUserName": {
            "minLength": 1,
            "type": "string"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "initiationTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "assignedUserGroupName": {
            "type": "string",
            "nullable": true
          },
          "assignAllToInitiator": {
            "type": "boolean"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isCancelled": {
            "type": "boolean"
          },
          "terminationReason": {
            "type": "string",
            "nullable": true
          },
          "terminationUserName": {
            "type": "string",
            "nullable": true
          },
          "terminationDateUtc": {
            "type": "string",
            "format": "date-time"
          },
          "pendingEvent": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
          },
          "pendingStage": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.StageDto"
          },
          "processedEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "allEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "isin": {
            "minLength": 1,
            "type": "string"
          },
          "workflowDisplayName": {
            "type": "string",
            "nullable": true
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "productName": {
            "type": "string",
            "nullable": true
          },
          "isFromSrfLite": {
            "type": "boolean"
          },
          "productStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductStateEnum"
          },
          "issuerDisplayName": {
            "type": "string",
            "nullable": true
          },
          "assetManager": {
            "type": "string",
            "nullable": true
          },
          "assetManagerEmail": {
            "type": "string",
            "nullable": true
          },
          "assetManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "issuerId": {
            "type": "integer",
            "format": "int32"
          },
          "companyId": {
            "type": "integer",
            "format": "int32"
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "valuationTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ValuationTypeEnum"
          },
          "payingAgentCompany": {
            "type": "string",
            "nullable": true
          },
          "payingAgentDisplay": {
            "type": "string",
            "nullable": true
          },
          "payingAgentAccountNumber": {
            "type": "string",
            "nullable": true
          },
          "payingAgentMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "payingAgentTradingMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productManagerCompany": {
            "type": "string",
            "nullable": true
          },
          "productManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "productManagerMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productRequestorCompany": {
            "type": "string",
            "nullable": true
          },
          "productRequestorDisplay": {
            "type": "string",
            "nullable": true
          },
          "productRequestorMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "isCellularProduct": {
            "type": "boolean"
          },
          "cellName": {
            "type": "string",
            "nullable": true
          },
          "subscriptionEndDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "paymentDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "productOfferingId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "jsonType": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "directorOfIssuerCompany": {
            "type": "string",
            "nullable": true
          },
          "directorOfIssuerDisplay": {
            "type": "string",
            "nullable": true
          },
          "parentWorkflowId": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "reportBackEventGuid": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "cancellationEventKey": {
            "type": "string",
            "nullable": true
          },
          "cancellationReason": {
            "type": "string",
            "nullable": true
          },
          "currentStep": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.G24BProductOpeningFlowDto+G24BProductOpeningFlowSteps"
          },
          "isDirectorGenTwo": {
            "type": "boolean"
          },
          "productTermsheetDocumentGuid": {
            "type": "string",
            "nullable": true
          },
          "productDiagramDocumentGuid": {
            "type": "string",
            "nullable": true
          },
          "bcSideLetterGuid": {
            "type": "string",
            "nullable": true
          },
          "signedBCSideLetterGuid": {
            "type": "string",
            "nullable": true
          },
          "bcAccountOpeningFormGuid": {
            "type": "string",
            "nullable": true
          },
          "signedBCAccountOpeningFormGuid": {
            "type": "string",
            "nullable": true
          },
          "paSideLetterGuid": {
            "type": "string",
            "nullable": true
          },
          "signedPASideLetterGuid": {
            "type": "string",
            "nullable": true
          },
          "signedBoardResolutionGuid": {
            "type": "string",
            "nullable": true
          },
          "payingAgentAccountId": {
            "type": "string",
            "nullable": true
          },
          "custodianAccountId": {
            "type": "string",
            "nullable": true
          },
          "custodianAccountIban": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Flow.Flows.G24BProductOpeningFlowDto+G24BProductOpeningFlowSteps": {
        "enum": [
          0,
          1,
          2,
          3,
          4
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.Flow.Flows.G24BProductOpeningFlowDto+InitiateG24BProductOpeningDto": {
        "type": "object",
        "properties": {
          "jsonType": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "initiatorUserName": {
            "type": "string",
            "nullable": true
          },
          "assignAllToInitiator": {
            "type": "boolean"
          },
          "isin": {
            "type": "string",
            "nullable": true
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "productTermsheetDocumentGuid": {
            "type": "string",
            "nullable": true
          },
          "productDiagramDocumentGuid": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Flow.Flows.InitiatePartialRedemptionEventFlowDto": {
        "type": "object",
        "properties": {
          "jsonType": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "initiatorUserName": {
            "type": "string",
            "nullable": true
          },
          "assignAllToInitiator": {
            "type": "boolean"
          },
          "isin": {
            "type": "string",
            "nullable": true
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "redemptionAmount": {
            "type": "number",
            "format": "double"
          },
          "currentDenomination": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "isProductCLN": {
            "type": "boolean"
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "productName": {
            "type": "string",
            "nullable": true
          },
          "isChangeOfDenomination": {
            "type": "boolean"
          },
          "latestOutstandingCertificates": {
            "type": "integer",
            "format": "int32"
          },
          "expectedRedemptionDate": {
            "type": "string",
            "format": "date-time"
          },
          "isPACashAccountFunded": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Flow.Flows.InitiateProductApprovalProcessFlowEventDto": {
        "type": "object",
        "properties": {
          "jsonType": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "initiatorUserName": {
            "type": "string",
            "nullable": true
          },
          "assignAllToInitiator": {
            "type": "boolean"
          },
          "isin": {
            "type": "string",
            "nullable": true
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "shouldRunPayingAgentApproval": {
            "type": "boolean"
          },
          "shouldRunIssuerApproval": {
            "type": "boolean"
          },
          "isSubrelationDocumentRequired": {
            "type": "boolean"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Flow.Flows.IspSecondaryChangeFlowDto+IspSecondaryChangeFlowSteps": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5,
          6
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.Flow.Flows.PartialRedemptionEventFlowDto+PartialRedemptionEventFlowSteps": {
        "enum": [
          1,
          2,
          3,
          4,
          5,
          6
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.Flow.Flows.PartialRedemptionEventFlowV2Dto": {
        "required": [
          "initiatorUserName",
          "isin"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "initiatorUserName": {
            "minLength": 1,
            "type": "string"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "initiationTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "assignedUserGroupName": {
            "type": "string",
            "nullable": true
          },
          "assignAllToInitiator": {
            "type": "boolean"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isCancelled": {
            "type": "boolean"
          },
          "terminationReason": {
            "type": "string",
            "nullable": true
          },
          "terminationUserName": {
            "type": "string",
            "nullable": true
          },
          "terminationDateUtc": {
            "type": "string",
            "format": "date-time"
          },
          "pendingEvent": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
          },
          "pendingStage": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.StageDto"
          },
          "processedEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "allEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "isin": {
            "minLength": 1,
            "type": "string"
          },
          "workflowDisplayName": {
            "type": "string",
            "nullable": true
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "productName": {
            "type": "string",
            "nullable": true
          },
          "isFromSrfLite": {
            "type": "boolean"
          },
          "productStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductStateEnum"
          },
          "issuerDisplayName": {
            "type": "string",
            "nullable": true
          },
          "assetManager": {
            "type": "string",
            "nullable": true
          },
          "assetManagerEmail": {
            "type": "string",
            "nullable": true
          },
          "assetManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "issuerId": {
            "type": "integer",
            "format": "int32"
          },
          "companyId": {
            "type": "integer",
            "format": "int32"
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "valuationTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ValuationTypeEnum"
          },
          "payingAgentCompany": {
            "type": "string",
            "nullable": true
          },
          "payingAgentDisplay": {
            "type": "string",
            "nullable": true
          },
          "payingAgentAccountNumber": {
            "type": "string",
            "nullable": true
          },
          "payingAgentMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "payingAgentTradingMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productManagerCompany": {
            "type": "string",
            "nullable": true
          },
          "productManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "productManagerMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productRequestorCompany": {
            "type": "string",
            "nullable": true
          },
          "productRequestorDisplay": {
            "type": "string",
            "nullable": true
          },
          "productRequestorMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "isCellularProduct": {
            "type": "boolean"
          },
          "cellName": {
            "type": "string",
            "nullable": true
          },
          "subscriptionEndDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "paymentDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "productOfferingId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "jsonType": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "directorOfIssuerCompany": {
            "type": "string",
            "nullable": true
          },
          "directorOfIssuerDisplay": {
            "type": "string",
            "nullable": true
          },
          "parentWorkflowId": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "reportBackEventGuid": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "currentStep": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.PartialRedemptionEventFlowDto+PartialRedemptionEventFlowSteps"
          },
          "currentDenomination": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "redemptionAmount": {
            "type": "number",
            "format": "double"
          },
          "amountPerNote": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "newDenomination": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "latestOutstandingCertificates": {
            "type": "integer",
            "format": "int32"
          },
          "isChangeOfDenomination": {
            "type": "boolean"
          },
          "expectedRedemptionDate": {
            "type": "string",
            "format": "date-time"
          },
          "isPACashAccountFunded": {
            "type": "boolean"
          },
          "settlementType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.SettlementType"
          },
          "earlyRedemptionState": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.EarlyRedemptionState"
          },
          "cancellationEventKey": {
            "type": "string",
            "nullable": true
          },
          "cancellationReason": {
            "type": "string",
            "nullable": true
          },
          "grossNav": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "isProductCLN": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Flow.Flows.PayingAgentAccountOpeningFlowDto": {
        "required": [
          "initiatorUserName",
          "isin"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "initiatorUserName": {
            "minLength": 1,
            "type": "string"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "initiationTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "assignedUserGroupName": {
            "type": "string",
            "nullable": true
          },
          "assignAllToInitiator": {
            "type": "boolean"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isCancelled": {
            "type": "boolean"
          },
          "terminationReason": {
            "type": "string",
            "nullable": true
          },
          "terminationUserName": {
            "type": "string",
            "nullable": true
          },
          "terminationDateUtc": {
            "type": "string",
            "format": "date-time"
          },
          "pendingEvent": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
          },
          "pendingStage": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.StageDto"
          },
          "processedEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "allEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "isin": {
            "minLength": 1,
            "type": "string"
          },
          "workflowDisplayName": {
            "type": "string",
            "nullable": true
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "productName": {
            "type": "string",
            "nullable": true
          },
          "isFromSrfLite": {
            "type": "boolean"
          },
          "productStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductStateEnum"
          },
          "issuerDisplayName": {
            "type": "string",
            "nullable": true
          },
          "assetManager": {
            "type": "string",
            "nullable": true
          },
          "assetManagerEmail": {
            "type": "string",
            "nullable": true
          },
          "assetManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "issuerId": {
            "type": "integer",
            "format": "int32"
          },
          "companyId": {
            "type": "integer",
            "format": "int32"
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "valuationTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ValuationTypeEnum"
          },
          "payingAgentCompany": {
            "type": "string",
            "nullable": true
          },
          "payingAgentDisplay": {
            "type": "string",
            "nullable": true
          },
          "payingAgentAccountNumber": {
            "type": "string",
            "nullable": true
          },
          "payingAgentMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "payingAgentTradingMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productManagerCompany": {
            "type": "string",
            "nullable": true
          },
          "productManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "productManagerMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productRequestorCompany": {
            "type": "string",
            "nullable": true
          },
          "productRequestorDisplay": {
            "type": "string",
            "nullable": true
          },
          "productRequestorMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "isCellularProduct": {
            "type": "boolean"
          },
          "cellName": {
            "type": "string",
            "nullable": true
          },
          "subscriptionEndDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "paymentDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "productOfferingId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "jsonType": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "directorOfIssuerCompany": {
            "type": "string",
            "nullable": true
          },
          "directorOfIssuerDisplay": {
            "type": "string",
            "nullable": true
          },
          "parentWorkflowId": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "reportBackEventGuid": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "isIssuerPayingAgentAccountOpening": {
            "type": "boolean"
          },
          "isProductPayingAgentAccountOpening": {
            "type": "boolean"
          },
          "isBrokerCustodianAccountOpening": {
            "type": "boolean"
          },
          "isGuernseyNonCellular": {
            "type": "boolean"
          },
          "newIssuerPayingAgentAccountNumber": {
            "type": "string",
            "nullable": true
          },
          "cancellationEventKey": {
            "type": "string",
            "nullable": true
          },
          "cancellationReason": {
            "type": "string",
            "nullable": true
          },
          "generatedInfoPackDocumentsGuid": {
            "type": "string",
            "nullable": true
          },
          "infoPackDocumentsGenerationSuccess": {
            "type": "boolean"
          },
          "infoPackDocumentsGenerationErrors": {
            "type": "object",
            "additionalProperties": {
              "type": "string",
              "nullable": true
            },
            "nullable": true
          },
          "generatedDocumentsToSign": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "documentsToSignGenerationSuccess": {
            "type": "boolean"
          },
          "documentsToSignGenerationErrors": {
            "type": "object",
            "additionalProperties": {
              "type": "string",
              "nullable": true
            },
            "nullable": true
          },
          "generatedDocumentsToAcknowledge": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "documentsToAcknowledgeGenerationSuccess": {
            "type": "boolean"
          },
          "documentsToAcknowledgeGenerationErrors": {
            "type": "object",
            "additionalProperties": {
              "type": "string",
              "nullable": true
            },
            "nullable": true
          },
          "newProductPayingAgentAccountDetails": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.PayingAgentAccountOpeningFlowDto+AccountOpeningEntryDto"
          },
          "newBrokerCustodianAccountDetails": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.PayingAgentAccountOpeningFlowDto+AccountOpeningEntryDto"
          },
          "newProductPayingAgentAccountId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "newBrokerCustodianAccountId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "newIssuerPayingAgentAccountId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Flow.Flows.PayingAgentAccountOpeningFlowDto+AccountDeposit": {
        "type": "object",
        "properties": {
          "accountNumber": {
            "type": "string",
            "nullable": true
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Flow.Flows.PayingAgentAccountOpeningFlowDto+AccountOpeningEntryDto": {
        "type": "object",
        "properties": {
          "accountNumber": {
            "type": "string",
            "nullable": true
          },
          "iban": {
            "type": "string",
            "nullable": true
          },
          "accountName": {
            "type": "string",
            "nullable": true
          },
          "deposits": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.PayingAgentAccountOpeningFlowDto+AccountDeposit"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Flow.Flows.PrimaryBookingRequestFlowSteps": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.Flow.Flows.ProductApprovalProcessFlowDto": {
        "required": [
          "initiatorUserName",
          "isin"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "initiatorUserName": {
            "minLength": 1,
            "type": "string"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "initiationTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "assignedUserGroupName": {
            "type": "string",
            "nullable": true
          },
          "assignAllToInitiator": {
            "type": "boolean"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isCancelled": {
            "type": "boolean"
          },
          "terminationReason": {
            "type": "string",
            "nullable": true
          },
          "terminationUserName": {
            "type": "string",
            "nullable": true
          },
          "terminationDateUtc": {
            "type": "string",
            "format": "date-time"
          },
          "pendingEvent": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
          },
          "pendingStage": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.StageDto"
          },
          "processedEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "allEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "isin": {
            "minLength": 1,
            "type": "string"
          },
          "workflowDisplayName": {
            "type": "string",
            "nullable": true
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "productName": {
            "type": "string",
            "nullable": true
          },
          "isFromSrfLite": {
            "type": "boolean"
          },
          "productStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductStateEnum"
          },
          "issuerDisplayName": {
            "type": "string",
            "nullable": true
          },
          "assetManager": {
            "type": "string",
            "nullable": true
          },
          "assetManagerEmail": {
            "type": "string",
            "nullable": true
          },
          "assetManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "issuerId": {
            "type": "integer",
            "format": "int32"
          },
          "companyId": {
            "type": "integer",
            "format": "int32"
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "valuationTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ValuationTypeEnum"
          },
          "payingAgentCompany": {
            "type": "string",
            "nullable": true
          },
          "payingAgentDisplay": {
            "type": "string",
            "nullable": true
          },
          "payingAgentAccountNumber": {
            "type": "string",
            "nullable": true
          },
          "payingAgentMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "payingAgentTradingMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productManagerCompany": {
            "type": "string",
            "nullable": true
          },
          "productManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "productManagerMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productRequestorCompany": {
            "type": "string",
            "nullable": true
          },
          "productRequestorDisplay": {
            "type": "string",
            "nullable": true
          },
          "productRequestorMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "isCellularProduct": {
            "type": "boolean"
          },
          "cellName": {
            "type": "string",
            "nullable": true
          },
          "subscriptionEndDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "paymentDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "productOfferingId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "jsonType": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "directorOfIssuerCompany": {
            "type": "string",
            "nullable": true
          },
          "directorOfIssuerDisplay": {
            "type": "string",
            "nullable": true
          },
          "parentWorkflowId": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "reportBackEventGuid": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "shouldRunPayingAgentApproval": {
            "type": "boolean"
          },
          "shouldRunIssuerApproval": {
            "type": "boolean"
          },
          "shouldSignSubRelationForm": {
            "type": "boolean"
          },
          "isSubrelationDocumentRequired": {
            "type": "boolean"
          },
          "payingAgentApproved": {
            "type": "boolean"
          },
          "directorOfIssuerApproved": {
            "type": "boolean"
          },
          "shouldRunIssuerIncoreAccountOpening": {
            "type": "boolean"
          },
          "shouldRunIncoreAccountOpening": {
            "type": "boolean"
          },
          "cancellationEventKey": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "cancellationReason": {
            "type": "string",
            "nullable": true
          },
          "shouldRunBrokerCustodianAccountOpening": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Flow.Flows.ProductIssuanceFlowSteps": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.Flow.Flows.ProductTerminationFlow.InitiateProductTerminationFlowDto": {
        "type": "object",
        "properties": {
          "jsonType": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "initiatorUserName": {
            "type": "string",
            "nullable": true
          },
          "assignAllToInitiator": {
            "type": "boolean"
          },
          "isin": {
            "type": "string",
            "nullable": true
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "terminationDate": {
            "type": "string",
            "format": "date-time"
          },
          "taxFillingDeclaration": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Flow.Flows.ProductTerminationFlow.ProductTerminationFlowDto": {
        "required": [
          "initiatorUserName",
          "isin"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "initiatorUserName": {
            "minLength": 1,
            "type": "string"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "initiationTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "assignedUserGroupName": {
            "type": "string",
            "nullable": true
          },
          "assignAllToInitiator": {
            "type": "boolean"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isCancelled": {
            "type": "boolean"
          },
          "terminationReason": {
            "type": "string",
            "nullable": true
          },
          "terminationUserName": {
            "type": "string",
            "nullable": true
          },
          "terminationDateUtc": {
            "type": "string",
            "format": "date-time"
          },
          "pendingEvent": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
          },
          "pendingStage": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.StageDto"
          },
          "processedEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "allEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "isin": {
            "minLength": 1,
            "type": "string"
          },
          "workflowDisplayName": {
            "type": "string",
            "nullable": true
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "productName": {
            "type": "string",
            "nullable": true
          },
          "isFromSrfLite": {
            "type": "boolean"
          },
          "productStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductStateEnum"
          },
          "issuerDisplayName": {
            "type": "string",
            "nullable": true
          },
          "assetManager": {
            "type": "string",
            "nullable": true
          },
          "assetManagerEmail": {
            "type": "string",
            "nullable": true
          },
          "assetManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "issuerId": {
            "type": "integer",
            "format": "int32"
          },
          "companyId": {
            "type": "integer",
            "format": "int32"
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "valuationTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ValuationTypeEnum"
          },
          "payingAgentCompany": {
            "type": "string",
            "nullable": true
          },
          "payingAgentDisplay": {
            "type": "string",
            "nullable": true
          },
          "payingAgentAccountNumber": {
            "type": "string",
            "nullable": true
          },
          "payingAgentMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "payingAgentTradingMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productManagerCompany": {
            "type": "string",
            "nullable": true
          },
          "productManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "productManagerMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productRequestorCompany": {
            "type": "string",
            "nullable": true
          },
          "productRequestorDisplay": {
            "type": "string",
            "nullable": true
          },
          "productRequestorMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "isCellularProduct": {
            "type": "boolean"
          },
          "cellName": {
            "type": "string",
            "nullable": true
          },
          "subscriptionEndDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "paymentDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "productOfferingId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "jsonType": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "directorOfIssuerCompany": {
            "type": "string",
            "nullable": true
          },
          "directorOfIssuerDisplay": {
            "type": "string",
            "nullable": true
          },
          "parentWorkflowId": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "reportBackEventGuid": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "terminationDate": {
            "type": "string",
            "format": "date-time"
          },
          "accountFunded": {
            "type": "boolean"
          },
          "accruedFees": {
            "type": "number",
            "format": "double"
          },
          "outstandingNotes": {
            "type": "number",
            "format": "double"
          },
          "redemptionAmount": {
            "type": "number",
            "format": "double"
          },
          "terminationNAV": {
            "type": "number",
            "format": "double"
          },
          "valueDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "residualAmount": {
            "type": "number",
            "format": "double"
          },
          "closedAtExchange": {
            "type": "boolean"
          },
          "cancellationEventKey": {
            "type": "string",
            "nullable": true
          },
          "cancellationReason": {
            "type": "string",
            "nullable": true
          },
          "taxFillingTypes": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.ProductTerminationFlow.ProductTerminationFlowDto+TaxFilling"
            },
            "nullable": true
          },
          "g2ProductAccountsToCloseWith": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Relations.ProductAccount"
            },
            "nullable": true
          },
          "g2DProductPartiesToCloseWith": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductParty"
            },
            "nullable": true
          },
          "currentStep": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.ProductTerminationFlow.ProductTerminationFlowDto+ProductTerminationFlowSteps"
          },
          "instructionLetterSentToAllProductAccountsAndPartiesChecked": {
            "type": "boolean"
          },
          "taxFillingDeclaration": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Flow.Flows.ProductTerminationFlow.ProductTerminationFlowDto+ProductTerminationFlowSteps": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.Flow.Flows.ProductTerminationFlow.ProductTerminationFlowDto+TaxFilling": {
        "enum": [
          0,
          1,
          2
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.Flow.Flows.StageDto": {
        "type": "object",
        "properties": {
          "stageName": {
            "type": "string",
            "nullable": true
          },
          "pendingEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Flow.Flows.SubscriptionEntryDto": {
        "required": [
          "counterparty",
          "issuePrice",
          "notes"
        ],
        "type": "object",
        "properties": {
          "counterparty": {
            "minLength": 1,
            "type": "string"
          },
          "notes": {
            "type": "number",
            "format": "double"
          },
          "issuePrice": {
            "type": "number",
            "format": "double"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "distributionFee": {
            "type": "number",
            "format": "double"
          },
          "distributionAgent": {
            "type": "string",
            "nullable": true
          },
          "distributionFeeValueType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.FeeFormEnum"
          },
          "spread": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "spreadValueType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.FeeFormEnum"
          },
          "lateInvestorInterest": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "lateInvestorInterestValueType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.FeeFormEnum"
          },
          "penaltyFee": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "penaltyFeeValueType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.FeeFormEnum"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Flow.ReassignFlowDto": {
        "required": [
          "assignee",
          "workflowId"
        ],
        "type": "object",
        "properties": {
          "workflowId": {
            "minLength": 1,
            "type": "string"
          },
          "assignee": {
            "minLength": 1,
            "type": "string"
          },
          "eventId": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Flow.WorkflowCoreShadowDto.WorkflowInstanceDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "workflowDefinitionId": {
            "type": "string",
            "nullable": true
          },
          "version": {
            "type": "integer",
            "format": "int32"
          },
          "status": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.WorkflowCoreShadowDto.WorkflowStatusEnum"
          },
          "data": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.BaseFlowDto"
          },
          "createTime": {
            "type": "string",
            "format": "date-time"
          },
          "completeTime": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Flow.WorkflowCoreShadowDto.WorkflowStatusEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.Flow.WorkflowPagingAndFilteringDto+SortingOrder": {
        "enum": [
          1,
          -1
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.Flow.WorkflowTypesCountDto": {
        "type": "object",
        "properties": {
          "workflowDisplayName": {
            "type": "string",
            "nullable": true
          },
          "workflowDefinitionId": {
            "type": "string",
            "nullable": true
          },
          "count": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.AccountType": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.AmortisationPeriod": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.AmortisationPeriodEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.AnnualFee": {
        "type": "object",
        "properties": {
          "fees": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.FeeLite"
            },
            "nullable": true
          },
          "lastYearAUS": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "lastMonthAUS": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "lastYearFeePaid": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "lastYearAUSClient": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "lastMonthAUSClient": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "isPunctual": {
            "type": "boolean"
          },
          "discount": {
            "type": "number",
            "format": "double"
          },
          "invoiceId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "businessCentralInvoiceId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.AssetBalanceFormat": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.AssetClassType": {
        "required": [
          "hubSpotId",
          "name"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "minLength": 1,
            "type": "string"
          },
          "hubSpotId": {
            "minLength": 1,
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.BankAccount": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "accountTypeId": {
            "type": "integer",
            "format": "int32"
          },
          "accountType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.AccountType"
          },
          "externalAccountId": {
            "type": "string",
            "nullable": true
          },
          "internalAccountName": {
            "type": "string",
            "nullable": true
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "partyId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "party": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Party"
          },
          "partyDescription": {
            "type": "string",
            "nullable": true
          },
          "iban": {
            "type": "string",
            "nullable": true
          },
          "accountNumber": {
            "type": "string",
            "nullable": true
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "swiftBic": {
            "type": "string",
            "nullable": true
          },
          "intermediarySwift": {
            "type": "string",
            "nullable": true
          },
          "intermediaryBankName": {
            "type": "string",
            "nullable": true
          },
          "intermediaryBankAddress": {
            "type": "string",
            "nullable": true
          },
          "bankName": {
            "type": "string",
            "nullable": true
          },
          "bankAddress": {
            "type": "string",
            "nullable": true
          },
          "bankCountryId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "accountName": {
            "type": "string",
            "nullable": true
          },
          "accountAddress": {
            "type": "string",
            "nullable": true
          },
          "accountCountryId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "accountStreet": {
            "type": "string",
            "nullable": true
          },
          "accountZip": {
            "type": "string",
            "nullable": true
          },
          "accountTown": {
            "type": "string",
            "nullable": true
          },
          "paymentReference": {
            "type": "string",
            "nullable": true
          },
          "routingNumber": {
            "type": "string",
            "nullable": true
          },
          "abaNumber": {
            "type": "string",
            "nullable": true
          },
          "hiddenInPaymentWorkflow": {
            "type": "boolean"
          },
          "createdByWorkflowId": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.BusinessCentralItem": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "no": {
            "type": "string",
            "nullable": true
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "longText": {
            "type": "string",
            "nullable": true
          },
          "unitPrice": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "genProdPostingGroup": {
            "type": "string",
            "nullable": true
          },
          "company": {
            "$ref": "#/components/schemas/g2fp.Models.BusinessCentral.BusinessCentralCompanyEnum"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.Callability": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.CallabilityEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ClientStatus": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.Company": {
        "required": [
          "address",
          "baseDocumentLocation",
          "clientSince",
          "countryId",
          "id",
          "name",
          "town",
          "zip"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "minLength": 1,
            "type": "string"
          },
          "normalizedName": {
            "type": "string",
            "nullable": true
          },
          "address": {
            "minLength": 1,
            "type": "string"
          },
          "zip": {
            "minLength": 1,
            "type": "string"
          },
          "town": {
            "minLength": 1,
            "type": "string"
          },
          "email": {
            "type": "string",
            "nullable": true
          },
          "operationalEmail": {
            "type": "string",
            "nullable": true
          },
          "phone": {
            "type": "string",
            "nullable": true
          },
          "companyContacts": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Relations.CompanyGentwoContact"
            },
            "nullable": true
          },
          "incorporationDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "clientSince": {
            "type": "string",
            "format": "date"
          },
          "baseDocumentLocation": {
            "minLength": 1,
            "type": "string"
          },
          "countryId": {
            "type": "integer",
            "format": "int32"
          },
          "country": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Country"
          },
          "notes": {
            "type": "string",
            "nullable": true
          },
          "introducedByUserId": {
            "type": "string",
            "nullable": true
          },
          "smallInvoiceClientNumbers": {
            "type": "string",
            "nullable": true
          },
          "responsibleSalesCoverageUserId": {
            "type": "string",
            "nullable": true
          },
          "responsibleAccountManagerUserId": {
            "type": "string",
            "nullable": true
          },
          "responsibleAccountManagerSecondaryUserId": {
            "type": "string",
            "nullable": true
          },
          "isReferralProgram": {
            "type": "boolean"
          },
          "smallInvoiceMainContactId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "smallInvoiceMainContactAddressId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "webUrl": {
            "type": "string",
            "nullable": true
          },
          "g2OfferingType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.G2OfferingTypeEnum"
          },
          "spvSetupFee": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "spvYearlyMaintenanceFeeDownpayment": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "spvMaintenanceFee": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "standardProductFee": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "complexProductFee": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "productMaintenanceFee": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "issuanceVehicleFeePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "applySpecialFees": {
            "type": "boolean",
            "nullable": true
          },
          "feeNotes": {
            "type": "string",
            "nullable": true
          },
          "nonStandardAfa": {
            "type": "boolean",
            "nullable": true
          },
          "ibanFees": {
            "type": "string",
            "nullable": true
          },
          "isArchived": {
            "type": "boolean"
          },
          "archiveNote": {
            "type": "string",
            "nullable": true
          },
          "framework2020CompanyStatusId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "framework2020CompanyStatus": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Framework2020CompanyStatus"
          },
          "createDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "modifiedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "modifiedUserName": {
            "type": "string",
            "nullable": true
          },
          "rowVersion": {
            "type": "integer",
            "format": "int32"
          },
          "accounts": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Relations.ClientAccount"
            },
            "nullable": true
          },
          "referredBy": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Party"
          },
          "referredById": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "isTest": {
            "type": "boolean"
          },
          "businessCentralNumber": {
            "type": "string",
            "nullable": true
          },
          "businessCentralDigitalNumber": {
            "type": "string",
            "nullable": true
          },
          "issuers": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Issuer"
            },
            "nullable": true
          },
          "hasGenTwoIssuers": {
            "type": "boolean",
            "nullable": true,
            "readOnly": true
          },
          "hasGenTwoDigitalIssuers": {
            "type": "boolean",
            "nullable": true,
            "readOnly": true
          },
          "hasActiveGenTwoDigitalIssuers": {
            "type": "boolean",
            "nullable": true,
            "readOnly": true
          },
          "hasActiveGenTwoIssuers": {
            "type": "boolean",
            "nullable": true,
            "readOnly": true
          },
          "clientStatusId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "clientStatus": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ClientStatus"
          },
          "includesOwnedIssuers": {
            "type": "boolean",
            "readOnly": true
          },
          "includesDelegatedIssuers": {
            "type": "boolean",
            "readOnly": true
          },
          "hasSrfAccess": {
            "type": "boolean",
            "readOnly": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ConnexorEvent": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "eventType": {
            "$ref": "#/components/schemas/g2fp.Models.Connexor.Enums.ConnexorEventType"
          },
          "workflowInstanceId": {
            "type": "string",
            "nullable": true
          },
          "userEmail": {
            "type": "string",
            "nullable": true
          },
          "isSuccess": {
            "type": "boolean"
          },
          "createdAt": {
            "type": "string",
            "format": "date-time"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.CoreBusinessType": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "hubSpotId": {
            "type": "string",
            "nullable": true
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.Country": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "nativeName": {
            "type": "string",
            "nullable": true
          },
          "isoAlpha2Code": {
            "type": "string",
            "nullable": true
          },
          "isoAlpha3Code": {
            "type": "string",
            "nullable": true
          },
          "callingCodes": {
            "type": "string",
            "nullable": true
          },
          "isShown": {
            "type": "boolean"
          },
          "isAlwaysExcluded": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.CouponPaymentType": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.CouponPaymentTypeEnum"
          },
          "order": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "yearlyFrequency": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.CouponType": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.CouponTypeEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "order": {
            "type": "integer",
            "format": "int32"
          },
          "enum": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.CouponTypeEnum"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.CryptoExchangeAccount": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "accountTypeId": {
            "type": "integer",
            "format": "int32"
          },
          "accountType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.AccountType"
          },
          "externalAccountId": {
            "type": "string",
            "nullable": true
          },
          "internalAccountName": {
            "type": "string",
            "nullable": true
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "partyId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "party": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Party"
          },
          "partyDescription": {
            "type": "string",
            "nullable": true
          },
          "email": {
            "type": "string",
            "nullable": true
          },
          "host": {
            "type": "string",
            "nullable": true
          },
          "apiKey": {
            "type": "string",
            "nullable": true
          },
          "secretKey": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.DayCountConvention": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.DayCountConventionEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.Documents.StoredDocumentRelatedEntityEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5,
          6
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Documents.StoredDocumentStatus+Ids": {
        "enum": [
          1,
          2,
          3,
          4,
          5,
          6,
          7
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Documents.StoredDocumentType": {
        "required": [
          "name"
        ],
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Documents.StoredDocumentType+Ids"
          },
          "name": {
            "minLength": 1,
            "type": "string"
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "isOptional": {
            "type": "boolean"
          },
          "isMultiple": {
            "type": "boolean"
          },
          "hasDate": {
            "type": "boolean"
          },
          "hasExpiry": {
            "type": "boolean"
          },
          "notOlderThanInMonths": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.Documents.StoredDocumentType+Ids": {
        "enum": [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
          32,
          33,
          34,
          35,
          36,
          37,
          38,
          39,
          40,
          41,
          42,
          43,
          44,
          45,
          46,
          47,
          48,
          49,
          50,
          51,
          52,
          53,
          54,
          55,
          56,
          57,
          58,
          59,
          60,
          61,
          62,
          63
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.DueDiligenceState": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.DueDiligenceEnum"
          },
          "order": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.EarlyRedemptionState": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.EarlyRedemptionStatesEnum"
          },
          "order": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.Enums.AccountVisibilityEnum": {
        "enum": [
          0,
          1,
          2
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.AmortisationPeriodEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.CallabilityEnum": {
        "enum": [
          0,
          1,
          2,
          3
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.CouponPaymentTypeEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.CouponTypeEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.DayCountConventionEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.DueDiligenceEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          16,
          17,
          18,
          19,
          20
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.EarlyRedemptionStatesEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.EventTypeEnum": {
        "enum": [
          0
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.FeeFormEnum": {
        "enum": [
          0,
          1
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.G2OfferingTypeEnum": {
        "enum": [
          0,
          1,
          2,
          4
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.G2ProductSourceEnum": {
        "enum": [
          0,
          1,
          2,
          3
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.G2ValuationTypeEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.HedgeContractStateEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.HighWaterMarkResetFrequencyEnum": {
        "enum": [
          1,
          2,
          3
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.HurdleRateTypeEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.InternalProductTypeEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          6,
          7,
          8,
          9,
          10,
          11,
          12
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.InvoiceStatusEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5,
          6
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.IspProductSourceEnum": {
        "enum": [
          1,
          2
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.MainProductTypeEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.PartyEnum": {
        "enum": [
          69,
          72,
          75,
          1699
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.PartyExternalSourceEnum": {
        "enum": [
          1,
          2,
          3
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.PartyTypeEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
          32,
          33,
          34,
          35,
          36,
          37,
          38,
          39,
          40,
          41,
          42,
          43,
          44,
          45,
          46,
          47,
          48,
          49,
          50,
          51,
          52,
          53,
          54
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.PaymentFlowTypeEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.PerformanceFrequencyEnum": {
        "enum": [
          1,
          2,
          3,
          4,
          5
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.PriceTypeEnum": {
        "enum": [
          0,
          1,
          2
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.ProductConvertibilityEnum": {
        "enum": [
          0,
          1,
          2
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.ProductEventTypeEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5,
          6
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.ProductOfferingEnum": {
        "enum": [
          1,
          2,
          3,
          4,
          5,
          6
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.ProductStateEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          9,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          23,
          24
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.SecondaryMarketEnum": {
        "enum": [
          0,
          1,
          2
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.SecondaryMarketFrequencyEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5,
          6
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.SecondaryMarketTypeEnum": {
        "enum": [
          0,
          1,
          2,
          3
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.SettlementTypeEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.SrfLiteAccessLevelEnum": {
        "enum": [
          0,
          1,
          2
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.SvspProductTypeEnum": {
        "enum": [
          0,
          1,
          2
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.TermsheetStatusEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.UnderlyingDataFrequencyEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.UnderlyingTypeEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.ValuationFrequencyStatusEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.ValuationStateEnum": {
        "enum": [
          1,
          2,
          3
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.ValuationTypeEnum": {
        "enum": [
          0,
          1,
          2,
          3
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Enums.YesNoStatusEnum": {
        "enum": [
          0,
          1,
          2
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.FeeForm": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.FeeFormEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.FeeLite": {
        "type": "object",
        "properties": {
          "type": {
            "type": "string",
            "nullable": true
          },
          "typeId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "title": {
            "type": "string",
            "nullable": true
          },
          "businessCentralItemNo": {
            "type": "string",
            "nullable": true
          },
          "thresholdConfiguration": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ThresholdConfiguration"
          },
          "amount": {
            "type": "number",
            "format": "double"
          },
          "units": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.FinmaPortfolioManager": {
        "required": [
          "city",
          "id",
          "isFinmaRegulated",
          "isRegulatedOutsideCh",
          "isSroRegulated",
          "name"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "minLength": 1,
            "type": "string"
          },
          "zipCode": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "city": {
            "minLength": 1,
            "type": "string"
          },
          "isFinmaRegulated": {
            "type": "boolean"
          },
          "isRegulatedOutsideCh": {
            "type": "boolean"
          },
          "isSroRegulated": {
            "type": "boolean"
          },
          "sroName": {
            "type": "string",
            "nullable": true
          },
          "isDeleted": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.FlowGroups": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "email": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.Framework2020CompanyStatus": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.G2ValuationType": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.G2ValuationTypeEnum"
          },
          "order": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.GentwoContact": {
        "required": [
          "firstName"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "companyName": {
            "type": "string",
            "nullable": true
          },
          "firstName": {
            "minLength": 1,
            "type": "string"
          },
          "lastName": {
            "type": "string",
            "nullable": true
          },
          "personJobTitle": {
            "type": "string",
            "nullable": true
          },
          "email": {
            "type": "string",
            "nullable": true
          },
          "normalizedEmail": {
            "type": "string",
            "nullable": true
          },
          "phone": {
            "type": "string",
            "nullable": true
          },
          "mobile": {
            "type": "string",
            "nullable": true
          },
          "address": {
            "type": "string",
            "nullable": true
          },
          "zip": {
            "type": "string",
            "nullable": true
          },
          "url": {
            "type": "string",
            "nullable": true
          },
          "comments": {
            "type": "string",
            "nullable": true
          },
          "countryId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "country": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Country"
          },
          "countryOfBirthId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "countryOfBirth": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Country"
          },
          "isAuthorizedSignatory": {
            "type": "boolean",
            "nullable": true
          },
          "contactParties": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Relations.PartyGentwoContact"
            },
            "nullable": true
          },
          "contactCompanies": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Relations.CompanyGentwoContact"
            },
            "nullable": true
          },
          "partyTypeParties": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Relations.PartyPartyTypeGentwoContact"
            },
            "nullable": true
          },
          "createDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "modifiedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "modifiedUserName": {
            "type": "string",
            "nullable": true
          },
          "rowVersion": {
            "type": "integer",
            "format": "int32"
          },
          "fullName": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "coreBusinessId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "coreBusiness": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.CoreBusinessType"
          },
          "gentwoContactAssetClassTypes": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.GentwoContactAssetClassType"
            },
            "nullable": true
          },
          "launchProductIn": {
            "type": "string",
            "nullable": true
          },
          "projectStage": {
            "type": "string",
            "nullable": true
          },
          "projectTiming": {
            "type": "string",
            "nullable": true
          },
          "projectDescription": {
            "type": "string",
            "nullable": true
          },
          "howDidYouHearAboutUs": {
            "type": "string",
            "nullable": true
          },
          "contactRecordType": {
            "type": "string",
            "nullable": true
          },
          "contactSource": {
            "type": "string",
            "nullable": true
          },
          "contactSourceDetail": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.GentwoContactAssetClassType": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "gentwoContactId": {
            "type": "integer",
            "format": "int32"
          },
          "gentwoContact": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.GentwoContact"
          },
          "assetClassTypeId": {
            "type": "integer",
            "format": "int32"
          },
          "assetClassType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.AssetClassType"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.GentwoFee": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "feeTypeId": {
            "type": "integer",
            "format": "int32"
          },
          "feeType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.GentwoFeeType"
          },
          "feeLevelId": {
            "type": "integer",
            "format": "int32"
          },
          "feeLevel": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.GentwoFeeLevel"
          },
          "issuerTypes": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.GentwoFeeIssuerType"
            },
            "nullable": true
          },
          "mainProductTypes": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.GentwoFeeMainProductType"
            },
            "nullable": true
          },
          "internalProductTypes": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.GentwoFeeInternalProductType"
            },
            "nullable": true
          },
          "businessCentralItemNo": {
            "type": "string",
            "nullable": true
          },
          "businessCentralItem": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.BusinessCentralItem"
          },
          "autoAssign": {
            "type": "boolean"
          },
          "isArchived": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.GentwoFeeInternalProductType": {
        "required": [
          "gentwoFeeId",
          "internalProductTypeId"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "gentwoFeeId": {
            "type": "integer",
            "format": "int32"
          },
          "gentwoFee": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.GentwoFee"
          },
          "internalProductTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.InternalProductTypeEnum"
          },
          "internalProductType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.InternalProductType"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.GentwoFeeIssuerType": {
        "required": [
          "gentwoFeeId",
          "issuerTypeId"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "gentwoFeeId": {
            "type": "integer",
            "format": "int32"
          },
          "gentwoFee": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.GentwoFee"
          },
          "issuerTypeId": {
            "type": "integer",
            "format": "int32"
          },
          "issuerType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.IssuerType"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.GentwoFeeLevel": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.GentwoFeeMainProductType": {
        "required": [
          "gentwoFeeId",
          "mainProductTypeId"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "gentwoFeeId": {
            "type": "integer",
            "format": "int32"
          },
          "gentwoFee": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.GentwoFee"
          },
          "mainProductTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.MainProductTypeEnum"
          },
          "mainProductType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.MainProductType"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.GentwoFeeType": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "sortOrder": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.HedgeContractState": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.HedgeContractStateEnum"
          },
          "order": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.HighWaterMarkResetFrequency": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.HighWaterMarkResetFrequencyEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.HurdleRateType": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.HurdleRateTypeEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.InternalProductType": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.InternalProductTypeEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "order": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.InvoiceStatus": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.InvoiceStatusEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.IssuanceVehicleFeeData": {
        "required": [
          "createDateTimeUtc",
          "priceDate"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "units": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "nominal": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "subAcc": {
            "type": "string",
            "nullable": true
          },
          "masAcc": {
            "type": "string",
            "nullable": true
          },
          "subInv": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "masInv": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "quotationType": {
            "type": "string",
            "nullable": true
          },
          "price": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "createdQuantity": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "createDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "modifiedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "priceDate": {
            "type": "string",
            "format": "date"
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "product": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Product"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.Issuer": {
        "required": [
          "baseDocumentLocation",
          "countryId",
          "genTwoClientCompanyId",
          "name"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "minLength": 1,
            "type": "string"
          },
          "normalizedName": {
            "type": "string",
            "nullable": true
          },
          "genTwoClientCompanyId": {
            "type": "integer",
            "format": "int32"
          },
          "genTwoClientCompany": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Company"
          },
          "countryId": {
            "type": "integer",
            "format": "int32"
          },
          "country": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Country"
          },
          "incorporationDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "relatedIccId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "relatedIcc": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Issuer"
          },
          "baseIncorporationDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "registrationNumber": {
            "type": "string",
            "nullable": true
          },
          "notes": {
            "type": "string",
            "nullable": true
          },
          "baseDocumentLocation": {
            "minLength": 1,
            "type": "string"
          },
          "email": {
            "type": "string",
            "nullable": true
          },
          "economicDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "tinCode": {
            "type": "string",
            "nullable": true
          },
          "giinCode": {
            "type": "string",
            "nullable": true
          },
          "leiCode": {
            "type": "string",
            "nullable": true
          },
          "qddStatusId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "qddStatus": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.QddStatus"
          },
          "qddBillingTypeId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "qddBillingType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.QddBillingType"
          },
          "smallInvoiceQuarterlyFeeLayoutId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "businessCentralNumber": {
            "type": "string",
            "nullable": true
          },
          "businessCentralDigitalNumber": {
            "type": "string",
            "nullable": true
          },
          "issuerParties": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.IssuerParty"
            },
            "nullable": true
          },
          "isArchived": {
            "type": "boolean"
          },
          "archiveNote": {
            "type": "string",
            "nullable": true
          },
          "issuerTypeId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "issuerType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.IssuerType"
          },
          "createDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "modifiedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "modifiedUserName": {
            "type": "string",
            "nullable": true
          },
          "rowVersion": {
            "type": "integer",
            "format": "int32"
          },
          "accounts": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Relations.IssuerAccount"
            },
            "nullable": true
          },
          "workflowItems": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.WorkflowItem"
            },
            "nullable": true
          },
          "isGentwoDigitalIssuer": {
            "type": "boolean"
          },
          "isUSTaxReturn": {
            "type": "boolean"
          },
          "usTinCode": {
            "type": "string",
            "nullable": true
          },
          "isGermanTaxReturn": {
            "type": "boolean"
          },
          "isPcc": {
            "type": "boolean",
            "readOnly": true
          },
          "isIcc": {
            "type": "boolean",
            "readOnly": true
          },
          "isIc": {
            "type": "boolean",
            "readOnly": true
          },
          "isSpc": {
            "type": "boolean",
            "readOnly": true
          },
          "issuerStatusId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "issuerStatus": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.IssuerStatus"
          },
          "isTest": {
            "type": "boolean"
          },
          "publicSlug": {
            "type": "string",
            "nullable": true
          },
          "fees": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.IssuerGentwoFee"
            },
            "nullable": true
          },
          "feeConfiguration": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.IssuerGentwoFeeConfiguration"
          },
          "usesNdpFeePooling": {
            "type": "boolean"
          },
          "bloombergCompanyId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "tkPartyKey": {
            "type": "string",
            "nullable": true
          },
          "migratedFromGuernsey": {
            "type": "boolean"
          },
          "guernseyOldName": {
            "type": "string",
            "nullable": true
          },
          "guernseyRegistrationNumber": {
            "type": "string",
            "nullable": true
          },
          "guernseyIncorporationDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "migratedFromThirdParty": {
            "type": "boolean"
          },
          "afaSignedDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "afaPaidDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "quarterlyMaintainanceFees": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.IssuerQuarterlyMaintainanceFee"
            },
            "nullable": true
          },
          "belongsToIsp": {
            "type": "boolean",
            "readOnly": true
          },
          "isInScopeOfQdd": {
            "type": "boolean",
            "readOnly": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.IssuerGentwoFee": {
        "required": [
          "gentwoFeeId",
          "issuerId"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "gentwoFeeId": {
            "type": "integer",
            "format": "int32"
          },
          "gentwoFee": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.GentwoFee"
          },
          "issuerId": {
            "type": "integer",
            "format": "int32"
          },
          "issuer": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Issuer"
          },
          "amount": {
            "type": "number",
            "format": "double"
          },
          "thresholdConfiguration": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ThresholdConfiguration"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.IssuerGentwoFeeConfiguration": {
        "required": [
          "issuerId"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "issuerId": {
            "type": "integer",
            "format": "int32"
          },
          "issuer": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Issuer"
          },
          "feeDiscountApplied": {
            "type": "boolean"
          },
          "aggregatedIssuers": {
            "type": "boolean"
          },
          "tieredFee": {
            "type": "boolean"
          },
          "freePCC": {
            "type": "boolean"
          },
          "referralProgram": {
            "type": "boolean"
          },
          "referralProgramEffectiveDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "referredBy": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "reviewed": {
            "type": "boolean"
          },
          "thresholdConfiguration": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ThresholdConfiguration"
          },
          "annualFees": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.AnnualFee"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.IssuerParty": {
        "required": [
          "issuerId",
          "partyId",
          "partyTypeId"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "partyId": {
            "type": "integer",
            "format": "int32"
          },
          "party": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Party"
          },
          "partyTypeId": {
            "type": "integer",
            "format": "int32"
          },
          "partyType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.PartyType"
          },
          "issuerId": {
            "type": "integer",
            "format": "int32"
          },
          "issuer": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Issuer"
          },
          "partyStatusId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "partyStatus": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.PartyStatus"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.IssuerQuarterlyMaintainanceFee": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "issuerId": {
            "type": "integer",
            "format": "int32"
          },
          "issuer": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Issuer"
          },
          "quarter": {
            "$ref": "#/components/schemas/g2fp.Models.Shared.QuarterDate"
          },
          "quarterDailyAverageAuS": {
            "type": "number",
            "format": "double"
          },
          "quarterDailyAverageAuSClient": {
            "type": "number",
            "format": "double"
          },
          "clientCredit": {
            "type": "number",
            "format": "double"
          },
          "discount": {
            "type": "number",
            "format": "double"
          },
          "bips": {
            "type": "number",
            "format": "double"
          },
          "issuerMaintainanceFee": {
            "type": "number",
            "format": "double"
          },
          "total": {
            "type": "number",
            "format": "double"
          },
          "vatAmount": {
            "type": "number",
            "format": "double"
          },
          "totalWithVAT": {
            "type": "number",
            "format": "double"
          },
          "invoiceId": {
            "type": "integer",
            "format": "int32"
          },
          "isLocked": {
            "type": "boolean"
          },
          "createDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "modifiedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.IssuerStatus": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "order": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.IssuerType": {
        "required": [
          "address",
          "countryId",
          "town",
          "zip"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "order": {
            "type": "integer",
            "format": "int32"
          },
          "address": {
            "minLength": 1,
            "type": "string"
          },
          "zip": {
            "minLength": 1,
            "type": "string"
          },
          "town": {
            "minLength": 1,
            "type": "string"
          },
          "countryId": {
            "type": "integer",
            "format": "int32"
          },
          "country": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Country"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.LegalSubjectType": {
        "required": [
          "name"
        ],
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.LegalSubjectType+Ids"
          },
          "name": {
            "minLength": 1,
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.LegalSubjectType+Ids": {
        "enum": [
          1,
          2
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.MainProductType": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.MainProductTypeEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.OrderAcceptanceOrder": {
        "required": [
          "counterparty",
          "orderAcceptanceStateId",
          "orderAcceptanceTemplateId"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "orderAcceptanceTemplateId": {
            "type": "integer",
            "format": "int32"
          },
          "orderAcceptanceTemplate": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.OrderAcceptanceTemplate"
          },
          "counterparty": {
            "minLength": 1,
            "type": "string"
          },
          "nominalUnits": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "issuePrice": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "entryComment": {
            "type": "string",
            "nullable": true
          },
          "distributionFee": {
            "type": "number",
            "format": "double"
          },
          "distributionFeeValueType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.FeeFormEnum"
          },
          "spread": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "spreadValueType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.FeeFormEnum"
          },
          "lateInvestorInterest": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "lateInvestorInterestValueType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.FeeFormEnum"
          },
          "penaltyFee": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "penaltyFeeValueType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.FeeFormEnum"
          },
          "distributionAgent": {
            "type": "string",
            "nullable": true
          },
          "orderAcceptanceStateId": {
            "type": "integer",
            "format": "int32"
          },
          "orderAcceptanceState": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.OrderAcceptanceState"
          },
          "createdOnDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "createdByUserId": {
            "type": "string",
            "nullable": true
          },
          "processedOnDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "processedByUserId": {
            "type": "string",
            "nullable": true
          },
          "processedComment": {
            "type": "string",
            "nullable": true
          },
          "createDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "modifiedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "modifiedUserName": {
            "type": "string",
            "nullable": true
          },
          "rowVersion": {
            "type": "integer",
            "format": "int32"
          },
          "distributionFeeType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.FeeForm"
          },
          "spreadType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.FeeForm"
          },
          "lateInvestorInterestType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.FeeForm"
          },
          "penaltyFeeType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.FeeForm"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.OrderAcceptanceState": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.OrderAcceptanceTemplate": {
        "required": [
          "id",
          "name",
          "workflowType"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "minLength": 1,
            "type": "string"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "workflowType": {
            "minLength": 1,
            "type": "string"
          },
          "productId": {
            "maximum": 2147483647,
            "minimum": 1,
            "type": "integer",
            "format": "int32"
          },
          "product": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Product"
          },
          "orders": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.OrderAcceptanceOrder"
            },
            "nullable": true
          },
          "isArchived": {
            "type": "boolean"
          },
          "createDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "modifiedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "modifiedUserName": {
            "type": "string",
            "nullable": true
          },
          "rowVersion": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.Party": {
        "required": [
          "entryDate",
          "legalSubjectTypeId",
          "name",
          "responsibleUserId"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "minLength": 1,
            "type": "string"
          },
          "address": {
            "type": "string",
            "nullable": true
          },
          "zip": {
            "type": "string",
            "nullable": true
          },
          "town": {
            "type": "string",
            "nullable": true
          },
          "entryDate": {
            "type": "string",
            "format": "date"
          },
          "responsibleUserId": {
            "minLength": 1,
            "type": "string"
          },
          "partyContacts": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Relations.PartyGentwoContact"
            },
            "nullable": true
          },
          "partyTypes": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.PartyPartyType"
            },
            "nullable": true
          },
          "createDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "modifiedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "modifiedUserName": {
            "type": "string",
            "nullable": true
          },
          "companyId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "company": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Company"
          },
          "userId": {
            "type": "string",
            "nullable": true
          },
          "notes": {
            "type": "string",
            "nullable": true
          },
          "countryId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "country": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Country"
          },
          "isArchived": {
            "type": "boolean"
          },
          "smallInvoiceClientNumber": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "smallInvoiceMainContactId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "smallInvoiceMainContactAddressId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "notReceivingQuarterlyFees": {
            "type": "boolean"
          },
          "notReceivingIspTransferFees": {
            "type": "boolean"
          },
          "notReceivingIncoreTransferFees": {
            "type": "boolean"
          },
          "email": {
            "type": "string",
            "nullable": true
          },
          "onboardingEmail": {
            "type": "string",
            "nullable": true
          },
          "phone": {
            "type": "string",
            "nullable": true
          },
          "approvedDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "clickUpLink": {
            "type": "string",
            "nullable": true
          },
          "incorporationDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "rowVersion": {
            "type": "integer",
            "format": "int32"
          },
          "accounts": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Relations.PartyAccount"
            },
            "nullable": true
          },
          "allowedIssuersForSrf": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Relations.PartyAllowedIssuerForSrf"
            },
            "nullable": true
          },
          "hasSwissRepresentative": {
            "type": "boolean"
          },
          "swissRepresentative": {
            "type": "string",
            "nullable": true
          },
          "hasPayingAgent": {
            "type": "boolean"
          },
          "payingAgent": {
            "type": "string",
            "nullable": true
          },
          "isTest": {
            "type": "boolean"
          },
          "bexioClientNumber": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "bexioClientNumberOld": {
            "type": "string",
            "nullable": true
          },
          "businessCentralNumber": {
            "type": "string",
            "nullable": true
          },
          "businessCentralDigitalNumber": {
            "type": "string",
            "nullable": true
          },
          "srfEnabled": {
            "type": "boolean"
          },
          "srfLiteAccessLevelId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.SrfLiteAccessLevelEnum"
          },
          "srfLiteAccessLevel": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.SrfLiteAccessLevel"
          },
          "amcForPmsAccessLevelId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.SrfLiteAccessLevelEnum"
          },
          "amcForPmsAccessLevel": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.SrfLiteAccessLevel"
          },
          "riskGrades": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.PartyRiskGrade"
            },
            "nullable": true
          },
          "legalSubjectTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.LegalSubjectType+Ids"
          },
          "legalSubjectType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.LegalSubjectType"
          },
          "tkPartyKey": {
            "type": "string",
            "nullable": true
          },
          "sisbpId": {
            "type": "string",
            "nullable": true
          },
          "finmaPortfolioManagerId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "finmaPortfolioManager": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.FinmaPortfolioManager"
          },
          "isRegulated": {
            "type": "boolean",
            "nullable": true
          },
          "regulatoryLicenseTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.RegulatoryLicenseType+Ids"
          },
          "regulatoryLicenseType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.RegulatoryLicenseType"
          },
          "regulatoryBodyId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "regulatoryBody": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.RegulatoryBody"
          },
          "supervisoryOrganizationId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "supervisoryOrganization": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.SupervisoryOrganization"
          },
          "externalSource": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.PartyExternalSourceEnum"
          },
          "zefixEhraId": {
            "type": "string",
            "nullable": true
          },
          "zefixUid": {
            "type": "string",
            "nullable": true
          },
          "zefixPmStatus": {
            "type": "string",
            "nullable": true
          },
          "esmaId": {
            "type": "string",
            "nullable": true
          },
          "esmaPmStatus": {
            "type": "string",
            "nullable": true
          },
          "legalEntityIdentifier": {
            "maxLength": 20,
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.PartyPartyType": {
        "required": [
          "partyId",
          "partyTypeId"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "partyId": {
            "type": "integer",
            "format": "int32"
          },
          "party": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Party"
          },
          "partyTypeId": {
            "type": "integer",
            "format": "int32"
          },
          "partyType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.PartyType"
          },
          "partyTypeContacts": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Relations.PartyPartyTypeGentwoContact"
            },
            "nullable": true
          },
          "notes": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.PartyRiskGrade": {
        "required": [
          "createDateTimeUtc",
          "createUserGuid",
          "partyId",
          "riskGradeDate",
          "riskGradeId"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "riskGradeDate": {
            "type": "string",
            "format": "date"
          },
          "clickUpLink": {
            "type": "string",
            "nullable": true
          },
          "partyId": {
            "type": "integer",
            "format": "int32"
          },
          "party": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Party"
          },
          "riskGradeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.RiskGrade+Ids"
          },
          "riskGrade": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.RiskGrade"
          },
          "createDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "createUserGuid": {
            "type": "string",
            "format": "uuid"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.PartyStatus": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "partyTypeId": {
            "type": "integer",
            "format": "int32"
          },
          "order": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.PartyType": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "isSubParty": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.PerformanceFrequency": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.PerformanceFrequencyEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "order": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.PriceDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "code": {
            "type": "string",
            "nullable": true
          },
          "isin": {
            "type": "string",
            "nullable": true
          },
          "type": {
            "type": "integer",
            "format": "int32"
          },
          "productId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "product": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Product"
          },
          "price": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "dataLastRefreshDateTime": {
            "type": "string",
            "format": "date-time"
          },
          "priceDateTime": {
            "type": "string",
            "format": "date-time"
          },
          "priceDate": {
            "type": "string",
            "format": "date"
          },
          "createDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "modifiedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "modifiedUserName": {
            "type": "string",
            "nullable": true
          },
          "rowVersion": {
            "type": "integer",
            "format": "int32"
          },
          "priceNotifications": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.PriceNotification"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.PriceNotification": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "clientNotificationDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "payingAgentNotificationDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "bbgNotificationDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "priceId": {
            "type": "integer",
            "format": "int32"
          },
          "price": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.PriceDto"
          },
          "hasNotifications": {
            "type": "boolean",
            "readOnly": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.Product": {
        "required": [
          "assetManagerId",
          "isTsProductHistoryEligible",
          "longName"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "isin": {
            "maxLength": 12,
            "minLength": 12,
            "type": "string",
            "nullable": true
          },
          "longName": {
            "minLength": 1,
            "type": "string"
          },
          "assetManagerId": {
            "type": "integer",
            "format": "int32"
          },
          "assetManager": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Issuer"
          },
          "valor": {
            "type": "string",
            "nullable": true
          },
          "wkn": {
            "type": "string",
            "nullable": true
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "notes": {
            "type": "string",
            "nullable": true
          },
          "baseDocumentLocation": {
            "pattern": "^((?![.,/?'\\\\:*<>|\"]).)*$",
            "type": "string",
            "nullable": true
          },
          "initialFixingDate": {
            "type": "string",
            "format": "date"
          },
          "paymentDate": {
            "type": "string",
            "format": "date"
          },
          "finalFixingDate": {
            "type": "string",
            "format": "date"
          },
          "repaymentDate": {
            "type": "string",
            "format": "date"
          },
          "subscriptionStartDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "subscriptionEndDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "anniversaryDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "distributionFeePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "distributionFeeCcy": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "issuanceSurchargePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "managementFeePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "managementFeeCurrency": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "supervisoryFeePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "supervisoryFeeCcy": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "supervisorySetupFee": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "adminFeePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "adminFeeCurrency": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "custodianFeePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "setupFeePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "setupFeeCurrency": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "performanceFeePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "hurdleRatePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "interestRateFeePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "secondaryPenaltyFeePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "secondaryPenaltyFeeCcy": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "lateInvestorFeePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "lateInvestorFeeCcy": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "securityAgentServiceFeePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "performanceFrequencyId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.PerformanceFrequencyEnum"
          },
          "performanceFrequency": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.PerformanceFrequency"
          },
          "productOfferingId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductOfferingEnum"
          },
          "productOffering": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductOffering"
          },
          "hurdleRateTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.HurdleRateTypeEnum"
          },
          "hurdleRateType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.HurdleRateType"
          },
          "feeDetails": {
            "type": "string",
            "nullable": true
          },
          "writeoffDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "faceValue": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "issuePricePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "issuePrice": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "couponPct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "couponPaPct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "denomination": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "issueSize": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "secondaryMarketSpread": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "secondaryMarketSpreadFormId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.FeeFormEnum"
          },
          "secondaryMarketSpreadForm": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.FeeForm"
          },
          "tenorInYears": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "hasTenorExtensionOption": {
            "type": "boolean"
          },
          "extendedRedemptionDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "isOpenEnd": {
            "type": "boolean"
          },
          "payoffDetails": {
            "type": "string",
            "nullable": true
          },
          "isCellularProduct": {
            "type": "boolean"
          },
          "hasCellFormed": {
            "type": "boolean"
          },
          "hasCellSideLetter": {
            "type": "boolean"
          },
          "cellName": {
            "type": "string",
            "nullable": true
          },
          "isinCountry": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Country"
          },
          "isinCountryId": {
            "type": "integer",
            "format": "int32"
          },
          "couponTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.CouponTypeEnum"
          },
          "couponType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.CouponType"
          },
          "couponPaymentTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.CouponPaymentTypeEnum"
          },
          "couponPaymentType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.CouponPaymentType"
          },
          "internalProductTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.InternalProductTypeEnum"
          },
          "internalProductType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.InternalProductType"
          },
          "mainProductTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.MainProductTypeEnum"
          },
          "mainProductType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.MainProductType"
          },
          "svspProductTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.SvspProductTypeEnum"
          },
          "svspProductType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.SvspProductType"
          },
          "dayCountConventionId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.DayCountConventionEnum"
          },
          "dayCountConvention": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.DayCountConvention"
          },
          "productStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductStateEnum"
          },
          "productState": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductState"
          },
          "valuationTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ValuationTypeEnum"
          },
          "valuationType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ValuationType"
          },
          "dueDiligenceStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.DueDiligenceEnum"
          },
          "dueDiligenceState": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.DueDiligenceState"
          },
          "hedgeContractStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.HedgeContractStateEnum"
          },
          "hedgeContractState": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.HedgeContractState"
          },
          "prospectusStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.YesNoStatusEnum"
          },
          "prospectusState": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.YesNoStatus"
          },
          "productInvoiceStatusId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.InvoiceStatusEnum"
          },
          "productInvoiceStatus": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.InvoiceStatus"
          },
          "listingInvoiceStatusId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.InvoiceStatusEnum"
          },
          "listingInvoiceStatus": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.InvoiceStatus"
          },
          "callabilityId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.CallabilityEnum"
          },
          "callability": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Callability"
          },
          "valuationFrequencyId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ValuationFrequencyStatusEnum"
          },
          "valuationFrequency": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ValuationFrequency"
          },
          "secondaryMarketTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.SecondaryMarketTypeEnum"
          },
          "secondaryMarketType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.SecondaryMarketType"
          },
          "secondaryMarketId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.SecondaryMarketEnum"
          },
          "secondaryMarket": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.SecondaryMarket"
          },
          "settlementTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.SettlementTypeEnum"
          },
          "settlementType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.SettlementType"
          },
          "earlyRedemptionStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.EarlyRedemptionStatesEnum"
          },
          "earlyRedemptionState": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.EarlyRedemptionState"
          },
          "collateralStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.YesNoStatusEnum"
          },
          "collateralState": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.YesNoStatus"
          },
          "productConvertibilityId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductConvertibilityEnum"
          },
          "productConvertibility": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductConvertibility"
          },
          "g2ValuationTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.G2ValuationTypeEnum"
          },
          "g2ValuationType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.G2ValuationType"
          },
          "g2ValuationTypeComment": {
            "type": "string",
            "nullable": true
          },
          "isAutoValuated": {
            "type": "boolean"
          },
          "productNotPricedReason": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductNotPricedReason"
          },
          "productNotPricedReasonId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductNotPricedReason+Ids"
          },
          "productNotPricedOtherReason": {
            "type": "string",
            "nullable": true
          },
          "valuationTypeInfo": {
            "type": "string",
            "nullable": true
          },
          "valuationSource": {
            "type": "string",
            "nullable": true
          },
          "valuationPortalStatus": {
            "type": "string",
            "nullable": true
          },
          "responsibleSalesUserId": {
            "type": "string",
            "nullable": true
          },
          "responsibleLegalUserId": {
            "type": "string",
            "nullable": true
          },
          "responsibleStructuringUserId": {
            "type": "string",
            "nullable": true
          },
          "responsibleClientUserId": {
            "type": "string",
            "nullable": true
          },
          "responsibleValuationsUserId": {
            "type": "string",
            "nullable": true
          },
          "responsibleComplianceUserId": {
            "type": "string",
            "nullable": true
          },
          "primaryBookingSize": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "noOveremission": {
            "type": "boolean"
          },
          "inScopeOf871M": {
            "type": "boolean"
          },
          "hasNotQuarterlyPayments": {
            "type": "boolean"
          },
          "hasManualQuarterlyFees": {
            "type": "boolean"
          },
          "hasPerformanceFee": {
            "type": "boolean"
          },
          "hasManualPerformanceFee": {
            "type": "boolean"
          },
          "secondaryMarketFrequencyId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.SecondaryMarketFrequencyEnum"
          },
          "secondaryMarketFrequency": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.SecondaryMarketFrequency"
          },
          "minimumTradeSize": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "setupFeeAmortisationPeriodId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.AmortisationPeriodEnum"
          },
          "setupFeeAmortisationPeriod": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.AmortisationPeriod"
          },
          "setupFeeAmortisationPeriodIsPaidUpfront": {
            "type": "boolean"
          },
          "setupFeeAmortisationPeriodNumOfMonths": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "termsheetStatusId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.TermsheetStatusEnum"
          },
          "termsheetStatus": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.TermsheetStatus"
          },
          "valuationStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ValuationStateEnum"
          },
          "valuationState": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ValuationState"
          },
          "isArchived": {
            "type": "boolean"
          },
          "archiveNote": {
            "type": "string",
            "nullable": true
          },
          "highWaterMarkResetFrequencyId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.HighWaterMarkResetFrequencyEnum"
          },
          "highWaterMarkResetFrequency": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.HighWaterMarkResetFrequency"
          },
          "highWaterMarkPeriod": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "productFeeSplitId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "productFeeSplit": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductFeeSplit"
          },
          "createDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "modifiedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "modifiedUserName": {
            "type": "string",
            "nullable": true
          },
          "rowVersion": {
            "type": "integer",
            "format": "int32"
          },
          "productUnderlyings": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Relations.ProductUnderlying"
            },
            "nullable": true
          },
          "productParties": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductParty"
            },
            "nullable": true
          },
          "productEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductEvent"
            },
            "nullable": true
          },
          "accounts": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Relations.ProductAccount"
            },
            "nullable": true
          },
          "cryptoExchangeAccounts": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Relations.ProductCryptoExchangeAccount"
            },
            "nullable": true
          },
          "hasAcceptedStructuringEngagementTCs": {
            "type": "boolean"
          },
          "productTexts": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductText"
            },
            "nullable": true
          },
          "hasDerivatives": {
            "type": "boolean"
          },
          "submittedToIspDateTime": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "srf": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.StructuringRequestForm"
          },
          "srfId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "clickUpId": {
            "type": "string",
            "nullable": true
          },
          "terminationPrice": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "ispProductSourceId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.IspProductSourceEnum"
          },
          "fees": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductGentwoFee"
            },
            "nullable": true
          },
          "valuationSources": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductValuationSource"
            },
            "nullable": true
          },
          "connexorEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ConnexorEvent"
            },
            "nullable": true
          },
          "issuanceVehicleFees": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.IssuanceVehicleFeeData"
            },
            "nullable": true
          },
          "productBelongsToIsp": {
            "type": "boolean",
            "readOnly": true
          },
          "productManager": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Party"
          },
          "primaryProductManager": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Party"
          },
          "payingAgent": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Party"
          },
          "productSponsor": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Party"
          },
          "productRequestor": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Party"
          },
          "valuationNotificationMap": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ValuationNotificationMap"
            },
            "nullable": true
          },
          "issuedAt": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "maturedAt": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "terminatedAt": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "pricePrecision": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "isTest": {
            "type": "boolean"
          },
          "isStpValuation": {
            "type": "boolean"
          },
          "assetBalanceFormatId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "assetBalanceFormat": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.AssetBalanceFormat"
          },
          "customAssetBalanceFormat": {
            "type": "string",
            "nullable": true
          },
          "cutOffTime": {
            "type": "string",
            "nullable": true
          },
          "stpValuationComment": {
            "type": "string",
            "nullable": true
          },
          "stpValuationHasFloatingCashTransfer": {
            "type": "boolean"
          },
          "bloombergProductName": {
            "type": "string",
            "nullable": true
          },
          "secondaryMarketSpecialTerms": {
            "type": "string",
            "nullable": true
          },
          "fastTrack": {
            "type": "boolean"
          },
          "lastProcessedPricingSheetFileDateTime": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "disableLifecycleEvents": {
            "type": "boolean"
          },
          "activateDraftTermsheetGeneration": {
            "type": "boolean"
          },
          "fundLanguageStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.YesNoStatusEnum"
          },
          "fundLanguage": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.YesNoStatus"
          },
          "previousProductIsin": {
            "maxLength": 12,
            "minLength": 12,
            "type": "string",
            "nullable": true
          },
          "feeConfiguration": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductGentwoFeeConfiguration"
          },
          "clonedProductId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "isVisibleOnDashboard": {
            "type": "boolean"
          },
          "isFromSrfLite": {
            "type": "boolean"
          },
          "g2OfferingType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.G2OfferingTypeEnum"
          },
          "g2ProductSourceId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.G2ProductSourceEnum"
          },
          "hasVestr": {
            "type": "boolean"
          },
          "pricingSourceComment": {
            "type": "string",
            "nullable": true
          },
          "isInScopeOfQdd": {
            "type": "boolean",
            "nullable": true,
            "readOnly": true
          },
          "slug": {
            "type": "string",
            "nullable": true
          },
          "isTsProductHistoryEligible": {
            "type": "boolean"
          },
          "isIspVestr": {
            "type": "boolean",
            "readOnly": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ProductConvertibility": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductConvertibilityEnum"
          },
          "order": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ProductDueDiligence": {
        "required": [
          "createDateTimeUtc",
          "createUsername",
          "statusId"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "serializedData": {
            "$ref": "#/components/schemas/System.Text.Json.Nodes.JsonNode"
          },
          "statusId": {
            "type": "integer",
            "format": "int32"
          },
          "status": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductDueDiligenceStatus"
          },
          "structuringRequestForm": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.StructuringRequestForm"
          },
          "isAgentic": {
            "type": "boolean"
          },
          "createDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "createUsername": {
            "minLength": 1,
            "type": "string"
          },
          "modifiedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "modifiedUserName": {
            "type": "string",
            "nullable": true
          },
          "rowVersion": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ProductDueDiligenceStatus": {
        "required": [
          "name"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "minLength": 1,
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ProductEvent": {
        "required": [
          "productId"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "paymentDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "rate": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "notional": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "amount": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "dueAmount": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "valuationDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "exDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "dueDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "notes": {
            "type": "string",
            "nullable": true
          },
          "statusId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "status": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductEventStatus"
          },
          "productEventTypeId": {
            "type": "integer",
            "format": "int32"
          },
          "productEventType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductEventType"
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "product": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Product"
          },
          "loanId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "loan": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductLoan"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ProductEventStatus": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ProductEventType": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "enum": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductEventTypeEnum"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ProductFeeSplit": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "administrationFeePO": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "administrationFeePM": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "administrationFeePS": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "administrationFeePSPO": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "administrationFeePMPO": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "administrationFeeG2": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "managementFeePO": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "managementFeePM": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "managementFeePS": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "managementFeePSPO": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "managementFeePMPO": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "managementFeeG2": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "supervisoryFeePS": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "supervisoryFeeCcyPS": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "supervisorySetupFeePS": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "performanceFeePO": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "performanceFeePM": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "performanceFeePS": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "performanceFeePSPO": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "performanceFeePMPO": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "setUpFeePctPO": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "setUpFeePctPM": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "setUpFeePctPS": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "setUpFeePctPSPO": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "setUpFeePctPMPO": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "setUpFeeCcyPO": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "setUpFeeCcyPM": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "setUpFeeCcyPS": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "setUpFeeCcyPSPO": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "setUpFeeCcyPMPO": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "lateInvestorFeePctPO": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "lateInvestorFeePctPM": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "lateInvestorFeePctPS": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "lateInvestorFeePctG2": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "hasAnyFeeSplits": {
            "type": "boolean",
            "readOnly": true
          },
          "hasPaFeeSplits": {
            "type": "boolean",
            "readOnly": true
          },
          "hasPmFeeSplits": {
            "type": "boolean",
            "readOnly": true
          },
          "hasPsFeeSplits": {
            "type": "boolean",
            "readOnly": true
          },
          "hasG2FeeSplits": {
            "type": "boolean",
            "readOnly": true
          },
          "hasAdministrationFee": {
            "type": "boolean",
            "readOnly": true
          },
          "hasManagementFee": {
            "type": "boolean",
            "readOnly": true
          },
          "hasPerformanceFee": {
            "type": "boolean",
            "readOnly": true
          },
          "hasSetUpPctFee": {
            "type": "boolean",
            "readOnly": true
          },
          "hasSetUpFeeCcyFee": {
            "type": "boolean",
            "readOnly": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ProductGentwoFee": {
        "required": [
          "gentwoFeeId",
          "productId"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "gentwoFeeId": {
            "type": "integer",
            "format": "int32"
          },
          "gentwoFee": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.GentwoFee"
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "product": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Product"
          },
          "amount": {
            "type": "number",
            "format": "double"
          },
          "discountPercentage": {
            "type": "number",
            "format": "double"
          },
          "discountAbsolute": {
            "type": "number",
            "format": "double"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ProductGentwoFeeConfiguration": {
        "required": [
          "productId"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "product": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Product"
          },
          "annualFees": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.AnnualFee"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ProductLoan": {
        "required": [
          "productId"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "productSequenceId": {
            "type": "integer",
            "format": "int32"
          },
          "borrowers": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductLoanBorrower"
            },
            "nullable": true
          },
          "currency": {
            "type": "string",
            "nullable": true
          },
          "maximumPrincipalBalance": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "loanExecutionDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "loanDisbursementDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "fixedInterestRate": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "maturityDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "isExtendedMaturityDateOptionExercised": {
            "type": "boolean"
          },
          "dayCountConventionId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.DayCountConventionEnum"
          },
          "dayCountConvention": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.DayCountConvention"
          },
          "variableInterest": {
            "type": "boolean"
          },
          "extendedMaturityDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "variableInterestDescription": {
            "type": "string",
            "nullable": true
          },
          "variableInterestDropboxFlrd": {
            "type": "string",
            "nullable": true
          },
          "earlyRepaymentOption": {
            "type": "boolean"
          },
          "earlyRepaymentDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "governingLaw": {
            "type": "string",
            "nullable": true
          },
          "collaterals": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductLoanCollateral"
            },
            "nullable": true
          },
          "guarantors": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductLoanGuarantor"
            },
            "nullable": true
          },
          "convertible": {
            "type": "boolean"
          },
          "convertibleConversionPrice": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "convertibleAmount": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "conversionTypeId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "conversionType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductLoanConversionType"
          },
          "conversionDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "convertibleNotes": {
            "type": "string",
            "nullable": true
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "product": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Product"
          },
          "underlyingId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "underlying": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Underlying"
          },
          "productEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductEvent"
            },
            "nullable": true
          },
          "generalComment": {
            "type": "string",
            "nullable": true
          },
          "isAmortized": {
            "type": "boolean"
          },
          "amortizationNotes": {
            "type": "string",
            "nullable": true
          },
          "isDeleted": {
            "type": "boolean",
            "nullable": true
          },
          "maximumPrincipalBalanceText": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ProductLoanBorrower": {
        "required": [
          "entityTypeId",
          "productLoanId"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "jurisdiction": {
            "type": "string",
            "nullable": true
          },
          "address": {
            "type": "string",
            "nullable": true
          },
          "registrationNumber": {
            "type": "string",
            "nullable": true
          },
          "productLoanId": {
            "type": "integer",
            "format": "int32"
          },
          "productLoan": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductLoan"
          },
          "entityTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductLoanEntityType+Ids"
          },
          "entityType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductLoanEntityType"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ProductLoanCollateral": {
        "required": [
          "productLoanId"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "type": {
            "type": "string",
            "nullable": true
          },
          "pledgor": {
            "type": "string",
            "nullable": true
          },
          "jurisdiction": {
            "type": "string",
            "nullable": true
          },
          "governingLaw": {
            "type": "string",
            "nullable": true
          },
          "notes": {
            "type": "string",
            "nullable": true
          },
          "productLoanId": {
            "type": "integer",
            "format": "int32"
          },
          "productLoan": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductLoan"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ProductLoanConversionType": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "order": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ProductLoanEntityType": {
        "required": [
          "name"
        ],
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductLoanEntityType+Ids"
          },
          "name": {
            "minLength": 1,
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ProductLoanEntityType+Ids": {
        "enum": [
          1,
          2,
          3,
          4,
          5
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.ProductLoanGuarantor": {
        "required": [
          "entityTypeId",
          "productLoanId"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "residence": {
            "type": "string",
            "nullable": true
          },
          "taxId": {
            "type": "string",
            "nullable": true
          },
          "guaranteeGoverningLaw": {
            "type": "string",
            "nullable": true
          },
          "jurisdiction": {
            "type": "string",
            "nullable": true
          },
          "notes": {
            "type": "string",
            "nullable": true
          },
          "productLoanId": {
            "type": "integer",
            "format": "int32"
          },
          "productLoan": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductLoan"
          },
          "entityTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductLoanEntityType+Ids"
          },
          "entityType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductLoanEntityType"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ProductNotPricedReason": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductNotPricedReason+Ids"
          },
          "name": {
            "maxLength": 50,
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ProductNotPricedReason+Ids": {
        "enum": [
          1,
          2,
          3
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.ProductOffering": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductOfferingEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "order": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ProductParty": {
        "required": [
          "partyId",
          "partyTypeId",
          "productId"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "partyId": {
            "type": "integer",
            "format": "int32"
          },
          "party": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Party"
          },
          "partyTypeId": {
            "type": "integer",
            "format": "int32"
          },
          "partyType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.PartyType"
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "product": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Product"
          },
          "partyStatusId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "partyStatus": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.PartyStatus"
          },
          "distributionCountries": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ProductState": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductStateEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "order": {
            "type": "integer",
            "format": "int32"
          },
          "externalName": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ProductText": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "productTextTypeId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "productTextType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductTextType"
          },
          "text": {
            "type": "string",
            "nullable": true
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "product": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Product"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ProductTextType": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "order": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ProductValuationSource": {
        "required": [
          "productId",
          "valuationSourceId"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "valuationSourceId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ValuationSource+Ids"
          },
          "valuationSource": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ValuationSource"
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "product": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Product"
          },
          "createDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "createdBy": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.QddBillingType": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "order": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.QddStatus": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "order": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.RegulatoryBody": {
        "required": [
          "countryId",
          "id",
          "name"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "minLength": 1,
            "type": "string"
          },
          "acronym": {
            "type": "string",
            "nullable": true
          },
          "countryId": {
            "type": "integer",
            "format": "int32"
          },
          "country": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Country"
          },
          "supervisoryOrganizations": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.SupervisoryOrganization"
            },
            "nullable": true
          },
          "isLowRiskJurisdiction": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.RegulatoryLicenseType": {
        "required": [
          "id",
          "name",
          "order"
        ],
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.RegulatoryLicenseType+Ids"
          },
          "name": {
            "minLength": 1,
            "type": "string"
          },
          "order": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.RegulatoryLicenseType+Ids": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.Relations.ClientAccount": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "accountId": {
            "type": "integer",
            "format": "int32"
          },
          "account": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.BankAccount"
          },
          "client": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Company"
          },
          "clientId": {
            "type": "integer",
            "format": "int32"
          },
          "accountVisibility": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.AccountVisibilityEnum"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.Relations.CompanyGentwoContact": {
        "type": "object",
        "properties": {
          "gentwoContactId": {
            "type": "integer",
            "format": "int32"
          },
          "gentwoContact": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.GentwoContact"
          },
          "companyId": {
            "type": "integer",
            "format": "int32"
          },
          "company": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Company"
          },
          "entityId": {
            "type": "integer",
            "format": "int32",
            "readOnly": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.Relations.IssuerAccount": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "accountId": {
            "type": "integer",
            "format": "int32"
          },
          "account": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.BankAccount"
          },
          "issuerId": {
            "type": "integer",
            "format": "int32"
          },
          "issuer": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Issuer"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.Relations.PartyAccount": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "accountId": {
            "type": "integer",
            "format": "int32"
          },
          "account": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.BankAccount"
          },
          "party": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Party"
          },
          "partyId": {
            "type": "integer",
            "format": "int32"
          },
          "accountVisibility": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.AccountVisibilityEnum"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.Relations.PartyAllowedIssuerForSrf": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "party": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Party"
          },
          "partyId": {
            "type": "integer",
            "format": "int32"
          },
          "issuerId": {
            "type": "integer",
            "format": "int32"
          },
          "issuer": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Issuer"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.Relations.PartyGentwoContact": {
        "type": "object",
        "properties": {
          "gentwoContactId": {
            "type": "integer",
            "format": "int32"
          },
          "gentwoContact": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.GentwoContact"
          },
          "partyId": {
            "type": "integer",
            "format": "int32"
          },
          "party": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Party"
          },
          "entityId": {
            "type": "integer",
            "format": "int32",
            "readOnly": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.Relations.PartyPartyTypeGentwoContact": {
        "type": "object",
        "properties": {
          "gentwoContactId": {
            "type": "integer",
            "format": "int32"
          },
          "gentwoContact": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.GentwoContact"
          },
          "partyPartyTypeId": {
            "type": "integer",
            "format": "int32"
          },
          "partyPartyType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.PartyPartyType"
          },
          "entityId": {
            "type": "integer",
            "format": "int32",
            "readOnly": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.Relations.ProductAccount": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "accountId": {
            "type": "integer",
            "format": "int32"
          },
          "account": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.BankAccount"
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "product": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Product"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.Relations.ProductCryptoExchangeAccount": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "accountId": {
            "type": "integer",
            "format": "int32"
          },
          "account": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.CryptoExchangeAccount"
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "product": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Product"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.Relations.ProductUnderlying": {
        "type": "object",
        "properties": {
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "product": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Product"
          },
          "underlyingId": {
            "type": "integer",
            "format": "int32"
          },
          "underlying": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Underlying"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.RiskGrade": {
        "required": [
          "name",
          "order"
        ],
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.RiskGrade+Ids"
          },
          "name": {
            "minLength": 1,
            "type": "string"
          },
          "order": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.RiskGrade+Ids": {
        "enum": [
          1,
          2,
          3,
          4
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.SecondaryMarket": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.SecondaryMarketEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.SecondaryMarketFrequency": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.SecondaryMarketFrequencyEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "order": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.SecondaryMarketType": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.SecondaryMarketTypeEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.SettlementType": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.SettlementTypeEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.SrfLiteAccessLevel": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.SrfLiteAccessLevelEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.SrfStatus": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.StructuringRequestForm": {
        "required": [
          "name",
          "version"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "minLength": 1,
            "type": "string"
          },
          "version": {
            "type": "integer",
            "format": "int32"
          },
          "isLite": {
            "type": "boolean"
          },
          "isArchived": {
            "type": "boolean"
          },
          "isDeleted": {
            "type": "boolean"
          },
          "initiatedByUserId": {
            "type": "string",
            "nullable": true
          },
          "modifiedUserId": {
            "type": "string",
            "nullable": true
          },
          "submittedByUserId": {
            "type": "string",
            "nullable": true
          },
          "steps": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.StructuringRequestStep"
            },
            "nullable": true
          },
          "currentStepId": {
            "type": "integer",
            "format": "int32"
          },
          "createDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "modifiedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "submittedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "progress": {
            "type": "integer",
            "format": "int32"
          },
          "statusId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "status": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.SrfStatus"
          },
          "productDueDiligenceId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "productDueDiligence": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductDueDiligence"
          },
          "rowVersion": {
            "type": "integer",
            "format": "int32"
          },
          "productType": {
            "type": "string",
            "nullable": true
          },
          "product": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Product"
          },
          "isAmcForPm": {
            "type": "boolean",
            "readOnly": true
          },
          "displayName": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.StructuringRequestStep": {
        "required": [
          "stepId",
          "structuringRequestFormId"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "stepId": {
            "type": "integer",
            "format": "int32"
          },
          "structuringRequestFormId": {
            "type": "integer",
            "format": "int32"
          },
          "structuringRequestForm": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.StructuringRequestForm"
          },
          "serializedData": {
            "$ref": "#/components/schemas/System.Text.Json.Nodes.JsonNode"
          },
          "createDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "modifiedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "modifiedUserName": {
            "type": "string",
            "nullable": true
          },
          "rowVersion": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.SupervisoryOrganization": {
        "required": [
          "id",
          "name",
          "regulatoryBodyId"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "minLength": 1,
            "type": "string"
          },
          "acronym": {
            "type": "string",
            "nullable": true
          },
          "regulatoryBodyId": {
            "type": "integer",
            "format": "int32"
          },
          "regulatoryBody": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.RegulatoryBody"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.SvspProductType": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.SvspProductTypeEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "typeCode": {
            "type": "integer",
            "format": "int32"
          },
          "categoryCode": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.TermsheetStatus": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.TermsheetStatusEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "order": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ThresholdConfiguration": {
        "type": "object",
        "properties": {
          "minimumAmount": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "thresholds": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ThresholdStep"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ThresholdStep": {
        "type": "object",
        "properties": {
          "ausValue": {
            "type": "integer",
            "format": "int32"
          },
          "bipsValue": {
            "type": "number",
            "format": "double"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.Underlying": {
        "required": [
          "name"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "minLength": 1,
            "type": "string"
          },
          "underlyingTypeId": {
            "type": "integer",
            "format": "int32"
          },
          "underlyingType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.UnderlyingType"
          },
          "underlyingInvoiceStatusId": {
            "type": "integer",
            "format": "int32"
          },
          "underlyingInvoiceStatus": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.UnderlyingInvoiceStatus"
          },
          "underlyingStatusId": {
            "type": "integer",
            "format": "int32"
          },
          "underlyingStatus": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.UnderlyingStatus"
          },
          "underlyingValuationId": {
            "type": "integer",
            "format": "int32"
          },
          "underlyingValuation": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.UnderlyingValuation"
          },
          "createDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "modifiedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "modifiedUserName": {
            "type": "string",
            "nullable": true
          },
          "rowVersion": {
            "type": "integer",
            "format": "int32"
          },
          "underlyingProducts": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Relations.ProductUnderlying"
            },
            "nullable": true
          },
          "underlyingDataFrequencyId": {
            "type": "integer",
            "format": "int32"
          },
          "underlyingDataFrequency": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.UnderlyingDataFrequency"
          },
          "dataFrequencyEnum": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.UnderlyingDataFrequencyEnum"
          },
          "loanId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "loan": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductLoan"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.UnderlyingDataFrequency": {
        "required": [
          "name",
          "order"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "minLength": 1,
            "type": "string"
          },
          "order": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.UnderlyingInvoiceStatus": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.UnderlyingStatus": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "order": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.UnderlyingType": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "assetUpdateName": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.UnderlyingValuation": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ValuationFrequency": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ValuationFrequencyStatusEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ValuationNotificationMap": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "email": {
            "type": "string",
            "nullable": true
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "product": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Product"
          },
          "notificationDayOverride": {
            "type": "string",
            "nullable": true
          },
          "isTextOnly": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ValuationSource": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ValuationSource+Ids"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ValuationSource+Ids": {
        "enum": [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
          32,
          33,
          34,
          35,
          36
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.G2DbModels.ValuationState": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ValuationStateEnum"
          },
          "order": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.ValuationType": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ValuationTypeEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.WorkflowItem": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "isFinished": {
            "type": "boolean"
          },
          "issuerId": {
            "type": "integer",
            "format": "int32"
          },
          "issuer": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Issuer"
          },
          "workflowTypeId": {
            "type": "integer",
            "format": "int32"
          },
          "workflowType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.WorkflowType"
          },
          "workflowStepId": {
            "type": "integer",
            "format": "int32"
          },
          "workflowStep": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.WorkflowStep"
          },
          "completedOnUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "completedByUsername": {
            "type": "string",
            "nullable": true
          },
          "completedNotes": {
            "type": "string",
            "nullable": true
          },
          "modifiedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "modifiedUserName": {
            "type": "string",
            "nullable": true
          },
          "rowVersion": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.WorkflowStep": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "responsibleGroup": {
            "type": "string",
            "nullable": true
          },
          "isDeprecated": {
            "type": "boolean"
          },
          "workflowTypeId": {
            "type": "integer",
            "format": "int32"
          },
          "workflowType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.WorkflowType"
          },
          "sortOrder": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.WorkflowType": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.G2DbModels.YesNoStatus": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.YesNoStatusEnum"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.PartyScreening.ScreeningStatus": {
        "enum": [
          1,
          2,
          3
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.Shared.QuarterDate": {
        "type": "object",
        "properties": {
          "quarter": {
            "type": "integer",
            "format": "int32"
          },
          "year": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Srf.ConversionWarning": {
        "type": "object",
        "properties": {
          "message": {
            "type": "string",
            "nullable": true
          },
          "step": {
            "type": "integer",
            "format": "int32"
          },
          "guid": {
            "type": "string",
            "format": "uuid"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Srf.DetectProductTypeResult": {
        "type": "object",
        "properties": {
          "internalProductType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.InternalProductType"
          },
          "mainProductType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.MainProductType"
          },
          "conversionWarnings": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Srf.ConversionWarning"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Srf.ProductDueDiligencePartyStatus": {
        "enum": [
          1,
          2,
          3,
          4,
          5
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.Srf.SrfConversionResult": {
        "type": "object",
        "properties": {
          "product": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Product"
          },
          "conversionWarnings": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Srf.ConversionWarning"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.Valuations.IspPositionCashAccountSumDto": {
        "type": "object",
        "properties": {
          "portfolioIdentifier": {
            "type": "integer",
            "format": "int32"
          },
          "statementDate": {
            "type": "string",
            "format": "date"
          },
          "valuePortfolioCurrency": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppTwo.ProductHub.DistributorVm": {
        "type": "object",
        "properties": {
          "productPartyId": {
            "type": "integer",
            "format": "int32"
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "distributionCountries": {
            "type": "string",
            "nullable": true
          },
          "assignedUserOrGroupName": {
            "type": "string",
            "nullable": true
          },
          "assignedUserOrGroupDisplay": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppTwo.ProductHub.ProductDistributionDetailsVm": {
        "type": "object",
        "properties": {
          "areAdditionalDistributionStepsNecessary": {
            "type": "boolean"
          },
          "distributors": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppTwo.ProductHub.DistributorVm"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.ApprovalFlowGenTwoApprovalVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "workflowId": {
            "type": "string",
            "nullable": true
          },
          "stepId": {
            "type": "integer",
            "format": "int32"
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "subscribeAsOf": {
            "type": "string",
            "format": "date-time"
          },
          "workflow": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.WorkflowCoreShadowDto.WorkflowInstanceDto"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isRejected": {
            "type": "boolean"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.ApprovalFlowWithFilesApprovalVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "workflowId": {
            "type": "string",
            "nullable": true
          },
          "stepId": {
            "type": "integer",
            "format": "int32"
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "subscribeAsOf": {
            "type": "string",
            "format": "date-time"
          },
          "workflow": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.WorkflowCoreShadowDto.WorkflowInstanceDto"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isRejected": {
            "type": "boolean"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.ApprovalVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "workflowId": {
            "type": "string",
            "nullable": true
          },
          "stepId": {
            "type": "integer",
            "format": "int32"
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "subscribeAsOf": {
            "type": "string",
            "format": "date-time"
          },
          "workflow": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.WorkflowCoreShadowDto.WorkflowInstanceDto"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isRejected": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.CouponFlowVm": {
        "required": [
          "initiatorUserName",
          "isin"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "initiatorUserName": {
            "minLength": 1,
            "type": "string"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "initiationTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "assignedUserGroupName": {
            "type": "string",
            "nullable": true
          },
          "assignAllToInitiator": {
            "type": "boolean"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isCancelled": {
            "type": "boolean"
          },
          "terminationReason": {
            "type": "string",
            "nullable": true
          },
          "terminationUserName": {
            "type": "string",
            "nullable": true
          },
          "terminationDateUtc": {
            "type": "string",
            "format": "date-time"
          },
          "pendingEvent": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
          },
          "pendingStage": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.StageDto"
          },
          "processedEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "allEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "isin": {
            "minLength": 1,
            "type": "string"
          },
          "workflowDisplayName": {
            "type": "string",
            "nullable": true
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "productName": {
            "type": "string",
            "nullable": true
          },
          "isFromSrfLite": {
            "type": "boolean"
          },
          "productStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductStateEnum"
          },
          "issuerDisplayName": {
            "type": "string",
            "nullable": true
          },
          "assetManager": {
            "type": "string",
            "nullable": true
          },
          "assetManagerEmail": {
            "type": "string",
            "nullable": true
          },
          "assetManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "issuerId": {
            "type": "integer",
            "format": "int32"
          },
          "companyId": {
            "type": "integer",
            "format": "int32"
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "valuationTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ValuationTypeEnum"
          },
          "payingAgentCompany": {
            "type": "string",
            "nullable": true
          },
          "payingAgentDisplay": {
            "type": "string",
            "nullable": true
          },
          "payingAgentAccountNumber": {
            "type": "string",
            "nullable": true
          },
          "payingAgentMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "payingAgentTradingMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productManagerCompany": {
            "type": "string",
            "nullable": true
          },
          "productManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "productManagerMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productRequestorCompany": {
            "type": "string",
            "nullable": true
          },
          "productRequestorDisplay": {
            "type": "string",
            "nullable": true
          },
          "productRequestorMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "isCellularProduct": {
            "type": "boolean"
          },
          "cellName": {
            "type": "string",
            "nullable": true
          },
          "subscriptionEndDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "paymentDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "productOfferingId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "jsonType": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "directorOfIssuerCompany": {
            "type": "string",
            "nullable": true
          },
          "directorOfIssuerDisplay": {
            "type": "string",
            "nullable": true
          },
          "parentWorkflowId": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "reportBackEventGuid": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "couponTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.CouponTypeEnum"
          },
          "discretionaryInterestRate": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "fixedInterestRate": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "variableInterestRate": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "paymentFrequencyId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "currency": {
            "type": "string",
            "nullable": true
          },
          "denomination": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "totalAmount": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "amountPerNote": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "outstandingsEntitled": {
            "type": "integer",
            "format": "int32"
          },
          "isPACashAccountFunded": {
            "type": "boolean"
          },
          "paCashAccountBalance": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "couponPaymentDate": {
            "type": "string",
            "format": "date"
          },
          "executionDate": {
            "type": "string",
            "format": "date"
          },
          "cancellationEventKey": {
            "type": "string",
            "nullable": true
          },
          "cancellationReason": {
            "type": "string",
            "nullable": true
          },
          "selectedProduct": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Product"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.Documents.IssuerKYCDocumentVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "issuerTypeId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "isGenTwoDigitalDocument": {
            "type": "boolean"
          },
          "salesDocumentTypeId": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "isDownloadable": {
            "type": "boolean"
          },
          "contentType": {
            "type": "string",
            "nullable": true
          },
          "fileSize": {
            "type": "integer",
            "format": "int64",
            "nullable": true
          },
          "fileModified": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "url": {
            "type": "string",
            "nullable": true
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "details": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.Documents.SalesDocumentVm": {
        "required": [
          "id",
          "name",
          "salesDocumentTypeId"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "isGenTwoDigitalDocument": {
            "type": "boolean"
          },
          "salesDocumentTypeId": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "minLength": 1,
            "type": "string"
          },
          "description": {
            "maxLength": 255,
            "type": "string",
            "nullable": true
          },
          "isDownloadable": {
            "type": "boolean"
          },
          "contentType": {
            "type": "string",
            "nullable": true
          },
          "fileSize": {
            "type": "integer",
            "format": "int64",
            "nullable": true
          },
          "fileModified": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "url": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.EntityApprovalFlowVm": {
        "required": [
          "initiatorUserName",
          "isin"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "initiatorUserName": {
            "minLength": 1,
            "type": "string"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "initiationTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "assignedUserGroupName": {
            "type": "string",
            "nullable": true
          },
          "assignAllToInitiator": {
            "type": "boolean"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isCancelled": {
            "type": "boolean"
          },
          "terminationReason": {
            "type": "string",
            "nullable": true
          },
          "terminationUserName": {
            "type": "string",
            "nullable": true
          },
          "terminationDateUtc": {
            "type": "string",
            "format": "date-time"
          },
          "pendingEvent": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
          },
          "pendingStage": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.StageDto"
          },
          "processedEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "allEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "isin": {
            "minLength": 1,
            "type": "string"
          },
          "workflowDisplayName": {
            "type": "string",
            "nullable": true
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "productName": {
            "type": "string",
            "nullable": true
          },
          "isFromSrfLite": {
            "type": "boolean"
          },
          "productStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductStateEnum"
          },
          "issuerDisplayName": {
            "type": "string",
            "nullable": true
          },
          "assetManager": {
            "type": "string",
            "nullable": true
          },
          "assetManagerEmail": {
            "type": "string",
            "nullable": true
          },
          "assetManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "issuerId": {
            "type": "integer",
            "format": "int32"
          },
          "companyId": {
            "type": "integer",
            "format": "int32"
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "valuationTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ValuationTypeEnum"
          },
          "payingAgentCompany": {
            "type": "string",
            "nullable": true
          },
          "payingAgentDisplay": {
            "type": "string",
            "nullable": true
          },
          "payingAgentAccountNumber": {
            "type": "string",
            "nullable": true
          },
          "payingAgentMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "payingAgentTradingMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productManagerCompany": {
            "type": "string",
            "nullable": true
          },
          "productManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "productManagerMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productRequestorCompany": {
            "type": "string",
            "nullable": true
          },
          "productRequestorDisplay": {
            "type": "string",
            "nullable": true
          },
          "productRequestorMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "isCellularProduct": {
            "type": "boolean"
          },
          "cellName": {
            "type": "string",
            "nullable": true
          },
          "subscriptionEndDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "paymentDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "productOfferingId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "jsonType": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "directorOfIssuerCompany": {
            "type": "string",
            "nullable": true
          },
          "directorOfIssuerDisplay": {
            "type": "string",
            "nullable": true
          },
          "parentWorkflowId": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "reportBackEventGuid": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "srfId": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.FlowOverviewVm": {
        "type": "object",
        "properties": {
          "flows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.FlowVm"
            },
            "nullable": true
          },
          "flowTypes": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.WorkflowTypesCountDto"
            },
            "nullable": true
          },
          "totalItemsCount": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.FlowVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "workflowDefinitionId": {
            "type": "string",
            "nullable": true
          },
          "version": {
            "type": "integer",
            "format": "int32"
          },
          "workflowDisplayName": {
            "type": "string",
            "nullable": true
          },
          "displayName": {
            "type": "string",
            "nullable": true
          },
          "additionalDataList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "status": {
            "type": "string",
            "nullable": true
          },
          "initiatorUserName": {
            "type": "string",
            "nullable": true
          },
          "initiationTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "currentStep": {
            "type": "string",
            "nullable": true
          },
          "isin": {
            "type": "string",
            "nullable": true
          },
          "productName": {
            "type": "string",
            "nullable": true
          },
          "issuerName": {
            "type": "string",
            "nullable": true
          },
          "data": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.BaseFlowDto"
          },
          "completeTime": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "pendingEvent": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
          },
          "pendingEventUrl": {
            "type": "string",
            "nullable": true
          },
          "lastActionDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "flowUrl": {
            "type": "string",
            "nullable": true
          },
          "hasVestr": {
            "type": "boolean"
          },
          "isFromSrfLite": {
            "type": "boolean"
          },
          "assetManagerId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.FrontEndComponent": {
        "enum": [
          "NotSet",
          "Product",
          "Workflow"
        ],
        "type": "string"
      },
      "g2fp.Models.ViewModels.AppWeb.IspPriceEntryVm": {
        "required": [
          "clientDealPrice",
          "nav",
          "spread",
          "spvDealPrice"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "workflowId": {
            "type": "string",
            "nullable": true
          },
          "stepId": {
            "type": "integer",
            "format": "int32"
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "subscribeAsOf": {
            "type": "string",
            "format": "date-time"
          },
          "nav": {
            "type": "number",
            "format": "double"
          },
          "secondaryAddOn": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "spread": {
            "type": "number",
            "format": "double"
          },
          "clientDealPrice": {
            "type": "number",
            "format": "double"
          },
          "spvDealPrice": {
            "type": "number",
            "format": "double"
          },
          "valueRightsChangeOverride": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "valueRightsToCreate": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "isDecrease": {
            "type": "boolean"
          },
          "workflow": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.WorkflowCoreShadowDto.WorkflowInstanceDto"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isRejected": {
            "type": "boolean"
          },
          "lateInvestorInterest": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "penaltyFee": {
            "type": "number",
            "format": "double",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.IspSecondaryChangeFlowVm": {
        "required": [
          "initiatorUserName",
          "isin",
          "tradeDate",
          "valueDate"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "initiatorUserName": {
            "minLength": 1,
            "type": "string"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "initiationTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "assignedUserGroupName": {
            "type": "string",
            "nullable": true
          },
          "assignAllToInitiator": {
            "type": "boolean"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isCancelled": {
            "type": "boolean"
          },
          "terminationReason": {
            "type": "string",
            "nullable": true
          },
          "terminationUserName": {
            "type": "string",
            "nullable": true
          },
          "terminationDateUtc": {
            "type": "string",
            "format": "date-time"
          },
          "pendingEvent": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
          },
          "pendingStage": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.StageDto"
          },
          "processedEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "allEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "isin": {
            "minLength": 1,
            "type": "string"
          },
          "workflowDisplayName": {
            "type": "string",
            "nullable": true
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "productName": {
            "type": "string",
            "nullable": true
          },
          "isFromSrfLite": {
            "type": "boolean"
          },
          "productStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductStateEnum"
          },
          "issuerDisplayName": {
            "type": "string",
            "nullable": true
          },
          "assetManager": {
            "type": "string",
            "nullable": true
          },
          "assetManagerEmail": {
            "type": "string",
            "nullable": true
          },
          "assetManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "issuerId": {
            "type": "integer",
            "format": "int32"
          },
          "companyId": {
            "type": "integer",
            "format": "int32"
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "valuationTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ValuationTypeEnum"
          },
          "payingAgentCompany": {
            "type": "string",
            "nullable": true
          },
          "payingAgentDisplay": {
            "type": "string",
            "nullable": true
          },
          "payingAgentAccountNumber": {
            "type": "string",
            "nullable": true
          },
          "payingAgentMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "payingAgentTradingMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productManagerCompany": {
            "type": "string",
            "nullable": true
          },
          "productManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "productManagerMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productRequestorCompany": {
            "type": "string",
            "nullable": true
          },
          "productRequestorDisplay": {
            "type": "string",
            "nullable": true
          },
          "productRequestorMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "isCellularProduct": {
            "type": "boolean"
          },
          "cellName": {
            "type": "string",
            "nullable": true
          },
          "subscriptionEndDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "paymentDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "productOfferingId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "jsonType": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "directorOfIssuerCompany": {
            "type": "string",
            "nullable": true
          },
          "directorOfIssuerDisplay": {
            "type": "string",
            "nullable": true
          },
          "parentWorkflowId": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "reportBackEventGuid": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "currentStep": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.IspSecondaryChangeFlowDto+IspSecondaryChangeFlowSteps"
          },
          "trades": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.SubscriptionEntryDto"
            },
            "nullable": true
          },
          "tradeDate": {
            "type": "string",
            "format": "date-time"
          },
          "valueDate": {
            "type": "string",
            "format": "date-time"
          },
          "outstandingNotes": {
            "type": "integer",
            "format": "int32"
          },
          "createdValueRights": {
            "type": "integer",
            "format": "int32"
          },
          "valueRightsToCreate": {
            "type": "integer",
            "format": "int32"
          },
          "totalSubscriptions": {
            "type": "number",
            "format": "double"
          },
          "isDecrease": {
            "type": "boolean"
          },
          "nav": {
            "type": "number",
            "format": "double"
          },
          "secondaryAddOn": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "lateInvestorInterest": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "spread": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "clientDealPrice": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "spvDealPrice": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "valueRightsChangeOverride": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "penaltyFee": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "isAssetManagerProductAdministratorAndNotProductManager": {
            "type": "boolean"
          },
          "isWithoutSpread": {
            "type": "boolean"
          },
          "selectedProduct": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Product"
          },
          "templateId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.IssuanceDistributorApprovalVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "workflowId": {
            "type": "string",
            "nullable": true
          },
          "stepId": {
            "type": "integer",
            "format": "int32"
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "subscribeAsOf": {
            "type": "string",
            "format": "date-time"
          },
          "workflow": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.WorkflowCoreShadowDto.WorkflowInstanceDto"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isRejected": {
            "type": "boolean"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.IssuanceG2ApprovalVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "workflowId": {
            "type": "string",
            "nullable": true
          },
          "stepId": {
            "type": "integer",
            "format": "int32"
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "subscribeAsOf": {
            "type": "string",
            "format": "date-time"
          },
          "workflow": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.WorkflowCoreShadowDto.WorkflowInstanceDto"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isRejected": {
            "type": "boolean"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "areFinalTermsUploaded": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.IssuanceIssuerApprovalVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "workflowId": {
            "type": "string",
            "nullable": true
          },
          "stepId": {
            "type": "integer",
            "format": "int32"
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "subscribeAsOf": {
            "type": "string",
            "format": "date-time"
          },
          "workflow": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.WorkflowCoreShadowDto.WorkflowInstanceDto"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isRejected": {
            "type": "boolean"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.IssuancePayingAgentApprovalVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "workflowId": {
            "type": "string",
            "nullable": true
          },
          "stepId": {
            "type": "integer",
            "format": "int32"
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "subscribeAsOf": {
            "type": "string",
            "format": "date-time"
          },
          "workflow": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.WorkflowCoreShadowDto.WorkflowInstanceDto"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isRejected": {
            "type": "boolean"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.IssuanceProductManagerApprovalVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "workflowId": {
            "type": "string",
            "nullable": true
          },
          "stepId": {
            "type": "integer",
            "format": "int32"
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "subscribeAsOf": {
            "type": "string",
            "format": "date-time"
          },
          "workflow": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.WorkflowCoreShadowDto.WorkflowInstanceDto"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isRejected": {
            "type": "boolean"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.IssuanceSubrelationIssuerApprovalVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "workflowId": {
            "type": "string",
            "nullable": true
          },
          "stepId": {
            "type": "integer",
            "format": "int32"
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "subscribeAsOf": {
            "type": "string",
            "format": "date-time"
          },
          "workflow": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.WorkflowCoreShadowDto.WorkflowInstanceDto"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isRejected": {
            "type": "boolean"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.OrderAcceptanceCreateVm": {
        "required": [
          "id",
          "name",
          "workflowType"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "minLength": 1,
            "type": "string"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "workflowType": {
            "minLength": 1,
            "type": "string"
          },
          "productId": {
            "maximum": 2147483647,
            "minimum": 1,
            "type": "integer",
            "format": "int32"
          },
          "product": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Product"
          },
          "orders": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.OrderAcceptanceOrder"
            },
            "nullable": true
          },
          "isArchived": {
            "type": "boolean"
          },
          "createDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "modifiedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "modifiedUserName": {
            "type": "string",
            "nullable": true
          },
          "rowVersion": {
            "type": "integer",
            "format": "int32"
          },
          "workflowTypes": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.SelectOptionsVm"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.OrderAcceptanceTemplateIssuerVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.OrderAcceptanceTemplateOverviewVm": {
        "type": "object",
        "properties": {
          "templates": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.OrderAcceptanceTemplateVm"
            },
            "nullable": true
          },
          "flowTypes": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.WorkflowTypesCountDto"
            },
            "nullable": true
          },
          "totalItemsCount": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.OrderAcceptanceTemplateProductVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "isin": {
            "type": "string",
            "nullable": true
          },
          "longName": {
            "type": "string",
            "nullable": true
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "assetManagerId": {
            "type": "integer",
            "format": "int32"
          },
          "assetManager": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.OrderAcceptanceTemplateIssuerVm"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.OrderAcceptanceTemplateVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "workflowType": {
            "type": "string",
            "nullable": true
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "product": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.OrderAcceptanceTemplateProductVm"
          },
          "orders": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.OrderAcceptanceOrder"
            },
            "nullable": true
          },
          "isArchived": {
            "type": "boolean"
          },
          "createDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "modifiedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "modifiedUserName": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.PaymentDirectorApprovalVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "workflowId": {
            "type": "string",
            "nullable": true
          },
          "stepId": {
            "type": "integer",
            "format": "int32"
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "subscribeAsOf": {
            "type": "string",
            "format": "date-time"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "workflow": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.WorkflowCoreShadowDto.WorkflowInstanceDto"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isRejected": {
            "type": "boolean"
          },
          "amount": {
            "type": "number",
            "format": "double"
          },
          "areInstructionsSentDirectly": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.PriceEntryVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "workflowId": {
            "type": "string",
            "nullable": true
          },
          "stepId": {
            "type": "integer",
            "format": "int32"
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "subscribeAsOf": {
            "type": "string",
            "format": "date-time"
          },
          "workflow": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.WorkflowCoreShadowDto.WorkflowInstanceDto"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isRejected": {
            "type": "boolean"
          },
          "percentOveremission": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "valueRightsOverride": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "valueRightsToCreate": {
            "type": "number",
            "format": "double"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.PrimaryBookingRequestFlowVm": {
        "required": [
          "initiatorUserName",
          "isin"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "initiatorUserName": {
            "minLength": 1,
            "type": "string"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "initiationTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "assignedUserGroupName": {
            "type": "string",
            "nullable": true
          },
          "assignAllToInitiator": {
            "type": "boolean"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isCancelled": {
            "type": "boolean"
          },
          "terminationReason": {
            "type": "string",
            "nullable": true
          },
          "terminationUserName": {
            "type": "string",
            "nullable": true
          },
          "terminationDateUtc": {
            "type": "string",
            "format": "date-time"
          },
          "pendingEvent": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
          },
          "pendingStage": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.StageDto"
          },
          "processedEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "allEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "isin": {
            "minLength": 1,
            "type": "string"
          },
          "workflowDisplayName": {
            "type": "string",
            "nullable": true
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "productName": {
            "type": "string",
            "nullable": true
          },
          "isFromSrfLite": {
            "type": "boolean"
          },
          "productStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductStateEnum"
          },
          "issuerDisplayName": {
            "type": "string",
            "nullable": true
          },
          "assetManager": {
            "type": "string",
            "nullable": true
          },
          "assetManagerEmail": {
            "type": "string",
            "nullable": true
          },
          "assetManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "issuerId": {
            "type": "integer",
            "format": "int32"
          },
          "companyId": {
            "type": "integer",
            "format": "int32"
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "valuationTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ValuationTypeEnum"
          },
          "payingAgentCompany": {
            "type": "string",
            "nullable": true
          },
          "payingAgentDisplay": {
            "type": "string",
            "nullable": true
          },
          "payingAgentAccountNumber": {
            "type": "string",
            "nullable": true
          },
          "payingAgentMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "payingAgentTradingMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productManagerCompany": {
            "type": "string",
            "nullable": true
          },
          "productManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "productManagerMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productRequestorCompany": {
            "type": "string",
            "nullable": true
          },
          "productRequestorDisplay": {
            "type": "string",
            "nullable": true
          },
          "productRequestorMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "isCellularProduct": {
            "type": "boolean"
          },
          "cellName": {
            "type": "string",
            "nullable": true
          },
          "subscriptionEndDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "paymentDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "productOfferingId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "jsonType": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "directorOfIssuerCompany": {
            "type": "string",
            "nullable": true
          },
          "directorOfIssuerDisplay": {
            "type": "string",
            "nullable": true
          },
          "parentWorkflowId": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "reportBackEventGuid": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "currentStep": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.PrimaryBookingRequestFlowSteps"
          },
          "subscriptions": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.SubscriptionEntryDto"
            },
            "nullable": true
          },
          "percentOveremission": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "valueRightsToCreate": {
            "type": "number",
            "format": "double"
          },
          "valueRightsOverride": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "totalSubscriptions": {
            "type": "number",
            "format": "double"
          },
          "isAssetManagerProductAdministratorAndNotProductManager": {
            "type": "boolean"
          },
          "selectedProduct": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Product"
          },
          "templateId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.ProductHub.BasicIssuerVm": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.ProductHub.BasicPartyVm": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.ProductHub.BasicProductInfoVm": {
        "type": "object",
        "properties": {
          "isin": {
            "type": "string",
            "nullable": true
          },
          "valor": {
            "type": "string",
            "nullable": true
          },
          "longName": {
            "type": "string",
            "nullable": true
          },
          "assetManagerId": {
            "type": "integer",
            "format": "int32"
          },
          "assetManager": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.BasicIssuerVm"
          },
          "internalProductTypeId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "productSponsor": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.BasicPartyVm"
          },
          "productManager": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.BasicPartyVm"
          },
          "productParties": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductParty"
            },
            "nullable": true
          },
          "paymentDate": {
            "type": "string",
            "format": "date-time"
          },
          "subscriptionEndDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "disableLifecycleEvents": {
            "type": "boolean"
          },
          "secondaryMarketFrequency": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.SecondaryMarketFrequencyVm"
          },
          "productBelongsToIsp": {
            "type": "boolean"
          },
          "valuationTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ValuationTypeEnum"
          },
          "productState": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductState"
          },
          "isFromSrfLite": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.ProductHub.ClientFeedbackVm": {
        "type": "object",
        "properties": {
          "feedback": {
            "type": "string",
            "nullable": true
          },
          "userName": {
            "type": "string",
            "nullable": true
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.ProductHub.CompanyDetailsVm": {
        "type": "object",
        "properties": {
          "company": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.CompanyVm"
          },
          "issuers": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.IssuerVm"
            },
            "nullable": true
          },
          "productList": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.ProductVm"
            },
            "nullable": true
          },
          "gentwoResponsibleUser": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.UserVm"
          },
          "hasNoCompany": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.ProductHub.CompanyVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "address": {
            "type": "string",
            "nullable": true
          },
          "zip": {
            "type": "string",
            "nullable": true
          },
          "town": {
            "type": "string",
            "nullable": true
          },
          "email": {
            "type": "string",
            "nullable": true
          },
          "incorporationDate": {
            "type": "string",
            "format": "date-time"
          },
          "country": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Country"
          },
          "responsibleAccountManagerUserId": {
            "type": "string",
            "nullable": true
          },
          "responsibleAccountManager": {
            "$ref": "#/components/schemas/g2fp.Models.Account.UserDto"
          },
          "webUrl": {
            "type": "string",
            "nullable": true
          },
          "phone": {
            "type": "string",
            "nullable": true
          },
          "logoSrc": {
            "type": "string",
            "nullable": true
          },
          "backgroundImageSrc": {
            "type": "string",
            "nullable": true
          },
          "hasGenTwoIssuers": {
            "type": "boolean"
          },
          "hasGenTwoDigitalIssuers": {
            "type": "boolean"
          },
          "partyId": {
            "type": "integer",
            "format": "int32"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.ProductHub.ExternalProductStateHistoryVm": {
        "type": "object",
        "properties": {
          "userId": {
            "type": "string",
            "nullable": true
          },
          "auditDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "externalProductStateId": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.ProductHub.IssuerVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "address": {
            "type": "string",
            "nullable": true
          },
          "zip": {
            "type": "string",
            "nullable": true
          },
          "town": {
            "type": "string",
            "nullable": true
          },
          "incorporationDate": {
            "type": "string",
            "format": "date-time"
          },
          "registrationNumber": {
            "type": "string",
            "nullable": true
          },
          "email": {
            "type": "string",
            "nullable": true
          },
          "economicDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "tinCode": {
            "type": "string",
            "nullable": true
          },
          "giinCode": {
            "type": "string",
            "nullable": true
          },
          "leiCode": {
            "type": "string",
            "nullable": true
          },
          "issuerTypeId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "issuerStatusId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "isUSTaxReturn": {
            "type": "boolean"
          },
          "isGermanTaxReturn": {
            "type": "boolean"
          },
          "isGentwoDigitalIssuer": {
            "type": "boolean"
          },
          "belongsToIsp": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.ProductHub.OutstandingCertificatesVm": {
        "type": "object",
        "properties": {
          "value": {
            "type": "integer",
            "format": "int32"
          },
          "date": {
            "type": "string",
            "format": "date"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.ProductHub.ProductVm": {
        "required": [
          "assetManagerId",
          "isTsProductHistoryEligible",
          "longName"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "isin": {
            "maxLength": 12,
            "minLength": 12,
            "type": "string",
            "nullable": true
          },
          "longName": {
            "minLength": 1,
            "type": "string"
          },
          "assetManagerId": {
            "type": "integer",
            "format": "int32"
          },
          "assetManager": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Issuer"
          },
          "valor": {
            "type": "string",
            "nullable": true
          },
          "wkn": {
            "type": "string",
            "nullable": true
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "notes": {
            "type": "string",
            "nullable": true
          },
          "baseDocumentLocation": {
            "pattern": "^((?![.,/?'\\\\:*<>|\"]).)*$",
            "type": "string",
            "nullable": true
          },
          "initialFixingDate": {
            "type": "string",
            "format": "date"
          },
          "paymentDate": {
            "type": "string",
            "format": "date"
          },
          "finalFixingDate": {
            "type": "string",
            "format": "date"
          },
          "repaymentDate": {
            "type": "string",
            "format": "date"
          },
          "subscriptionStartDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "subscriptionEndDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "anniversaryDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "distributionFeePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "distributionFeeCcy": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "issuanceSurchargePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "managementFeePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "managementFeeCurrency": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "supervisoryFeePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "supervisoryFeeCcy": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "supervisorySetupFee": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "adminFeePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "adminFeeCurrency": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "custodianFeePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "setupFeePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "setupFeeCurrency": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "performanceFeePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "hurdleRatePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "interestRateFeePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "secondaryPenaltyFeePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "secondaryPenaltyFeeCcy": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "lateInvestorFeePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "lateInvestorFeeCcy": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "securityAgentServiceFeePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "performanceFrequencyId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.PerformanceFrequencyEnum"
          },
          "performanceFrequency": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.PerformanceFrequency"
          },
          "productOfferingId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductOfferingEnum"
          },
          "productOffering": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductOffering"
          },
          "hurdleRateTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.HurdleRateTypeEnum"
          },
          "hurdleRateType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.HurdleRateType"
          },
          "feeDetails": {
            "type": "string",
            "nullable": true
          },
          "writeoffDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "faceValue": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "issuePricePct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "issuePrice": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "couponPct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "couponPaPct": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "denomination": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "issueSize": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "secondaryMarketSpread": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "secondaryMarketSpreadFormId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.FeeFormEnum"
          },
          "secondaryMarketSpreadForm": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.FeeForm"
          },
          "tenorInYears": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "hasTenorExtensionOption": {
            "type": "boolean"
          },
          "extendedRedemptionDate": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "isOpenEnd": {
            "type": "boolean"
          },
          "payoffDetails": {
            "type": "string",
            "nullable": true
          },
          "isCellularProduct": {
            "type": "boolean"
          },
          "hasCellFormed": {
            "type": "boolean"
          },
          "hasCellSideLetter": {
            "type": "boolean"
          },
          "cellName": {
            "type": "string",
            "nullable": true
          },
          "isinCountry": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Country"
          },
          "isinCountryId": {
            "type": "integer",
            "format": "int32"
          },
          "couponTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.CouponTypeEnum"
          },
          "couponType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.CouponType"
          },
          "couponPaymentTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.CouponPaymentTypeEnum"
          },
          "couponPaymentType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.CouponPaymentType"
          },
          "internalProductTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.InternalProductTypeEnum"
          },
          "internalProductType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.InternalProductType"
          },
          "mainProductTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.MainProductTypeEnum"
          },
          "mainProductType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.MainProductType"
          },
          "svspProductTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.SvspProductTypeEnum"
          },
          "svspProductType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.SvspProductType"
          },
          "dayCountConventionId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.DayCountConventionEnum"
          },
          "dayCountConvention": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.DayCountConvention"
          },
          "productStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductStateEnum"
          },
          "productState": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductState"
          },
          "valuationTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ValuationTypeEnum"
          },
          "valuationType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ValuationType"
          },
          "dueDiligenceStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.DueDiligenceEnum"
          },
          "dueDiligenceState": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.DueDiligenceState"
          },
          "hedgeContractStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.HedgeContractStateEnum"
          },
          "hedgeContractState": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.HedgeContractState"
          },
          "prospectusStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.YesNoStatusEnum"
          },
          "prospectusState": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.YesNoStatus"
          },
          "productInvoiceStatusId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.InvoiceStatusEnum"
          },
          "productInvoiceStatus": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.InvoiceStatus"
          },
          "listingInvoiceStatusId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.InvoiceStatusEnum"
          },
          "listingInvoiceStatus": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.InvoiceStatus"
          },
          "callabilityId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.CallabilityEnum"
          },
          "callability": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Callability"
          },
          "valuationFrequencyId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ValuationFrequencyStatusEnum"
          },
          "valuationFrequency": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ValuationFrequency"
          },
          "secondaryMarketTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.SecondaryMarketTypeEnum"
          },
          "secondaryMarketType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.SecondaryMarketType"
          },
          "secondaryMarketId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.SecondaryMarketEnum"
          },
          "secondaryMarket": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.SecondaryMarket"
          },
          "settlementTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.SettlementTypeEnum"
          },
          "settlementType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.SettlementType"
          },
          "earlyRedemptionStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.EarlyRedemptionStatesEnum"
          },
          "earlyRedemptionState": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.EarlyRedemptionState"
          },
          "collateralStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.YesNoStatusEnum"
          },
          "collateralState": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.YesNoStatus"
          },
          "productConvertibilityId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductConvertibilityEnum"
          },
          "productConvertibility": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductConvertibility"
          },
          "g2ValuationTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.G2ValuationTypeEnum"
          },
          "g2ValuationType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.G2ValuationType"
          },
          "g2ValuationTypeComment": {
            "type": "string",
            "nullable": true
          },
          "isAutoValuated": {
            "type": "boolean"
          },
          "productNotPricedReason": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductNotPricedReason"
          },
          "productNotPricedReasonId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductNotPricedReason+Ids"
          },
          "productNotPricedOtherReason": {
            "type": "string",
            "nullable": true
          },
          "valuationTypeInfo": {
            "type": "string",
            "nullable": true
          },
          "valuationSource": {
            "type": "string",
            "nullable": true
          },
          "valuationPortalStatus": {
            "type": "string",
            "nullable": true
          },
          "responsibleSalesUserId": {
            "type": "string",
            "nullable": true
          },
          "responsibleLegalUserId": {
            "type": "string",
            "nullable": true
          },
          "responsibleStructuringUserId": {
            "type": "string",
            "nullable": true
          },
          "responsibleClientUserId": {
            "type": "string",
            "nullable": true
          },
          "responsibleValuationsUserId": {
            "type": "string",
            "nullable": true
          },
          "responsibleComplianceUserId": {
            "type": "string",
            "nullable": true
          },
          "primaryBookingSize": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "noOveremission": {
            "type": "boolean"
          },
          "inScopeOf871M": {
            "type": "boolean"
          },
          "hasNotQuarterlyPayments": {
            "type": "boolean"
          },
          "hasManualQuarterlyFees": {
            "type": "boolean"
          },
          "hasPerformanceFee": {
            "type": "boolean"
          },
          "hasManualPerformanceFee": {
            "type": "boolean"
          },
          "secondaryMarketFrequencyId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.SecondaryMarketFrequencyEnum"
          },
          "secondaryMarketFrequency": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.SecondaryMarketFrequency"
          },
          "minimumTradeSize": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "setupFeeAmortisationPeriodId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.AmortisationPeriodEnum"
          },
          "setupFeeAmortisationPeriod": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.AmortisationPeriod"
          },
          "setupFeeAmortisationPeriodIsPaidUpfront": {
            "type": "boolean"
          },
          "setupFeeAmortisationPeriodNumOfMonths": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "termsheetStatusId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.TermsheetStatusEnum"
          },
          "termsheetStatus": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.TermsheetStatus"
          },
          "valuationStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ValuationStateEnum"
          },
          "valuationState": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ValuationState"
          },
          "isArchived": {
            "type": "boolean"
          },
          "archiveNote": {
            "type": "string",
            "nullable": true
          },
          "highWaterMarkResetFrequencyId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.HighWaterMarkResetFrequencyEnum"
          },
          "highWaterMarkResetFrequency": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.HighWaterMarkResetFrequency"
          },
          "highWaterMarkPeriod": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "productFeeSplitId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "productFeeSplit": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductFeeSplit"
          },
          "createDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "modifiedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "modifiedUserName": {
            "type": "string",
            "nullable": true
          },
          "rowVersion": {
            "type": "integer",
            "format": "int32"
          },
          "productUnderlyings": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Relations.ProductUnderlying"
            },
            "nullable": true
          },
          "productParties": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductParty"
            },
            "nullable": true
          },
          "productEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductEvent"
            },
            "nullable": true
          },
          "accounts": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Relations.ProductAccount"
            },
            "nullable": true
          },
          "cryptoExchangeAccounts": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Relations.ProductCryptoExchangeAccount"
            },
            "nullable": true
          },
          "hasAcceptedStructuringEngagementTCs": {
            "type": "boolean"
          },
          "productTexts": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductText"
            },
            "nullable": true
          },
          "hasDerivatives": {
            "type": "boolean"
          },
          "submittedToIspDateTime": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "srf": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.StructuringRequestForm"
          },
          "srfId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "clickUpId": {
            "type": "string",
            "nullable": true
          },
          "terminationPrice": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "ispProductSourceId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.IspProductSourceEnum"
          },
          "fees": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductGentwoFee"
            },
            "nullable": true
          },
          "valuationSources": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductValuationSource"
            },
            "nullable": true
          },
          "connexorEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ConnexorEvent"
            },
            "nullable": true
          },
          "issuanceVehicleFees": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.IssuanceVehicleFeeData"
            },
            "nullable": true
          },
          "productBelongsToIsp": {
            "type": "boolean",
            "readOnly": true
          },
          "productManager": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Party"
          },
          "primaryProductManager": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Party"
          },
          "payingAgent": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Party"
          },
          "productSponsor": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Party"
          },
          "productRequestor": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Party"
          },
          "valuationNotificationMap": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ValuationNotificationMap"
            },
            "nullable": true
          },
          "issuedAt": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "maturedAt": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "terminatedAt": {
            "type": "string",
            "format": "date",
            "nullable": true
          },
          "pricePrecision": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "isTest": {
            "type": "boolean"
          },
          "isStpValuation": {
            "type": "boolean"
          },
          "assetBalanceFormatId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "assetBalanceFormat": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.AssetBalanceFormat"
          },
          "customAssetBalanceFormat": {
            "type": "string",
            "nullable": true
          },
          "cutOffTime": {
            "type": "string",
            "nullable": true
          },
          "stpValuationComment": {
            "type": "string",
            "nullable": true
          },
          "stpValuationHasFloatingCashTransfer": {
            "type": "boolean"
          },
          "bloombergProductName": {
            "type": "string",
            "nullable": true
          },
          "secondaryMarketSpecialTerms": {
            "type": "string",
            "nullable": true
          },
          "fastTrack": {
            "type": "boolean"
          },
          "lastProcessedPricingSheetFileDateTime": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "disableLifecycleEvents": {
            "type": "boolean"
          },
          "activateDraftTermsheetGeneration": {
            "type": "boolean"
          },
          "fundLanguageStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.YesNoStatusEnum"
          },
          "fundLanguage": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.YesNoStatus"
          },
          "previousProductIsin": {
            "maxLength": 12,
            "minLength": 12,
            "type": "string",
            "nullable": true
          },
          "feeConfiguration": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductGentwoFeeConfiguration"
          },
          "clonedProductId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "isVisibleOnDashboard": {
            "type": "boolean"
          },
          "isFromSrfLite": {
            "type": "boolean"
          },
          "g2OfferingType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.G2OfferingTypeEnum"
          },
          "g2ProductSourceId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.G2ProductSourceEnum"
          },
          "hasVestr": {
            "type": "boolean"
          },
          "pricingSourceComment": {
            "type": "string",
            "nullable": true
          },
          "isInScopeOfQdd": {
            "type": "boolean",
            "nullable": true,
            "readOnly": true
          },
          "slug": {
            "type": "string",
            "nullable": true
          },
          "isTsProductHistoryEligible": {
            "type": "boolean"
          },
          "isIspVestr": {
            "type": "boolean",
            "readOnly": true
          },
          "latestProductValuation": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.PriceDto"
          },
          "isIspPayingAgent": {
            "type": "boolean"
          },
          "platformOwner": {
            "type": "string",
            "nullable": true
          },
          "platformOwnerAssignmentId": {
            "type": "string",
            "nullable": true
          },
          "productSponsorDisplay": {
            "type": "string",
            "nullable": true
          },
          "productSponsorAssignmentId": {
            "type": "string",
            "nullable": true
          },
          "productManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "productManagerAssignmentId": {
            "type": "string",
            "nullable": true
          },
          "productAdministratorDisplay": {
            "type": "string",
            "nullable": true
          },
          "productAdministratorAssignmentId": {
            "type": "string",
            "nullable": true
          },
          "currentWorkflows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.FlowVm"
            },
            "nullable": true
          },
          "externalProductStateHistory": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.ExternalProductStateHistoryVm"
            },
            "nullable": true
          },
          "showInvoices": {
            "type": "boolean"
          },
          "productDueDiligenceId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "srfVersion": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "latestOutstandingCertificates": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.OutstandingCertificatesVm"
          },
          "distributionDetails": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppTwo.ProductHub.ProductDistributionDetailsVm"
          },
          "workflowInitiationBlockReasons": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.WorkflowInitiationBlockReason"
            },
            "nullable": true
          },
          "currencyConversionRateToCHF": {
            "type": "number",
            "format": "double"
          },
          "responsibleUsers": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.ResponsibleUserVm"
            },
            "nullable": true
          },
          "productGrossNav": {
            "type": "number",
            "format": "double",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.ProductHub.ResponsibleUserVm": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string",
            "nullable": true
          },
          "email": {
            "type": "string",
            "nullable": true
          },
          "responsibility": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.ProductHub.SecondaryMarketFrequencyVm": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.ProductHub.UserImageVm": {
        "type": "object",
        "properties": {
          "imageSrc": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.ProductHub.UserVm": {
        "type": "object",
        "properties": {
          "firstName": {
            "type": "string",
            "nullable": true
          },
          "lastName": {
            "type": "string",
            "nullable": true
          },
          "userName": {
            "type": "string",
            "nullable": true
          },
          "imageSrc": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.ProductHub.WorkflowInitiationBlockReason": {
        "type": "object",
        "properties": {
          "workflowName": {
            "type": "string",
            "nullable": true
          },
          "reason": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.ProductIssuanceFlowVm": {
        "required": [
          "attachedFileGuids",
          "initiatorUserName",
          "isin"
        ],
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "initiatorUserName": {
            "minLength": 1,
            "type": "string"
          },
          "initiationTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "assignedUserGroupName": {
            "type": "string",
            "nullable": true
          },
          "assignAllToInitiator": {
            "type": "boolean"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isCancelled": {
            "type": "boolean"
          },
          "terminationReason": {
            "type": "string",
            "nullable": true
          },
          "terminationUserName": {
            "type": "string",
            "nullable": true
          },
          "terminationDateUtc": {
            "type": "string",
            "format": "date-time"
          },
          "pendingEvent": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
          },
          "pendingStage": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.StageDto"
          },
          "processedEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "allEvents": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.EventDto"
            },
            "nullable": true
          },
          "isin": {
            "minLength": 1,
            "type": "string"
          },
          "workflowDisplayName": {
            "type": "string",
            "nullable": true
          },
          "productId": {
            "type": "integer",
            "format": "int32"
          },
          "productName": {
            "type": "string",
            "nullable": true
          },
          "isFromSrfLite": {
            "type": "boolean"
          },
          "productStateId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ProductStateEnum"
          },
          "issuerDisplayName": {
            "type": "string",
            "nullable": true
          },
          "assetManager": {
            "type": "string",
            "nullable": true
          },
          "assetManagerEmail": {
            "type": "string",
            "nullable": true
          },
          "assetManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "issuerId": {
            "type": "integer",
            "format": "int32"
          },
          "companyId": {
            "type": "integer",
            "format": "int32"
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "valuationTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.ValuationTypeEnum"
          },
          "payingAgentCompany": {
            "type": "string",
            "nullable": true
          },
          "payingAgentDisplay": {
            "type": "string",
            "nullable": true
          },
          "payingAgentAccountNumber": {
            "type": "string",
            "nullable": true
          },
          "payingAgentMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "payingAgentTradingMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productManagerCompany": {
            "type": "string",
            "nullable": true
          },
          "productManagerDisplay": {
            "type": "string",
            "nullable": true
          },
          "productManagerMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productRequestorCompany": {
            "type": "string",
            "nullable": true
          },
          "productRequestorDisplay": {
            "type": "string",
            "nullable": true
          },
          "productRequestorMidofficeMailList": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "isCellularProduct": {
            "type": "boolean"
          },
          "cellName": {
            "type": "string",
            "nullable": true
          },
          "subscriptionEndDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "paymentDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "productOfferingId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "jsonType": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "directorOfIssuerCompany": {
            "type": "string",
            "nullable": true
          },
          "directorOfIssuerDisplay": {
            "type": "string",
            "nullable": true
          },
          "parentWorkflowId": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "reportBackEventGuid": {
            "type": "string",
            "format": "uuid",
            "nullable": true
          },
          "currentStep": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.Flows.ProductIssuanceFlowSteps"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "attachedFileGuids": {
            "minItems": 1,
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "isFinalTermsheet": {
            "type": "boolean",
            "nullable": true
          },
          "isSubrelationCheckVisible": {
            "type": "boolean"
          },
          "isSubrelationDocumentRequired": {
            "type": "boolean"
          },
          "shouldUploadToConnexor": {
            "type": "boolean"
          },
          "selectedProduct": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Product"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.PublicIssuer.PublicIssuerVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.PublicIssuer.PublicPartyVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.PublicIssuer.PublicProductDocument": {
        "type": "object",
        "properties": {
          "type": {
            "type": "string",
            "nullable": true
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "culture": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.PublicIssuer.PublicProductListItemVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "isin": {
            "type": "string",
            "nullable": true
          },
          "longName": {
            "type": "string",
            "nullable": true
          },
          "assetManager": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Issuer"
          },
          "issuerName": {
            "type": "string",
            "nullable": true,
            "readOnly": true
          },
          "valor": {
            "type": "string",
            "nullable": true
          },
          "productStateId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "productState": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductState"
          },
          "internalProductTypeId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "latestProductValuation": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.PriceDto"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.PublicIssuer.PublicProductListVm": {
        "type": "object",
        "properties": {
          "products": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.PublicIssuer.PublicProductListItemVm"
            },
            "nullable": true
          },
          "productStates": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductState"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.PublicIssuer.PublicProductPartyVm": {
        "type": "object",
        "properties": {
          "party": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.PublicIssuer.PublicPartyVm"
          },
          "partyTypeId": {
            "type": "integer",
            "format": "int32"
          },
          "partyType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.PartyType"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.PublicIssuer.PublicProductVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "isin": {
            "type": "string",
            "nullable": true
          },
          "longName": {
            "type": "string",
            "nullable": true
          },
          "slug": {
            "type": "string",
            "nullable": true
          },
          "valor": {
            "type": "string",
            "nullable": true
          },
          "latestProductValuation": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.PriceDto"
          },
          "isTsProductHistoryEligible": {
            "type": "boolean"
          },
          "hasTermsheet": {
            "type": "boolean"
          },
          "distributionDetails": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppTwo.ProductHub.ProductDistributionDetailsVm"
          },
          "internalProductTypeId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "productStateId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "productState": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductState"
          },
          "assetManager": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.PublicIssuer.PublicIssuerVm"
          },
          "couponPaymentType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.CouponPaymentType"
          },
          "couponType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.CouponType"
          },
          "issueSize": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "denomination": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "dayCountConvention": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.DayCountConvention"
          },
          "settlementType": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.SettlementType"
          },
          "collateralState": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.YesNoStatus"
          },
          "productParties": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.PublicIssuer.PublicProductPartyVm"
            },
            "nullable": true
          },
          "productManager": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.PublicIssuer.PublicPartyVm"
          },
          "productSponsor": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.PublicIssuer.PublicPartyVm"
          },
          "availableDocuments": {
            "type": "object",
            "additionalProperties": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.PublicIssuer.PublicProductDocument"
              },
              "nullable": true
            },
            "nullable": true
          },
          "tenorInYears": {
            "type": "number",
            "format": "double",
            "nullable": true
          },
          "subscriptionEndDate": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "initialFixingDate": {
            "type": "string",
            "format": "date-time"
          },
          "paymentDate": {
            "type": "string",
            "format": "date-time"
          },
          "finalFixingDate": {
            "type": "string",
            "format": "date-time"
          },
          "repaymentDate": {
            "type": "string",
            "format": "date-time"
          },
          "earlyRedemptionState": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.EarlyRedemptionState"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.QuarterliesApprovalVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "workflowId": {
            "type": "string",
            "nullable": true
          },
          "stepId": {
            "type": "integer",
            "format": "int32"
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "subscribeAsOf": {
            "type": "string",
            "format": "date-time"
          },
          "workflow": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.WorkflowCoreShadowDto.WorkflowInstanceDto"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isRejected": {
            "type": "boolean"
          },
          "amount": {
            "type": "number",
            "format": "double"
          },
          "lastSmallInvoiceId": {
            "type": "integer",
            "format": "int32"
          },
          "invoiceDate": {
            "type": "string",
            "format": "date"
          },
          "cashAccountsAmount": {
            "$ref": "#/components/schemas/g2fp.Models.Valuations.IspPositionCashAccountSumDto"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.SelectOptionsVm": {
        "type": "object",
        "properties": {
          "value": {
            "type": "string",
            "nullable": true
          },
          "text": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.SelectedDataRangeEnum": {
        "enum": [
          0,
          1,
          2,
          3,
          4,
          5
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Models.ViewModels.AppWeb.Srf.DocumentTypeVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.Srf.PartyVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.Srf.ProductDueDiligenceUpdateResponse": {
        "type": "object",
        "properties": {
          "warnings": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "productDueDiligence": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductDueDiligence"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.Srf.ProductDueDiligenceVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "serializedData": {
            "$ref": "#/components/schemas/System.Text.Json.Nodes.JsonNode"
          },
          "statusId": {
            "type": "integer",
            "format": "int32"
          },
          "status": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductDueDiligenceStatus"
          },
          "isAgentic": {
            "type": "boolean"
          },
          "createDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "createUsername": {
            "type": "string",
            "nullable": true
          },
          "modifiedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "modifiedUserName": {
            "type": "string",
            "nullable": true
          },
          "rowVersion": {
            "type": "integer",
            "format": "int32"
          },
          "isAcceptingTraders": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.Srf.ProductPartyVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "partyTypeId": {
            "type": "integer",
            "format": "int32"
          },
          "isLowRiskJurisdiction": {
            "type": "boolean",
            "nullable": true
          },
          "showOwnershipAndManagementStructure": {
            "type": "boolean"
          },
          "entityStatusId": {
            "$ref": "#/components/schemas/g2fp.Models.Srf.ProductDueDiligencePartyStatus"
          },
          "documentTypesToProvide": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Documents.StoredDocumentType+Ids"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.Srf.SrfUserSpecificStaticVm": {
        "type": "object",
        "properties": {
          "issuers": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.IssuerVm"
            },
            "nullable": true
          },
          "company": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.CompanyVm"
          },
          "g24bIssuers": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.ProductHub.IssuerVm"
            },
            "nullable": true
          },
          "isinCountryOptions": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.ViewModels.CountryVm"
            },
            "nullable": true
          },
          "platformAgentAdminFeeCcy": {
            "type": "number",
            "format": "double"
          },
          "isCellularUser": {
            "type": "boolean"
          },
          "isLimitedUser": {
            "type": "boolean"
          },
          "requestorPartyId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "structuringTermsDocument": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.Srf.TermsDocumentReferenceVm"
          },
          "productIssuanceTermsDocument": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.Srf.TermsDocumentReferenceVm"
          },
          "productManagerTermsDocument": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.Srf.TermsDocumentReferenceVm"
          },
          "distributionAgentTermsDocument": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.Srf.TermsDocumentReferenceVm"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.Srf.StructuringRequestFormVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "version": {
            "type": "integer",
            "format": "int32"
          },
          "isLite": {
            "type": "boolean"
          },
          "isArchived": {
            "type": "boolean"
          },
          "isDeleted": {
            "type": "boolean"
          },
          "steps": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/g2fp.Models.G2DbModels.StructuringRequestStep"
            },
            "nullable": true
          },
          "currentStepId": {
            "type": "integer",
            "format": "int32"
          },
          "createDateTimeUtc": {
            "type": "string",
            "format": "date-time"
          },
          "modifiedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "submittedDateTimeUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "progress": {
            "type": "integer",
            "format": "int32"
          },
          "statusId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "status": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.SrfStatus"
          },
          "productDueDiligenceId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "productDueDiligence": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.Srf.ProductDueDiligenceVm"
          },
          "rowVersion": {
            "type": "integer",
            "format": "int32"
          },
          "productType": {
            "type": "string",
            "nullable": true
          },
          "product": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Product"
          },
          "displayName": {
            "type": "string",
            "nullable": true
          },
          "initiatedByUser": {
            "$ref": "#/components/schemas/g2fp.Models.Account.UserDto"
          },
          "modifiedUser": {
            "$ref": "#/components/schemas/g2fp.Models.Account.UserDto"
          },
          "submittedByUser": {
            "$ref": "#/components/schemas/g2fp.Models.Account.UserDto"
          },
          "rejectedDocumentsCount": {
            "type": "integer",
            "format": "int32"
          },
          "productState": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.ProductState"
          },
          "activateDraftTermsheetGeneration": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.Srf.TermsDocumentReferenceVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.Srf.TraderVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.TelekursVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "workflowId": {
            "type": "string",
            "nullable": true
          },
          "stepId": {
            "type": "integer",
            "format": "int32"
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "subscribeAsOf": {
            "type": "string",
            "format": "date-time"
          },
          "ispConfirmDistributionAgreement": {
            "type": "boolean"
          },
          "distributionTo50Inv": {
            "type": "boolean"
          },
          "workflow": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.WorkflowCoreShadowDto.WorkflowInstanceDto"
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isRejected": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.TerminateWorkflowRequestDto": {
        "type": "object",
        "properties": {
          "workflowId": {
            "type": "string",
            "nullable": true
          },
          "terminationReason": {
            "type": "string",
            "nullable": true
          },
          "user": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.UserNotificationVm": {
        "type": "object",
        "properties": {
          "message": {
            "type": "string",
            "nullable": true
          },
          "type": {
            "$ref": "#/components/schemas/g2fp.Models.ViewModels.AppWeb.FrontEndComponent"
          },
          "data": {
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.AppWeb.WorkflowVm": {
        "type": "object",
        "properties": {
          "workflow": {
            "$ref": "#/components/schemas/g2fp.Models.Flow.WorkflowCoreShadowDto.WorkflowInstanceDto"
          },
          "canProcessWorkflow": {
            "type": "boolean"
          },
          "allowedEvents": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "hiddenAttachments": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "hasVestr": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Models.ViewModels.CountryVm": {
        "type": "object",
        "properties": {
          "id": {
            "type": "integer",
            "format": "int32"
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "nativeName": {
            "type": "string",
            "nullable": true
          },
          "isoAlpha2Code": {
            "type": "string",
            "nullable": true
          },
          "isoAlpha3Code": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Modules.ProductStructuring.Legacy.Models.UpsertStep": {
        "type": "object",
        "properties": {
          "step": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.StructuringRequestStep"
          },
          "progress": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Workflow.Contracts.NoTouchIssuance.Version2.NoTouchIssuanceApprovalEventDto": {
        "type": "object",
        "properties": {
          "assignedUserGroupName": {
            "type": "string",
            "nullable": true
          },
          "assignedUserGroupDisplay": {
            "type": "string",
            "nullable": true
          },
          "isApproved": {
            "type": "boolean"
          },
          "assignedDateUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "completedBy": {
            "type": "string",
            "nullable": true
          },
          "completedOn": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "eventId": {
            "type": "string",
            "nullable": true
          },
          "eventDescription": {
            "type": "string",
            "nullable": true
          },
          "comment": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Workflow.Contracts.NoTouchIssuance.Version2.NoTouchIssuanceCancellationEventDto": {
        "type": "object",
        "properties": {
          "assignedDateUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "completedBy": {
            "type": "string",
            "nullable": true
          },
          "completedOn": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "eventId": {
            "type": "string",
            "nullable": true
          },
          "eventDescription": {
            "type": "string",
            "nullable": true
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "initiatorEventKey": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Workflow.Contracts.PaymentInstruction.Version4.NDPTransferType": {
        "enum": [
          0,
          1,
          2,
          3
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowApprovalEventDto": {
        "type": "object",
        "properties": {
          "assignedDateUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "completedBy": {
            "type": "string",
            "nullable": true
          },
          "completedOn": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "eventId": {
            "type": "string",
            "nullable": true
          },
          "eventDescription": {
            "type": "string",
            "nullable": true
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "assignedUserGroupName": {
            "type": "string",
            "nullable": true
          },
          "assignedUserGroupDisplay": {
            "type": "string",
            "nullable": true
          },
          "isApproved": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowApprovalWithFilesEventDto": {
        "type": "object",
        "properties": {
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "assignedUserGroupName": {
            "type": "string",
            "nullable": true
          },
          "assignedUserGroupDisplay": {
            "type": "string",
            "nullable": true
          },
          "isApproved": {
            "type": "boolean"
          },
          "assignedDateUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "completedBy": {
            "type": "string",
            "nullable": true
          },
          "completedOn": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "eventId": {
            "type": "string",
            "nullable": true
          },
          "eventDescription": {
            "type": "string",
            "nullable": true
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "areInstructionsSentDirectly": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowCancellationEventDto": {
        "type": "object",
        "properties": {
          "assignedDateUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "completedBy": {
            "type": "string",
            "nullable": true
          },
          "completedOn": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "eventId": {
            "type": "string",
            "nullable": true
          },
          "eventDescription": {
            "type": "string",
            "nullable": true
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "initiatorEventKey": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowV4ExecutionTypeEnum": {
        "enum": [
          1,
          2
        ],
        "type": "integer",
        "format": "int32"
      },
      "g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowV4InitiationStepData": {
        "type": "object",
        "properties": {
          "initiatorUserName": {
            "type": "string",
            "nullable": true
          },
          "isin": {
            "type": "string",
            "nullable": true
          },
          "currencyIso": {
            "type": "string",
            "nullable": true
          },
          "quarterlyFlowId": {
            "type": "string",
            "nullable": true
          },
          "physicalCopyAddress": {
            "type": "string",
            "nullable": true
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "assignAllToInitiator": {
            "type": "boolean"
          },
          "isPhysicalCopyNeeded": {
            "type": "boolean"
          },
          "paymentFlowConceptId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "fromAccountId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "toAccountId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "initiatorCompanyPartyId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "initiatorClientCompanyId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "invoiceId": {
            "type": "integer",
            "format": "int32",
            "nullable": true
          },
          "issuerId": {
            "type": "integer",
            "format": "int32"
          },
          "amount": {
            "type": "number",
            "format": "double"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "quarterDate": {
            "type": "string",
            "format": "date"
          },
          "paymentExecution": {
            "$ref": "#/components/schemas/g2fp.Workflow.Contracts.PaymentInstruction.Version4.PaymentFlowV4ExecutionTypeEnum"
          },
          "paymentFlowTypeId": {
            "$ref": "#/components/schemas/g2fp.Models.G2DbModels.Enums.PaymentFlowTypeEnum"
          },
          "ndpTransferType": {
            "$ref": "#/components/schemas/g2fp.Workflow.Contracts.PaymentInstruction.Version4.NDPTransferType"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceApprovalEventDto": {
        "type": "object",
        "properties": {
          "assignedUserGroupName": {
            "type": "string",
            "nullable": true
          },
          "assignedUserGroupDisplay": {
            "type": "string",
            "nullable": true
          },
          "assignedDateUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "completedBy": {
            "type": "string",
            "nullable": true
          },
          "completedOn": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "eventId": {
            "type": "string",
            "nullable": true
          },
          "eventDescription": {
            "type": "string",
            "nullable": true
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isApproved": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceApprovalWithFilesEventDto": {
        "type": "object",
        "properties": {
          "assignedUserGroupName": {
            "type": "string",
            "nullable": true
          },
          "assignedUserGroupDisplay": {
            "type": "string",
            "nullable": true
          },
          "assignedDateUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "completedBy": {
            "type": "string",
            "nullable": true
          },
          "completedOn": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "eventId": {
            "type": "string",
            "nullable": true
          },
          "eventDescription": {
            "type": "string",
            "nullable": true
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isApproved": {
            "type": "boolean"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceFlowCancellationEventDto": {
        "type": "object",
        "properties": {
          "assignedDateUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "completedBy": {
            "type": "string",
            "nullable": true
          },
          "completedOn": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "eventId": {
            "type": "string",
            "nullable": true
          },
          "eventDescription": {
            "type": "string",
            "nullable": true
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "initiatorEventKey": {
            "type": "string",
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceFlowV6InitiationStepData": {
        "type": "object",
        "properties": {
          "isin": {
            "type": "string",
            "nullable": true
          },
          "initiatorUserName": {
            "type": "string",
            "nullable": true
          },
          "assignAllToInitiator": {
            "type": "boolean"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          }
        },
        "additionalProperties": false
      },
      "g2fp.Workflow.Contracts.ProductIssuance.Version6.ProductIssuanceG2ApprovalEventDto": {
        "type": "object",
        "properties": {
          "assignedUserGroupName": {
            "type": "string",
            "nullable": true
          },
          "assignedUserGroupDisplay": {
            "type": "string",
            "nullable": true
          },
          "assignedDateUtc": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "completedBy": {
            "type": "string",
            "nullable": true
          },
          "completedOn": {
            "type": "string",
            "format": "date-time",
            "nullable": true
          },
          "eventName": {
            "type": "string",
            "nullable": true
          },
          "eventKey": {
            "type": "string",
            "nullable": true
          },
          "eventId": {
            "type": "string",
            "nullable": true
          },
          "eventDescription": {
            "type": "string",
            "nullable": true
          },
          "comment": {
            "type": "string",
            "nullable": true
          },
          "isApproved": {
            "type": "boolean"
          },
          "attachedFileGuids": {
            "type": "array",
            "items": {
              "type": "string"
            },
            "nullable": true
          },
          "areFinalTermsUploaded": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      }
    },
    "securitySchemes": {
      "Antiforgery": {
        "type": "apiKey",
        "description": "You can use this to add antiforgery token to the header. You can get the token from the accout/getcsrftoken endpoint.",
        "name": "RequestVerificationToken",
        "in": "header"
      }
    }
  },
  "security": [
    {
      "Antiforgery": [ ]
    }
  ],
  "tags": [
    {
      "name": "Account"
    },
    {
      "name": "Antiforgery"
    },
    {
      "name": "Communication"
    },
    {
      "name": "Company"
    },
    {
      "name": "Dashboard"
    },
    {
      "name": "Debug"
    },
    {
      "name": "FeatureFlag"
    },
    {
      "name": "Flow"
    },
    {
      "name": "InCorePayment"
    },
    {
      "name": "Introspection"
    },
    {
      "name": "IssuerKYC"
    },
    {
      "name": "IssuerPublic"
    },
    {
      "name": "NoTouchIssuance"
    },
    {
      "name": "PaymentInstruction"
    },
    {
      "name": "Pdd"
    },
    {
      "name": "PlatformUserTerms"
    },
    {
      "name": "ProductHistory"
    },
    {
      "name": "ProductHub"
    },
    {
      "name": "ProductIssuance"
    },
    {
      "name": "QuarterliesApproval"
    },
    {
      "name": "SalesDocument"
    },
    {
      "name": "Startup"
    },
    {
      "name": "StructuringRequest"
    },
    {
      "name": "Test"
    },
    {
      "name": "User"
    },
    {
      "name": "Webhook"
    },
    {
      "name": "Workflow"
    }
  ]
}